import React, { useEffect, useState } from 'react'
import SearchBar from '../Search/SearchBar'
import '../../style/Layout.scss'
// import clinicalTrialsData from '/clinicaltrials.json' // NOT WORKING YET // TODO console.log this to test
import { ElevationScroll } from '../../style/layout-style'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { ReactComponent as SpotIcon } from '../../assets/images/spot.svg'
import { ReactComponent as GlobalIcon } from '../../assets/images/earth-3.svg'
import ReplyIcon from '@mui/icons-material/Reply'
import ListItemText from '@mui/material/ListItemText'
import { DialogActions, DialogContent, DialogTitle } from '../Dashboard/dashboard-style'
import SvgIcon from '@mui/material/SvgIcon'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { ReactComponent as HomeIcon } from '../../assets/images/Home_Icon.svg'
import { ReactComponent as OverviewIcon } from '../../assets/images/layout-dashboard-1.svg'
import { ReactComponent as ProductIcon } from '../../assets/images/product-summary.svg'
import { ReactComponent as MetricsIcon } from '../../assets/images/science-graph.svg'
import { ReactComponent as LightningIcon } from '../../assets/images/actions_lightning.svg'
import { ReactComponent as ResourcesIcon } from '../../assets/images/action-doc.svg'
import { ReactComponent as StrategicIcon } from '../../assets/images/Strategic_Icon.svg'
import { ReactComponent as GapIcon } from '../../assets/images/Gap_Icon.svg'
import { ReactComponent as EvidenceIcon } from '../../assets/images/Ev_Icon.svg'
import { ReactComponent as ActivityIcon } from '../../assets/images/Act_Icon.svg'
import { ReactComponent as VMIcon } from '../../assets/images/VM_Icon.svg'
import { ReactComponent as SnapshotIcon } from '../../assets/images/Camera_Icon.svg'
import { ReactComponent as ViewSnapshotIcon } from '../../assets/images/camera-double.svg'
import { ReactComponent as DownloadIcon } from '../../assets/images/Download_Icon.svg'
import { ReactComponent as LogoutIcon } from '../../assets/images/logout-1.svg'
import { ReactComponent as SettingsIcon } from '../../assets/images/settings-gear.svg'
import { ReactComponent as InfoIcon } from '../../assets/images/info-circle.svg'
import { ReactComponent as MapIcon } from '../../assets/images/maps-mark.svg'
import AtlasIcon from '../../shared/icons/AtlasIcon'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import { withRouter, useHistory, useLocation } from 'react-router-dom'
import store from '../../redux/store'
import { connect, useDispatch, useSelector } from 'react-redux'
import callSecureAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import _ from 'underscore'
import pptxgen from 'pptxgenjs'
import {
    arysanaLogoPPT,
    atlasRoadMapValueLogoBlack,
    gradientLine,
    litePowerpointTitleBackground,
    whiteAtlasLogo,
} from '../../assets/encodedImages'
import { isStrategySelected, quarterOfYear } from '../../utilities/helpers'
import CircularProgress from '@mui/material/CircularProgress'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { useAuth0 } from '../../contexts/auth0-context'
import Dialog from '@mui/material/Dialog'
import DialogContentText from '@mui/material/DialogContentText'
import { FormControlLabel, ListItemAvatar, ListItemSecondaryAction } from '@mui/material/'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import ReactCountryFlag from 'react-country-flag'
import { countryLookup } from '../../utilities/countryLookup'
import GetAppIcon from '@mui/icons-material/GetApp'
import DescriptionIcon from '@mui/icons-material/Description'
import { WhiteOutlineCheckbox } from '../Support/CustomElements'
import { Link as RouterLink } from 'react-router-dom'
import Link from '@mui/material/Link'
import FormControl from '@mui/material/FormControl'
import { Menu, MenuList, MenuItem, Select } from '@mui/material/'
import {
    reduxLogout,
    setFreeTrialStatus,
    setIsPicoEnabled,
    setIsMaiaEnabled,
    setSelectedMarket,
    setStrategy,
    setSettings,
} from '../../redux/actions'
import Grid from '@mui/material/Grid'
import callAPI from '../../API/callSecureAPI'
import { useTheme } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'
import List from '@mui/material/List'
import Avatar from '@mui/material/Avatar'
import MenuIcon from '@mui/icons-material/Menu'
import AppBar from '@mui/material/AppBar'
import Drawer from '@mui/material/Drawer'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import Slide from '@mui/material/Slide'
import Fade from '@mui/material/Fade'
import { ReactComponent as SearchIcon } from '../../assets/images/search-icon.svg'
import { ClickAwayListener, Popper } from '@mui/material'
import DashBg from '../../assets/images/prodov-2EDIT2.png'
import { makeStyles } from '@mui/styles'
import { FIGMA_DARK_COLORS } from '../../style/colors'
import { NavbarInfoBanner } from './NavbarInfoBanner'
import { PulsingCircle } from '../../shared/components/PulsingCircle'
import RoadmapSelector from '../../shared/components/RoadmapSelector/RoadmapSelector'
import { useExitSnapshotMode } from '../../shared/hooks/useExitSnapshotMode'
import ModuleSelector from '../../shared/components/ModuleSelector/ModuleSelector'
import useValueNarrativeDisplayName from '../../shared/hooks/useDisplayNames/variants/useValueNarrativeDisplayName'
import useValueMessageDisplayName from '../../shared/hooks/useDisplayNames/variants/useValueMessageDisplayName'
import useEventLogger from '../../shared/hooks/useEventLogger'
import useActivityStatuses from '../../shared/hooks/useActivityStatuses'
import { useGetSettingsQuery } from '../../shared/queries/useGetSettingsQuery'
import { useHasInProgressSnapshot } from '../../shared/queries/useGetSnapshotsQuery'
import useStrategicImperativeDisplayName from '../../shared/hooks/useDisplayNames/variants/useStrategicImperativeDisplayName'
import useValuePropositionDisplayName from '../../shared/hooks/useDisplayNames/variants/useValuePropositionDisplayName'
import OrganizationSelector from '../OrganizationSelector/OrganizationSelector'
import SnapshotModal from '../../shared/components/Snapshots/components/SnapshotModal'
import { useBooleanState } from '../../shared/hooks/useBooleanState'

// Imports for pptExports folder
import {
    getOrderedCategories,
    getMessageStatus,
    getMessagePriority,
    getEvidenceTypeLabel,
    getCategoryName,
    getActivityDisplayLabel,
    getActivityTitle,
    buildActivityNumberingMap,
    getActivityNumber,
    buildActivityNotesText,
    toSuperscriptNumber,
    getOrderedValueMessages,
    resolveActivityTimelineDates,
    appendAtlasBrandingToNotes,
} from './pptExports/pptExportHelpers'
import { buildValueMessageSupportMetricData, addValueMessageSupportMetricsSlide } from './pptExports/pptMetricHelpers'
import {
    addTppDifferentiationBox,
    buildTppActivityMapFromElementSupportResponses,
    buildTppActivityRuns,
    buildTppElementRuns,
    buildTppFulfillmentRowsForCategory,
    cleanTppText,
    estimateTppFulfillmentRowHeight,
    getTppTotalHeight,
    normalizeLiveTppForRows,
    transformLiveTppDataForExport,
    buildTppFulfillmentMetricData,
    addTppFulfillmentMetricsSlide,
    enrichTppDataForExecSummary,
    normalizeTppForStandardExport,
    cleanTppOneLine,
    getTppTotalRowHeight,
    countTppCharsForRuns,
    tppGroupHasAnyBullets,
    buildTppBulletRuns,
    estimateTppHeightFromRuns,
    flushTppTable,
    makeTppHeaderRow,
} from './pptExports/pptTPPhelpers'
import { downloadJsonFile, safeFilename } from './pptExports/atlasDownloadHelpers'
import { createValueMessageFulfillmentGanttSlide, createTppFulfillmentGanttSlide } from './pptExports/pptGanttHelpers'
import {
    fetchActivitiesForExport,
    fetchDisseminationPrioritizationExportData,
    buildValueMessageFulfillmentGanttGroups,
    buildTppFulfillmentGanttGroups,
    buildValueMessageNameMap,
    buildKesByEvidenceId,
} from './pptExports/atlasExportDataFetchers'
import {
    exportActivitiesJson,
    exportTrppJson,
    exportValueNarrativesFullJson,
    exportEvidenceJson,
} from './pptExports/atlasJsonExportHelpers'
import {
    exportActivitiesTrackerToExcel,
    exportDisseminationPrioritizationWorkbook,
} from './pptExports/atlasExcelExportHelpers'
function mapDispatchToProps(dispatch) {
    return {
        setLocalMarket: (market) => dispatch(setSelectedMarket(market)),
        userLogout: () => dispatch(reduxLogout()),
        setStrategy: (strat) => dispatch(setStrategy(strat)),
    }
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

export const useMenuListStyles = makeStyles(() => ({
    root: {
        padding: '0 !important',
    },
    list: {
        padding: '0 !important',
    },
    paper: {
        borderRadius: '16px !important',
        marginTop: '8px !important',
    },
}))

const DRAWER_WIDTH = 320

function ConnectedLayout(props) {
    const dispatch = useDispatch()

    const [strategy, setStrategy] = useState(_.get(store.getState(), 'strategy', null))
    const [organization, setOrganization] = useState({})
    const [showStrategy, setShowStrategy] = useState(false)
    const [forceRefresh, setForceRefresh] = useState(false)
    const [menuItems, setMenuItems] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [errorModalText, setErrorModalText] = useState('')
    const [openPptxCustomizationModal, setOpenPptxCustomizationModal] = useState(false)
    const [includesValueProp, setIncludesValueProp] = useState(false)
    const [vmExporting, setVMExporting] = useState(false)
    const [vmAndEvidenceExporting, setVMAndEvidenceExporting] = useState(false)
    const [vmAndActExporting, setVMAndActExporting] = useState(false)
    const [siAndActExporting, setSIAndActExporting] = useState(false)
    const [evidenceExporting, setEvidenceExporting] = useState(false)
    const [EGPExporting, setEGPExporting] = useState(false)
    const [actExporting, setActExporting] = useState(false)
    const [isValueNarrativeExporting, setIsValueNarrativeExporting] = useState(false)
    const [isKeyEvidenceExporting, setIsKeyEvidenceExporting] = useState(false)
    // const [isTPPExporting, setIsTPPExporting] = useState(false) // TODO <- Old school TPP approach Eventually remove
    const [isTrPPExporting, setIsTrPPExporting] = useState(false)
    const [vmsStatusGapsExporting, setVMsStatusGapsExporting] = useState(false)
    const [vmsGapsExporting, setVMsGapsExporting] = useState(false)
    const [isAspirationalExporting, setIsAspirationalExporting] = useState(false)
    const [isFulfillmentVMExporting, setIsFulfillmentVMExporting] = useState(false)
    const [isFulfillmentTPPExporting, setIsFulfillmentTPPExporting] = useState(false)
    const [activitiesExcelExporting, setActivitiesExcelExporting] = useState(false)
    const [disseminationPrioritizationExcelExporting, setDisseminationPrioritizationExcelExporting] = useState(false)
    const [activitiesJsonExporting, setActivitiesJsonExporting] = useState(false)
    const [trppJsonExporting, setTrppJsonExporting] = useState(false)
    const [valueNarrativesJsonExporting, setValueNarrativesJsonExporting] = useState(false)
    const [evidenceJsonExporting, setEvidenceJsonExporting] = useState(false)

    const history = useHistory()
    const location = useLocation()
    const theme = useTheme()
    const [open, setOpen] = useState(false)
    const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null)
    const [popperAnchorEl, setPopperAnchorEl] = useState(null)
    const [popperOpen, setPopperOpen] = useState(false)
    const { isLoading, user, loginWithRedirect, logout, getTokenSilently, isAuthenticated } = useAuth0()

    const [isLoaded, setIsLoaded] = useState(false)

    const isPicoPage = location.pathname.startsWith('/pico')
    const [categorizedVMs, setCategorizedVMs] = useState({})
    const [categories, setCategories] = useState([])
    const [categoryMap, setCategoryMap] = useState({})

    const currentUser = useSelector((state) => state.userRecord)

    const { handleExitSnapshotMode } = useExitSnapshotMode()
    const { logEvent, ACTIONS } = useEventLogger()

    const valueNarrativeDisplayName = useValueNarrativeDisplayName()

    const { activityStatusDetails, getActivityStatusDetails } = useActivityStatuses()
    const activityStatuses = activityStatusDetails.map((d) => d.id)

    const activityStatusStylesBase = Object.fromEntries(
        activityStatusDetails.map((d) => {
            const hex = (d.color || '').replace('#', '')
            return [d.id, { fill: hex, line: hex, label: d.name }]
        })
    )

    const activityStatusOrderMap = Object.fromEntries(
        activityStatusDetails.map((d) => [d.id, d.order ?? Number.MAX_SAFE_INTEGER])
    )

    if (!activityStatusStylesBase['Uncategorized']) {
        activityStatusStylesBase['Uncategorized'] = { fill: '999999', line: '999999', label: 'Uncategorized' }
    }

    const idByLowerId = new Map(activityStatusDetails.map((d) => [d.id.toLowerCase(), d.id]))
    const idByLowerName = new Map(activityStatusDetails.map((d) => [d.name.toLowerCase(), d.id]))
    const toStatusId = (v) => {
        if (v == null) return null
        const k = String(v).trim().toLowerCase()
        return idByLowerId.get(k) || idByLowerName.get(k) || null
    }

    function getStatusLabel(activity) {
        const raw = activity?.status ?? activity?.activityStatus ?? ''
        return toStatusId(raw) || 'Uncategorized'
    }

    const getSettingsQuery = useGetSettingsQuery()

    const colors = {
        purple: { fill: 'efeafd', line: '5C34E4' },
        blue: { fill: 'ecf5ff', line: '389BFF' },
        magenta: { fill: 'fdebf6', line: 'E4349B' },
        green: { fill: 'ebf9f5', line: '07CC9E' },
        orange: { fill: 'fff5eb', line: 'FF9C2B' },
        salmon: { fill: 'fff0f1', line: 'FF6B70' },
        red: { fill: 'fae8eb', line: 'C30B31' },
        pink: { fill: 'fdf2ff', line: 'E37FFF' },
        yellow: { fill: 'fffbee', line: 'FFD748' },
        teal: { fill: 'eef8ff', line: '55B8F9' },
        neon: { fill: 'f3fef3', line: '80F785' },
        lavender: { fill: 'f7f2ff', line: 'B27FFF' },
        black: { fill: 'e5e5e5', line: '000000' },
        grey: { fill: 'fafafa', line: 'CCCCCC' },
        sanofiActivityPlanned: { fill: '23004C', line: '23004C' },
        sanofiActivityInitiated: { fill: '7A00AE', line: '7A00AE' },
        sanofiActivityOnHold: { fill: '007FAD', line: '007FAD' },
        sanofiActivityCancelled: { fill: 'DA3A16', line: 'DA3A16' },
        sanofiActivityCompleted: { fill: '268500', line: '268500' },
    }

    // Tyler moving subpopulation Styles higher to be used everywhere. Eventually replace this with however colors are used in ATLAS.
    // Illia colors (line is regular colors while fill is a helper function with half transparency)
    const subpopulationStylesList = [
        colors.purple,
        colors.blue,
        colors.magenta,
        colors.green,
        colors.orange,
        colors.salmon,
        colors.red,
        colors.pink,
        colors.yellow,
        colors.teal,
        colors.neon,
        colors.lavender,
    ]

    let pink = colors.magenta.line,
        white = 'FFFFFF',
        grey = 'EBEBEB',
        confidentialityFooterGrey = '918f8f',
        backgroundColor = 'FFFFFF',
        textColor = FIGMA_DARK_COLORS.grayscale.contentWrapper.replace('#', ''),
        blueHeaders = '0049EA',
        MAX_CHARS_PER_SLIDE = 1600
    // Should we add a headerColor for consistency
    // Should we add fontColor here so that it can be used by many

    let strat = useSelector((state) => state.strategy)
    const selectedMarket = useSelector((state) => state.selectedMarket)
    const selectedStrategyId = useSelector((state) => state.strategy?._id)
    const userReadonly = useSelector((state) => (state.userRecord ? !!state.userRecord.readonly : false))
    const isDarkMode = useSelector((state) => (state?.userRecord ? state?.userRecord?.isDarkMode : true))

    let storeSettings = useSelector((state) => state.settings)

    const valueMessageDisplayName = useValueMessageDisplayName()
    const strategicImperativeDisplayName = useStrategicImperativeDisplayName()
    const valuePropositionDisplayName = useValuePropositionDisplayName()

    const vmsDisplayName = valueMessageDisplayName.plural
    const vnsDisplayName = valueNarrativeDisplayName.plural

    const tppDisplayName = useSelector((state) =>
        state.settings && state.settings.displayNames ? state.settings.displayNames.tpp : ''
    )

    const activityDisplayName = useSelector((state) =>
        state.settings && state.settings.displayNames ? state.settings.displayNames.activity : ''
    )
    const activitiesDisplayName = useSelector((state) =>
        state.settings && state.settings.displayNames ? state.settings.displayNames.activities : ''
    )
    const evidenceDisplayName = useSelector((state) =>
        state.settings && state.settings.displayNames ? state.settings.displayNames.evidence : ''
    )
    const strategicDisplayName = strategicImperativeDisplayName.plural

    const valueAndAccessDisplayName = useSelector((state) =>
        state.settings && state.settings.displayNames ? state.settings.displayNames.valueAndAccess : ''
    )

    useEffect(() => {
        if (!store.getState() || !store.getState().strategy) {
            return
        }
        setStrategy(store.getState().strategy)

        if (isAuthenticated) {
            getOrg()
            getSettings()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps

        if (strat?.isActive === false && !isLoading) {
            history.push('/roadmaps')
        }
    }, [strat])

    async function getSettings() {
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        let incomingSettings = await callAPI(
            endpoints.getSettingsByOrganizationId.url + store.getState().strategy.organizationId,
            endpoints.getSettingsByOrganizationId.method,
            token
        )
        if (incomingSettings.success) {
            setSettings(incomingSettings.data)
        }
    }

    const handleViewCurrentStrategy = async () => {
        await handleExitSnapshotMode()
        setForceRefresh(true)
    }

    async function beginCustomizingPptx() {
        if (!isStrategySelected()) {
            cannotExportPPTX('No Strategy selected. Please select a Strategy and try again.')
            return
        }

        setOpenPptxCustomizationModal(true)
    }

    function defineContentSlide(pptx, org) {
        let productFor = `${store.getState().strategy.product} for ` // I think we have an extra space here that isn't needed.
        let indication = store.getState().strategy.indication

        pptx.defineSlideMaster({
            title: 'CONTENT_SLIDE',
            bkgd: backgroundColor,
            color: textColor,
            objects: [
                { image: { data: org.lightModeImage, x: 0.15, y: 5.28, w: 0.96, h: 0.26 } }, // Swapped the org images with the Arysana logo
                // { image: { data: arysanaLogoPPT, x: 1.25, y: 5.28, w: 0.96, h: 0.26 } }, // TODO Add to an if statement to include if not Otsuka
                {
                    text: {
                        text: org.confidentialityFooter,
                        options: {
                            fontSize: 6,
                            color: confidentialityFooterGrey,
                            align: 'center',
                            fontFace: 'Arial',
                            breakLine: true,
                            y: 5.33,
                            x: '1.75',
                            w: '65%',
                        },
                    },
                },

                {
                    text: {
                        text: [
                            {
                                text: productFor,
                            },
                            {
                                text: indication,
                                options: {
                                    italic: true,
                                },
                            },
                        ],
                        options: {
                            fontSize: 16,
                            color: textColor,
                            bold: true,
                            fontFace: 'Arial',
                            y: 0.15,
                            x: 0.2, // Shifted this slightly over to not take up so much space.
                            w: '90%',
                        },
                    },
                },
            ],

            slideNumber: { color: textColor, x: '95%', y: '92.96%', w: 0.5 }, // TKR Slide number location shifted right, converted to relative positions, and trimmed down the width
        })
    }

    function defineTrPPSlide(pptx, org) {
        // Creating a new TrPP focused slide template to create more space
        let product = store.getState().strategy.product.trim() // I think we have an extra space here that isn't needed.
        let indicationFor = `for ${store.getState().strategy.indication.trim()}` // I think we have an extra space here that isn't needed.

        pptx.defineSlideMaster({
            title: 'TrPP_SLIDE',
            bkgd: backgroundColor,
            color: textColor,
            objects: [
                { image: { data: org.lightModeImage, x: 0.15, y: 5.28, w: 0.96, h: 0.26 } }, // Swapped the org images with the Arysana logo
                // { image: { data: arysanaLogoPPT, x: 1.25, y: 5.28, w: 0.96, h: 0.26 } },
                {
                    text: {
                        text: org.confidentialityFooter,
                        options: {
                            fontSize: 6,
                            color: confidentialityFooterGrey,
                            align: 'center',
                            fontFace: 'Arial',
                            breakLine: true,
                            y: 5.33,
                            x: '1.75',
                            w: '65%',
                        },
                    },
                },

                {
                    text: {
                        text: [
                            {
                                text: product,
                            },
                            {
                                text: '\n     ' + indicationFor, // Moving the indication to a new line with a slight indent
                                options: {
                                    italic: true,
                                    fontSize: 14, // Font for the indication to be slightly smaller
                                },
                            },
                        ],
                        options: {
                            fontSize: 16,
                            color: textColor,
                            bold: true,
                            fontFace: 'Arial',
                            y: 0.1,
                            x: 0.1,
                            w: '40%',
                            h: 0.5,
                        },
                    },
                },
            ],

            slideNumber: { color: textColor, x: '95%', y: '92.96%', w: 0.5 }, // TKR Slide number location shifted right, converted to relative positions, and trimmed down the width
        })
    }

    function defineTitleSlide(pptx, org, reportType) {
        // Adding reportType to the Title Slide
        let productFor = `${store.getState().strategy.product} for ` // I think we have an extra space here that isn't needed.
        let indication = store.getState().strategy.indication

        const formattedDate = new Intl.DateTimeFormat('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        }).format(new Date())

        // -- Controls for logo size and location

        const slideWidth = 10.0
        const slideHeight = 5.625

        const logoY = 0.15 // Convert to percentages based on the slide sizing
        const logoH = 0.38
        const orgLogoX = 0.22
        const orgLogoW = 1.45

        const arysanaLogoX = orgLogoX + orgLogoW + 0.18
        const arysanaLogoW = 1.45 // TODO consider adding a If subscription then remove ArysanaLogo

        const reportTypeY = 2.4
        const dateY = 2.62

        pptx.defineSlideMaster({
            title: 'MASTER_SLIDE',
            bkgd: backgroundColor,
            color: white,
            objects: [
                // { image: { data: litePowerpointTitleBackground, x: 0, y: 0, w: '100%', h: '100%' } },
                { image: { data: org.lightModeImage, x: orgLogoX, y: logoY, w: orgLogoW, h: logoH } }, // Based on constants
                // { image: { data: arysanaLogoPPT, x: arysanaLogoX, y: logoY, w: arysanaLogoW, h: logoH } },
                { image: { data: gradientLine, x: '5%', y: '39.82%', w: '90%', h: '1.5%' } }, // X: 0.62 -> X: '6.22%' and Y: 2.24 -> '39.82%'

                // Title
                {
                    text: {
                        text: [
                            {
                                text: productFor,
                            },
                            {
                                text: indication,
                                options: { italic: true },
                            },
                        ],
                        options: {
                            fontSize: 24,
                            color: textColor,
                            bold: true,
                            fontFace: 'Arial',
                            y: 1.76,
                            x: '5%',
                            w: '90%',
                        },
                    },
                },

                // Adding the Report Type to each slide
                {
                    text: {
                        text: reportType,
                        options: {
                            fontSize: 12,
                            color: textColor,
                            fontFace: 'Arial',
                            bold: 'true',
                            y: reportTypeY, // just below the gradient line
                            x: '5%',
                            w: '80%',
                        },
                    },
                },

                // Date (below report type)
                {
                    text: {
                        text: formattedDate,
                        options: {
                            fontSize: 10,
                            color: textColor,
                            fontFace: 'Arial',
                            bold: 'true',
                            y: dateY,
                            x: 0.5,
                            w: '90%',
                        },
                    },
                },

                // Confidentiality Footer
                {
                    text: {
                        text: org.confidentialityFooter,
                        options: {
                            fontSize: 8,
                            color: confidentialityFooterGrey,
                            align: 'center',
                            fontFace: 'Arial',
                            breakLine: true,
                            y: 5.25,
                            x: '1.75',
                            w: '65%',
                        },
                    },
                },
            ],
            // slideNumber: { color: confidentialityFooterGrey, x: 9.3, y: 5.23 },
        })
    }

    function definePlaceholderSlide(pptx, org) {
        pptx.defineSlideMaster({
            title: 'PLACEHOLDER_SLIDE',
            background: { color: 'FFFFFF' },
            objects: [
                // Header band
                {
                    rect: {
                        x: 0,
                        y: 0,
                        w: '100%',
                        h: 0.75,
                        fill: { color: 'F1F1F1' },
                    },
                },

                // Header title (swap text if you want it dynamic)
                {
                    text: {
                        text: 'Placeholer Slide',
                        options: {
                            x: 0.3,
                            y: 0,
                            w: 6,
                            h: 0.75,
                            fontFace: 'Arial',
                            fontSize: 18,
                            bold: true,
                            color: '000000',
                            valign: 'mid',
                        },
                    },
                },

                // Optional: Org name on the right side of header
                ...(org?.name
                    ? [
                          {
                              text: {
                                  text: org.name,
                                  options: {
                                      x: 6.5,
                                      y: 0,
                                      w: 6.5,
                                      h: 0.75,
                                      fontFace: 'Arial',
                                      fontSize: 12,
                                      color: '666666',
                                      align: 'right',
                                      valign: 'mid',
                                  },
                              },
                          },
                      ]
                    : []),

                // Named BODY placeholder
                {
                    placeholder: {
                        options: {
                            name: 'body',
                            type: 'body',
                            x: 0.6,
                            y: 1.5,
                            w: 12,
                            h: 5.25,
                        },
                        text: '(custom placeholder text!)',
                    },
                },
            ],

            // Slide numbers (bottom-left-ish)
            slideNumber: { x: 0.3, y: '95%' },
        })
    }

    async function exportPPTX(reportType, { activityStatusDetails, activityStatuses, userFilters = {} } = {}) {
        let settings = await getSettings()
        let date = new Date()
        let dateString = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
        let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        logEvent(ACTIONS.PPT_EXPORT, { reportType })

        let org = (
            await callSecureAPI(
                endpoints.getOrganizationById.url + store.getState().strategy.organizationId,
                endpoints.getOrganizationById.method,
                token
            )
        ).data

        let vms = await callSecureAPI(
            endpoints.getValueMessagesForTable.url + store.getState().strategy._id,
            endpoints.getValueMessagesForTable.method,
            token
        )

        const vmNameMap = {}

        if (vms?.success) {
            const list = Array.isArray(vms.data) ? vms.data : []

            for (const vm of list) {
                const id = vm?._id || vm?.id
                if (!id) continue

                vmNameMap[id] = vm?.name ?? ''
            }
        }

        if (reportType.includes(vmsDisplayName) && !vms.success) {
            cannotExportPPTX(
                `No ${vmsDisplayName}. Please add a new ${valueMessageDisplayName.singular} to your Strategy and try again.`
            )
            return
        }

        let tempCategorizedVMs = {}
        let tempCategoryMap = {}
        if (reportType.includes(vmsDisplayName)) {
            let incomingCategories = await callSecureAPI(
                endpoints.getNarrativeCategories.url + store.getState().strategy.organizationId,
                endpoints.getNarrativeCategories.method,
                token
            )

            if (incomingCategories.success) {
                for (let category of incomingCategories.data) {
                    tempCategoryMap[category._id] = category
                }
                setCategoryMap(tempCategoryMap)
                setCategories(incomingCategories.data)

                for (let category of incomingCategories.data) {
                    tempCategorizedVMs[String(category._id)] = []
                }

                for (let vm of vms.data) {
                    const categoryId = String(vm?.categoryId || '')

                    if (!tempCategorizedVMs[categoryId]) {
                        tempCategorizedVMs[categoryId] = []

                        if (!tempCategoryMap[categoryId]) {
                            tempCategoryMap[categoryId] = {
                                _id: categoryId,
                                name: 'Uncategorized',
                            }
                        }
                    }

                    tempCategorizedVMs[categoryId].push(vm)
                }

                for (let category of Object.keys(tempCategorizedVMs)) {
                    let arrCopy = Array.from(tempCategorizedVMs[category])
                    arrCopy.sort((a, b) => a.order - b.order)
                    tempCategorizedVMs[category] = arrCopy
                }
                setCategorizedVMs(tempCategorizedVMs)
            }
        }

        let evidence = await callSecureAPI(
            endpoints.getEvidenceForTable.url + store.getState().strategy._id,
            endpoints.getEvidenceForTable.method,
            token
        )

        const evidenceById = (evidence?.data || []).reduce((acc, ev) => {
            const id = ev?._id || ev?.id
            if (id) acc[id] = ev
            return acc
        }, {})

        if (!evidence?.success) {
            console.log('Failed to fetch evidence')
            return
        }

        let kesList = await callSecureAPI(
            endpoints.getKeyEvidenceStatementsByStrategy.url + store.getState().strategy._id,
            endpoints.getKeyEvidenceStatementsByStrategy.method,
            token
        )

        if (!kesList?.success) {
            console.log('Failed to fetch key evidence statements')
            return
        }

        // Build evidenceId -> [KES strings]
        const kesByEvidenceId = new Map()
        for (const kes of (kesList.data || []).filter((k) => k.status === 'approved')) {
            const text = (kes?.statement || '').toString().trim()
            const parent =
                typeof kes?.parentEvidence === 'object' && kes.parentEvidence
                    ? kes.parentEvidence._id || kes.parentEvidence.id
                    : kes?.parentEvidence

            if (!text || !parent) continue
            if (!kesByEvidenceId.has(parent)) kesByEvidenceId.set(parent, [])
            kesByEvidenceId.get(parent).push(text)
        }

        // (optional) dedupe per evidence
        for (const [id, arr] of kesByEvidenceId) kesByEvidenceId.set(id, [...new Set(arr)])

        // TODO Check if we should clean these up or if those first two are used anywhere else
        // Quick diagnostics
        const firstEv = evidence?.data?.[0]

        let uniqueSubpopulations = []
        let subpopulationStyles = {}

        let valueNarrativesData = await callSecureAPI(
            endpoints.getValueCompendiumValueNarratives.url + store.getState().strategy._id,
            endpoints.getValueCompendiumValueNarratives.method,
            token
        )

        let valueNarratives = []

        if (valueNarrativesData.success) {
            valueNarratives = valueNarrativesData.data
            ;({ uniqueSubpopulations, subpopulationStyles } = getSubpopulationStyles(valueNarratives))
        } else {
            console.log('⚠️ No Value Narratives found — proceeding without subpopulation styles')
            // uniqueSubpopulations = [];
            // subpopulationStyles = {};
        }

        console.log('Value Narratives export structure:', valueNarratives?.[0])

        // TODO Does this work if we've replaced with evidenceDisplayName
        if (reportType.includes('Evidence') && !evidence.success) {
            cannotExportPPTX(
                `No ${
                    (store.getState().settings?.displayNames?.evidence &&
                        store.getState().settings?.displayNames?.evidence) ||
                    'Evidence'
                }. Please add new evidence to your strategy and try again.`
            )
            return
        }

        let pptx = new pptxgen()

        // From the pptxgenjs website it appears like we can adjust the metadata to handle info data.
        pptx.author = 'ARYSANA'
        pptx.title = 'Atlas Export'
        pptx.subject = '' // optional
        pptx.company = 'ARYSANA'

        // Defining the exact layout
        pptx.layout = 'LAYOUT_16x9' // Default layout 'LAYOUT_16x9' is 16x9 which is our 10 x 5.625 inches

        // Otsuka layout (at least for the TrPP materials) width: 13.3333, height: 7.5 which would be the 'LAYOUT_WIDE'
        // Lantheus layout width: 13.3333, height: 7.5 which would be the 'LAYOUT_WIDE'
        // Sanofi layout width: 13.3333, height: 7.5 which would be the 'LAYOUT_WIDE'
        // TODO create a map for the organization and their desired layout size for easier conversion to alternative templates
        // TODO Adjust sizing either via percentages or a conversion function or template-type to size maps a mixed approach for things like fonts

        defineTitleSlide(pptx, org, reportType)
        defineContentSlide(pptx, org)
        defineTrPPSlide(pptx, org)
        // definePlaceholderSlide(pptx, org) //Testing the creation of a template slide with placeholders that aren't being used by anything

        if (store.getState().strategy.sourceId) {
            dateString += ' (Snapshot of ' + new Date(store.getState().strategy.createdAt).toLocaleDateString() + ')'
        }
        // TITLE SLIDE
        let slide = pptx.addSlide('MASTER_SLIDE')
        // For some reason the date string isn't adding when set on MASTER_SLIDE template, must manually add
        // I think this is fixed on the slide MASTER
        /* slide.addText(
            [
                {
                    text: dateString,
                    options: {
                        fontSize: 12, // increasing size and shifting up
                        color: textColor,
                        fontFace: 'Arial',
                        bold: true,
                        breakLine: true,
                    },
                },
            ],
            { y: 2.67, x: '5%', w: '20%', align: 'left' }
        ) */ //Snipping out the addition of the date string to the Title Slide to see if I can figure out why it wasn't being built on the template.

        // VALUE PROPOSITION SLIDE
        // ------------------------------------------------------------------------------------------------------
        // Make this optional when you add checkboxes
        if (includesValueProp) {
            addValuePropSlide(pptx)
        }

        // Should the below be declared inside the cases or kept outside?
        let currentCharCount = 0,
            tableRowsWithHeaders = [],
            headers = [],
            headersCopy = []

        switch (reportType) {
            // Remove mentions of "Value" in the exports (Narratives, Messages, etc.)
            case vmsDisplayName: // Front end name: vmsDisplayName
                for (let category of valueNarratives) {
                    for (let narrative of category.valueNarratives) {
                        const style = subpopulationStyles[narrative.subpopulation]

                        const MAX_CHARS_PER_SLIDE = 1800
                        const MAX_TABLE_HEIGHT = 3.1

                        function createSlideWithVMTable() {
                            const slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                            const LEGEND_TOP_Y = 0.08
                            const LEGEND_RIGHT_X = 9.85
                            const LEGEND_GAP = 0.05
                            const STATUS_LEGEND_WIDTH = 0.93

                            const populationLegendWidth = getPopulationLegendWidth(uniqueSubpopulations)

                            const populationLegendBox = addLegendToSlide(
                                slide,
                                uniqueSubpopulations,
                                subpopulationStyles,
                                {
                                    x: LEGEND_RIGHT_X - populationLegendWidth,
                                    y: LEGEND_TOP_Y,
                                }
                            )

                            addStatusLegend(slide, {
                                x: populationLegendBox.x - STATUS_LEGEND_WIDTH - LEGEND_GAP,
                                y: LEGEND_TOP_Y,
                            })

                            slide.addText([{ text: category.name, options: { bold: true, fontSize: 12 } }], {
                                x: 0.5,
                                y: 1,
                                w: 3,
                                h: 0.3,
                                align: 'left',
                            })

                            slide.addText(narrative.name, {
                                x: 0.5,
                                y: 1.33,
                                w: '90%',
                                h: 0.45,
                                fontSize: getFontSizeForText(narrative.name, 250, 10, 7),
                                align: 'left',
                                color: '000000',
                                fill: { color: style.fill },
                                line: { color: style.line },
                                breakLine: true,
                            })

                            return slide
                        }

                        let currentSlide = createSlideWithVMTable()
                        let currentCharCount = 0
                        let rowHeights = [0.25] // Header row height

                        const headers = [
                            [
                                {
                                    text: vmsDisplayName,
                                    options: {
                                        fill: backgroundColor,
                                        color: textColor,
                                        align: 'left',
                                        bold: true,
                                        border: [
                                            { color: 'FFFFFF' },
                                            { color: 'FFFFFF' },
                                            { color: style.line, pt: 2 },
                                            { color: 'FFFFFF' },
                                        ],
                                    },
                                },
                                {
                                    text: 'Status',
                                    options: {
                                        fill: backgroundColor,
                                        color: textColor,
                                        align: 'center',
                                        bold: true,
                                        border: [
                                            { color: 'FFFFFF' },
                                            { color: 'FFFFFF' },
                                            { color: style.line, pt: 2 },
                                            { color: 'FFFFFF' },
                                        ],
                                    },
                                },
                            ],
                        ]

                        let tableRows = [...headers]

                        const orderedValueMessages = getOrderedValueMessages(narrative.valueMessages)

                        for (let vmIdx = 0; vmIdx < orderedValueMessages.length; vmIdx++) {
                            const vm = orderedValueMessages[vmIdx]

                            const vmText = vm.name?.trim() || `(No ${vmsDisplayName.toLowerCase()})` // Switched Display name to vmsDisplayName for dynamic display
                            const fill = vmIdx % 2 === 1 ? 'F2F2F2' : 'FFFFFF'
                            const fontColor = '000000'
                            const rowCharCount = vmText.length
                            const rowHeight = 0.4

                            if (
                                currentCharCount + rowCharCount > MAX_CHARS_PER_SLIDE ||
                                getTotalRowHeight(rowHeights) + rowHeight > MAX_TABLE_HEIGHT
                            ) {
                                currentSlide.addTable(tableRows, {
                                    x: 0.5,
                                    y: 2.0,
                                    colW: [8.1, 0.9],
                                    rowH: rowHeights,
                                    fontSize: 9,
                                    border: { type: 'none' },
                                })

                                currentSlide = createSlideWithVMTable()
                                tableRows = [...headers]
                                rowHeights = [0.25]
                                currentCharCount = 0
                            }

                            tableRows.push([
                                { text: vmText, options: { fontSize: 9, fill, color: fontColor } },
                                {
                                    text: '◉',
                                    options: {
                                        fontSize: 14,
                                        fill,
                                        color:
                                            STATUS_COLORS?.[vm.status] ??
                                            STATUS_COLORS?.[(vm.status || '').replace(/^\w/, (c) => c.toUpperCase())] ??
                                            fontColor,
                                        align: 'center',
                                        valign: 'middle',
                                    },
                                },
                            ])
                            rowHeights.push(rowHeight)
                            currentCharCount += rowCharCount
                        }

                        if (tableRows.length === headers.length) {
                            tableRows.push([
                                {
                                    text: `(No ${vmsDisplayName.toLowerCase()}s)`,
                                    options: { fontSize: 9 },
                                },
                                {
                                    text: '',
                                    options: { fontSize: 9 },
                                },
                            ])
                            rowHeights.push(0.4)
                        }

                        currentSlide.addTable(tableRows, {
                            x: 0.5,
                            y: 2.0,
                            colW: [8.1, 0.9],
                            rowH: rowHeights,
                            fontSize: 9,
                            border: { type: 'none' },
                        })
                    }
                }

                break
            case vmsDisplayName + ' + ' + evidenceDisplayName: // Updated Evidence to evidenceDisplayName
                for (let category of Object.keys(tempCategorizedVMs)) {
                    // =============================
                    // Layout / pagination settings
                    // =============================
                    // Prefer height-based pagination (visual truth). Use weighted text as a secondary guardrail.
                    const MAX_TABLE_HEIGHT = 3.8
                    const BODY_FONT = 9

                    // Weighted text budget (VM counts "less" so VM text can be longer before pagination)
                    const MAX_TEXT_BUDGET = 2400
                    const VM_ONLY_MAX_TEXT_BUDGET = 6000 // VM-only slides should paginate mainly by height

                    const slideWidth = 10.0
                    const slideHeight = 5.625

                    const COL_W = [0.33 * slideWidth, 0.37 * slideWidth, 0.2 * slideWidth]

                    function getTotalRowHeight(rowHeights) {
                        return rowHeights.reduce((sum, h) => sum + h, 0)
                    }

                    // Estimate wrapped text height for pagination.
                    function estimateLines(text, colWIn, fontSizePt) {
                        const t = (text ?? '').toString()
                        if (!t.trim()) return 1

                        // rough heuristic: avg char width ~ 0.5*fontSize (pt), convert pt→in by /72
                        const avgCharWidthIn = (0.5 * fontSizePt) / 72
                        const charsPerLine = Math.max(10, Math.floor(colWIn / avgCharWidthIn))

                        const newlineLines = t.split('\n').length
                        const wrappedLines = Math.ceil(t.length / charsPerLine)
                        return Math.max(newlineLines, wrappedLines, 1)
                    }

                    function estimateRowHeightIn(rowTexts, colWsIn, fontSizePt) {
                        const lineHIn = (fontSizePt * 1.15) / 72
                        const padIn = 0.08

                        const lines = Math.max(
                            estimateLines(rowTexts[0], colWsIn[0], fontSizePt),
                            estimateLines(rowTexts[1], colWsIn[1], fontSizePt),
                            estimateLines(rowTexts[2], colWsIn[2], fontSizePt)
                        )

                        // Constrain estimated row height to supported visual limits.
                        return Math.min(1.2, Math.max(0.32, lines * lineHIn + padIn))
                    }

                    // Use weighted text length as a secondary pagination guardrail.
                    // Value Message text receives a lower weight because its column is wider
                    function weightedTextCost(vmText, evidenceText, citationText) {
                        const vm = (vmText ?? '').toString().length
                        const ev = (evidenceText ?? '').toString().length
                        const ct = (citationText ?? '').toString().length

                        const VM_WEIGHT = 0.55
                        const EV_WEIGHT = 0.9
                        const CT_WEIGHT = 1.0

                        return Math.round(vm * VM_WEIGHT + ev * EV_WEIGHT + ct * CT_WEIGHT)
                    }

                    function createSlideWithCategoryHeader(categoryName) {
                        const slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                        slide.addText(
                            [
                                {
                                    text: tempCategoryMap[categoryName].name,
                                    options: { bold: true, fontSize: 12 },
                                },
                            ],
                            {
                                x: 0.05 * slideWidth,
                                y: 0.09 * slideHeight,
                                w: 0.9 * slideWidth,
                                h: 0.05 * slideHeight,
                                align: 'left',
                            }
                        )
                        return slide
                    }

                    // Build the category rows from active narratives so Value Messages
                    // remain grouped and ordered under their parent narrative.
                    const categoryName = tempCategoryMap?.[category]?.name

                    const categoryData = valueNarratives.find((item) => item?.name === categoryName)

                    const activeNarratives = (categoryData?.valueNarratives || []).filter((narrative) => {
                        const archiveValue = narrative?.archived ?? narrative?.valueMessages?.[0]?.narrative?.archived

                        return archiveValue == null
                    })

                    const vmsInCat = activeNarratives.flatMap((narrative) =>
                        getOrderedValueMessages(narrative.valueMessages)
                    )

                    const hasAnyRealVm = vmsInCat.some((vm) => (vm?.name ?? '').trim().length > 0)

                    if (!hasAnyRealVm) continue

                    // =============================
                    // Lazy slide creation (prevents empty header-only slides)
                    // =============================
                    let currentSlide = null
                    function ensureSlide() {
                        if (!currentSlide) currentSlide = createSlideWithCategoryHeader(category)
                        return currentSlide
                    }

                    let currentBudget = 0 // weighted text budget consumed
                    let rowHeights = [0.25]

                    const headers = [
                        [
                            {
                                text: vmsDisplayName,
                                options: {
                                    fill: backgroundColor,
                                    color: textColor,
                                    align: 'left',
                                    bold: true,
                                    border: [
                                        { color: 'FFFFFF' },
                                        { color: 'FFFFFF' },
                                        { color: textColor, pt: 2 },
                                        { color: 'FFFFFF' },
                                    ],
                                },
                            },
                            {
                                text: evidenceDisplayName,
                                options: {
                                    fill: backgroundColor,
                                    color: textColor,
                                    align: 'left',
                                    bold: true,
                                    border: [
                                        { color: 'FFFFFF' },
                                        { color: 'FFFFFF' },
                                        { color: '000000', pt: 2 },
                                        { color: 'FFFFFF' },
                                    ],
                                },
                            },
                            {
                                text: 'Citation',
                                options: {
                                    fill: backgroundColor,
                                    color: textColor,
                                    align: 'left',
                                    bold: true,
                                    border: [
                                        { color: 'FFFFFF' },
                                        { color: 'FFFFFF' },
                                        { color: '000000', pt: 2 },
                                        { color: 'FFFFFF' },
                                    ],
                                },
                            },
                        ],
                    ]

                    let tableRows = [...headers]
                    let forceVmColumn = false

                    function flushTableToSlide() {
                        if (tableRows.length <= headers.length) return
                        ensureSlide().addTable(tableRows, {
                            x: 0.05 * slideWidth,
                            y: 0.133 * slideHeight,
                            colW: COL_W,
                            rowH: rowHeights,
                            fontSize: BODY_FONT,
                            border: { type: 'none' },
                        })
                    }

                    function startNewSlide() {
                        // Create a continuation slide and reset pagination state.
                        currentSlide = createSlideWithCategoryHeader(category)
                        tableRows = [...headers]
                        rowHeights = [0.25]
                        currentBudget = 0
                        forceVmColumn = true
                    }

                    // Helper: decide if we need a new slide BEFORE adding a row
                    function needsNewSlide(rowHeight, rowCost, isVmOnlyRow) {
                        const heightWouldOverflow = getTotalRowHeight(rowHeights) + rowHeight > MAX_TABLE_HEIGHT
                        if (heightWouldOverflow) return true

                        // Apply the weighted text budget after the height check.
                        const limit = isVmOnlyRow ? VM_ONLY_MAX_TEXT_BUDGET : MAX_TEXT_BUDGET
                        const budgetWouldOverflow = currentBudget + rowCost > limit
                        return budgetWouldOverflow
                    }

                    for (let vmIdx = 0; vmIdx < vmsInCat.length; vmIdx++) {
                        const vm = vmsInCat[vmIdx]
                        const vmText = vm.name?.trim() || `(No ${vmsDisplayName.toLowerCase()})`
                        const fill = vmIdx % 2 === 1 ? grey : white
                        const fontColor = '000000'

                        let evidenceList = []
                        if (vm.linkedEvidence && vm.linkedEvidence.length > 0) {
                            const response = await callSecureAPI(
                                endpoints.getLinkedEvidence.url,
                                endpoints.getLinkedEvidence.method,
                                token,
                                { listOfEvidence: vm.linkedEvidence }
                            )
                            evidenceList = response.data
                        }

                        // =============================
                        // VM-only row (no evidence): paginate based primarily on HEIGHT
                        // =============================
                        if (evidenceList.length === 0) {
                            const evText = `(No ${evidenceDisplayName})`
                            const ctText = '(No citation)'

                            const rowHeight = estimateRowHeightIn([vmText, evText, ctText], COL_W, BODY_FONT)
                            const rowCost = weightedTextCost(vmText, evText, ctText)

                            if (needsNewSlide(rowHeight, rowCost, true)) {
                                flushTableToSlide()
                                startNewSlide()
                            }

                            tableRows.push([
                                { text: vmText, options: { fontSize: BODY_FONT, fill, color: fontColor } },
                                { text: evText, options: { fontSize: BODY_FONT, fill, color: fontColor } },
                                { text: ctText, options: { fontSize: BODY_FONT, fill, color: fontColor } },
                            ])

                            rowHeights.push(rowHeight)
                            currentBudget += rowCost
                            forceVmColumn = false
                            continue
                        }

                        // =============================
                        // Evidence rows
                        // =============================
                        for (let evIdx = 0; evIdx < evidenceList.length; evIdx++) {
                            const ev = evidenceList[evIdx]
                            const citation = ev.citation?.trim() || '(No citation)'
                            const link = ev.link

                            const showVm = evIdx === 0 || forceVmColumn
                            const vmCellText = showVm ? vmText : ''
                            const evCellText = `• ${ev.name}`

                            const rowHeight = estimateRowHeightIn([vmCellText, evCellText, citation], COL_W, BODY_FONT)
                            const rowCost = weightedTextCost(vmCellText, evCellText, citation)

                            if (needsNewSlide(rowHeight, rowCost, false)) {
                                flushTableToSlide()
                                startNewSlide()
                            }

                            const vmTextToShow = forceVmColumn ? vmText : evIdx === 0 ? vmText : ''

                            tableRows.push([
                                { text: vmTextToShow, options: { fontSize: BODY_FONT, fill, color: fontColor } },
                                { text: evCellText, options: { fontSize: BODY_FONT, fill, color: fontColor } },
                                {
                                    text: citation,
                                    options: {
                                        fontSize: BODY_FONT,
                                        fill,
                                        color: link ? '0563C1' : fontColor,
                                        underline: !!link,
                                        hyperlink: link ? { url: link } : undefined,
                                    },
                                },
                            ])

                            rowHeights.push(rowHeight)
                            currentBudget += rowCost

                            if (forceVmColumn) forceVmColumn = false
                        }
                    }

                    // Render any rows remaining after the final Value Message.
                    flushTableToSlide()
                }
                break
            case vmsDisplayName + ' + ' + activitiesDisplayName: {
                const MAX_ROWS_PER_SLIDE = 7
                const slideWidth = 10.0
                const slideHeight = 5.625

                // Add Gantt chart slide first
                const activityResponse = await callSecureAPI(
                    endpoints.getActivitiesForTable.url + store.getState().strategy._id,
                    endpoints.getActivitiesForTable.method,
                    token
                )

                if (activityResponse?.success && Array.isArray(activityResponse.data) && activityResponse.data.length) {
                    await createActivitiesRightGanttSlide(
                        pptx,
                        activityResponse, // API response with .data
                        activityStatusStylesBase, // org-aware colors from component scope
                        getStatusLabel, // org-aware resolver (ID-or-name → canonical ID)
                        {
                            // ---- Title / axis ----
                            title: `${vmsDisplayName} + Timeline of ${activitiesDisplayName}`,

                            timeSplit: null, // Options: 'quarter' | 'half' | 'year' | null → auto-select based on window size
                            periodLabelMode: 'yearOver', // 'yearOver' = small quarters underneath a larger year header
                            periodFont: 6, // smaller Q/H labels
                            yearFont: 7, // smaller year label

                            // DATE WINDOW OVERRIDES
                            // Uncomment these if you want to lock the chart to specific years
                            startDateOverride: new Date(2024, 0, 1), // Jan 1, 2024 ; Place // out front to override
                            endDateOverride: null, // new Date(2028, 11, 31); Place // out front to override
                            maxYearsQuarter: 4, // - ≤ 4 years → quarter view
                            maxYearsHalf: 8, // - ≤10 years → half-year view // - >10 years → yearly view

                            // ---- Layout (left text + right bars) ----
                            slideWidth: 10.0,
                            slideHeight: 5.625,
                            yOffset: 0.7, // Space between slide title and chart area
                            leftWidthPct: 0.35, // Width of the left column (activity names)
                            chartHeightPct: 0.68, // Height of the chart area relative to the slide
                            rightPad: 0.05, // Padding on the right side to prevent bars or legend cutoff

                            minBarH: 0.055, // Minimum bar height (inches)
                            maxBarH: 0.2, // Maximum bar height (inches)
                            rowGap: 0.035, // Vertical gap between bars

                            sparseRowsTarget: 20, // treat <=20 activities as sparse
                            maxPerSlide: 30, // Max number of activities per slide
                            minFont: 6, // Min font size for labels
                            maxFont: 11, // Max font size for labels
                            sparseMaxFont: 10, // allow labels up to 12pt when sparse
                            sparseMaxBarH: 0.2, // allow taller bars on sparse slides
                            leftWidthPctSparse: 0.3, // widen names column on sparse slides // TODO Is this needed or would we want this to be shorter not wider?

                            // 🔧 turn off snapping
                            snapStartToPeriod: true, // keep start on a neat boundary (optional)
                            snapEndToPeriod: false, // ← do NOT snap to the most recent period; stop exactly at end

                            // ---- Status filtering (defaults to all) ----
                            includeStatuses: null, // null → all statuses are included // includeStatuses: ['Planned', 'Initiated', 'Completed']

                            // ---- Optional grouping by Strategic Imperatives ----
                            groupBySI: false, // true → separates by strategic imperative groups
                            // getSIName: (id) => tempSIMap[id]?.name,    // required only if groupBySI = true

                            // ---- Legend position ----
                            showLegend: true,
                            legendX: null, // Position (inches) from left
                            legendY: 0.08, // Position (inches) from top

                            // Notes
                            includeAllActivitiesInNotes: true,
                        }
                    )
                }

                for (const category of getOrderedCategories(tempCategoryMap, tempCategorizedVMs)) {
                    const categoryName = tempCategoryMap?.[category]?.name

                    const categoryData = valueNarratives.find((item) => item?.name === categoryName)

                    const activeNarratives = (categoryData?.valueNarratives || []).filter((narrative) => {
                        const archiveValue = narrative?.archived ?? narrative?.valueMessages?.[0]?.narrative?.archived

                        return archiveValue == null
                    })

                    const vms = activeNarratives.flatMap((narrative) =>
                        getOrderedValueMessages(narrative.valueMessages)
                    )

                    if (!vms.length) continue

                    // ---- Layout controls (adjust as needed) ----
                    const TABLE_X = 0.05 * slideWidth
                    const TABLE_Y = 0.14 * slideHeight
                    const COL_W = [
                        0.34 * slideWidth, // VM
                        0.1 * slideWidth, // Message Status
                        0.1 * slideWidth, // Priority
                        0.36 * slideWidth, // Activities
                    ] // VM | Activities

                    const HEADER_H = 0.25 // header row height (in)
                    const BASE_ROW_H = 0.4 // base row height (in)
                    const EXTRA_PER_WRAP = 0.08 // extra per wrapped line (in)
                    const MAX_TABLE_H = 0.76 * slideHeight // total table height budget on a slide
                    const MAX_ROW_H = 0.9 // optional clamp for a single row
                    const SAFETY_PAD = 0.02 // safety margin to avoid borderline overflow

                    // Rough wrap heuristics (no truncation; used only for pagination decisions)
                    const VM_NAME_CHARS_PER_LINE = 46
                    const BULLET_CHARS_PER_LINE = 56

                    // Helpers
                    const estLines = (s, charsPerLine) => Math.max(1, Math.ceil(String(s || '').length / charsPerLine))

                    // Lazy slide creation
                    function createSlideWithCategoryHeader(categoryName) {
                        const slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })

                        slide.addText([{ text: categoryName, options: { bold: true, fontSize: 12 } }], {
                            x: 0.05 * slideWidth,
                            y: 0.1 * slideHeight,
                            w: 0.6 * slideWidth,
                            h: 0.04 * slideHeight,
                            align: 'left',
                        })

                        const headers = [
                            [
                                {
                                    text: vmsDisplayName,
                                    options: {
                                        fill: backgroundColor,
                                        color: textColor,
                                        valign: 'middle',
                                        align: 'left',
                                        bold: true,
                                        border: [
                                            { color: white },
                                            { color: white },
                                            { color: '000000', pt: 2 },
                                            { color: white },
                                        ],
                                    },
                                },
                                {
                                    text: 'Message Status',
                                    options: {
                                        fill: backgroundColor,
                                        color: textColor,
                                        valign: 'middle',
                                        align: 'center',
                                        bold: true,
                                        border: [
                                            { color: white },
                                            { color: white },
                                            { color: '000000', pt: 2 },
                                            { color: white },
                                        ],
                                    },
                                },
                                {
                                    text: 'Priority',
                                    options: {
                                        fill: backgroundColor,
                                        color: textColor,
                                        valign: 'middle',
                                        align: 'center',
                                        bold: true,
                                        border: [
                                            { color: white },
                                            { color: white },
                                            { color: '000000', pt: 2 },
                                            { color: white },
                                        ],
                                    },
                                },
                                {
                                    text: activitiesDisplayName,
                                    options: {
                                        fill: backgroundColor,
                                        color: textColor,
                                        valign: 'middle',
                                        align: 'left',
                                        bold: true,
                                        border: [
                                            { color: white },
                                            { color: white },
                                            { color: '000000', pt: 2 },
                                            { color: white },
                                        ],
                                    },
                                },
                            ],
                        ]

                        return { slide, tableRows: [...headers] }
                    }

                    let currentSlide = null
                    let tableRows = null
                    let rowHeights = null // parallel array of row heights (in)
                    let usedHeight = 0 // accumulated height (in)
                    let rowColorToggle = false

                    // Flush current table to slide
                    function flushTable() {
                        if (!currentSlide || !tableRows || tableRows.length <= 1) return // nothing but headers
                        const rh = [HEADER_H, ...rowHeights]
                        currentSlide.addTable(tableRows, {
                            x: TABLE_X,
                            y: TABLE_Y,
                            colW: COL_W,
                            rowH: rh,
                            fontSize: 9,
                            border: { type: 'none' },
                        })
                    }

                    function startNewCategorySlide() {
                        ;({ slide: currentSlide, tableRows } = createSlideWithCategoryHeader(
                            getCategoryName(tempCategoryMap, category)
                        ))
                        rowHeights = []
                        usedHeight = HEADER_H // header placed
                    }

                    // Delay creating a slide until we actually have a row
                    let slideStarted = false

                    for (const vm of vms) {
                        // Fetch linked activities
                        let activities = []
                        if (Array.isArray(vm?.linkedActivities) && vm.linkedActivities.length) {
                            const resp = await callSecureAPI(
                                endpoints.getLinkedActivities.url,
                                endpoints.getLinkedActivities.method,
                                token,
                                { listOfActivities: vm.linkedActivities }
                            )
                            if (resp?.success) activities = resp.data || []
                        }

                        // Build bullets (NO truncation; use all)
                        const bulletsRaw = activities.length ? activities.map((a) => getActivityDisplayLabel(a)) : [``]

                        // --- Estimate row height (no truncation; just for pagination) ---
                        const vmNameLines = estLines(vm.name, VM_NAME_CHARS_PER_LINE)
                        let bulletLinesSum = 0
                        for (const b of bulletsRaw) bulletLinesSum += estLines(b, BULLET_CHARS_PER_LINE)

                        // Each bullet gets at least 1 line; extra wraps add height
                        const extraWrapLines = vmNameLines - 1 + (bulletLinesSum - bulletsRaw.length)
                        let rowH = BASE_ROW_H + extraWrapLines * EXTRA_PER_WRAP + SAFETY_PAD
                        rowH = Math.min(rowH, MAX_ROW_H) // optional clamp

                        // Start slide on first real row
                        if (!slideStarted) {
                            startNewCategorySlide()
                            slideStarted = true
                        }

                        // If this row would overflow the table height budget, flush & start a new slide
                        if (usedHeight + rowH > MAX_TABLE_H) {
                            flushTable()
                            startNewCategorySlide()
                        }

                        const rowColor = rowColorToggle ? grey : white
                        rowColorToggle = !rowColorToggle

                        // Convert bullets to pptx objects
                        const bullets = bulletsRaw.map((t) => ({
                            text: t,
                            options: { bullet: true, indent: 0.05, fontSize: 9 },
                        }))

                        // Push the row (no numbering on VM name)
                        tableRows.push([
                            { text: vm.name || '(Untitled)', options: { fontSize: 9, fill: rowColor } },
                            {
                                text: getMessageStatus(vm),
                                options: {
                                    fontSize: 8,
                                    fill: rowColor,
                                    align: 'center',
                                    valign: 'middle',
                                },
                            },
                            {
                                text: getMessagePriority(vm),
                                options: {
                                    fontSize: 8,
                                    fill: rowColor,
                                    align: 'center',
                                    valign: 'middle',
                                },
                            },
                            { text: bullets, options: { fill: rowColor } },
                        ])

                        rowHeights.push(rowH)
                        usedHeight += rowH
                    }

                    // Final flush for this category
                    flushTable()
                }

                break
            }
            case evidenceDisplayName:
                {
                    currentCharCount = 0

                    const tableRowsWithHeaders = []
                    let headersCopy

                    const headers = [
                        {
                            text: evidenceDisplayName,
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Type', //TODO Eventually add the affiliation that the source came from.
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'center',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Citation',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                    ]

                    // Set Up Table headers
                    tableRowsWithHeaders.push(headers)
                    headersCopy = Array.from(tableRowsWithHeaders)

                    let rowsOnSlide = 0

                    const renderSlide = () => {
                        const newSlide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                        newSlide.addTable(headersCopy, {
                            x: 0.5,
                            y: 0.7,
                            colW: [5.2, 1.0, 2.8],
                            border: { type: 'none' },
                            fill: backgroundColor,
                            color: textColor,
                            margin: 10,
                            rowH: 0.4,
                        })
                        rowsOnSlide = 0
                    }

                    for (let i = 0; i < evidence.data.length; i++) {
                        if (rowsOnSlide > 4 && rowsOnSlide !== 0) {
                            renderSlide()
                            currentCharCount = 0
                            headersCopy = Array.from(tableRowsWithHeaders)
                        }

                        const ev = evidence.data[i]
                        const rowColor = i % 2 === 0 ? grey : white

                        const row = [
                            {
                                text: ev.name ?? `(No ${evidenceDisplayName})`,
                                options: { fontSize: 9, fill: rowColor, fontFace: 'Arial' },
                            },
                            {
                                text: getEvidenceTypeLabel(ev),
                                options: {
                                    fontSize: 8,
                                    fill: rowColor,
                                    fontFace: 'Arial',
                                    align: 'center',
                                },
                            },
                            {
                                text: ev.citation ? ev.citation.trim() : '(No citation)',
                                options: {
                                    fontSize: 8,
                                    fill: rowColor,
                                    fontFace: 'Arial',
                                    hyperlink: ev.link ? { url: ev.link } : undefined,
                                    color: ev.link ? '0563C1' : textColor,
                                    underline: !!ev.link,
                                },
                            },
                        ]

                        headersCopy.push(row)
                        rowsOnSlide += 1

                        if (i === evidence.data.length - 1) renderSlide()
                    }
                }
                break
            case 'Key Evidence Statements':
                {
                    // Case‑local vars (avoid cross‑case collisions)
                    let currentCharCount = 0
                    const tableRowsWithHeaders = []
                    let headersCopy

                    const headers = [
                        {
                            text: evidenceDisplayName,
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Type',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'center',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Key Statements',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Citation',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                    ]

                    const slimExport = (evidence.data || []).map((ev) => {
                        const evId = ev?._id || ev?.id
                        const kesStrings = evId ? kesByEvidenceId.get(evId) || [] : []
                        return {
                            evidence: ev.name?.trim() || '',
                            keyEvidenceStatements: kesStrings, // array of strings
                            citation: ev.citation?.trim() || '',
                            link: ev.link || '',
                        }
                    })

                    // ---- PPT table ----
                    tableRowsWithHeaders.push(headers)
                    headersCopy = Array.from(tableRowsWithHeaders)

                    let rowsOnSlide = 0
                    const renderSlide = () => {
                        const newSlide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                        newSlide.addTable(headersCopy, {
                            x: 0.5,
                            y: 0.7,
                            colW: [2.1, 0.8, 4.5, 1.8],
                            border: { type: 'none' },
                            fill: backgroundColor,
                            color: textColor,
                            margin: 10,
                            rowH: 0.4,
                        })
                        rowsOnSlide = 0
                    }

                    for (const ev of evidence.data || []) {
                        if (rowsOnSlide > 4) {
                            renderSlide()
                            currentCharCount = 0
                            headersCopy = Array.from(tableRowsWithHeaders)
                        }

                        const evId = ev?._id || ev?.id
                        const rowColor = rowsOnSlide % 2 === 0 ? grey : white

                        const evidenceText = ev.name?.trim() || `(No ${evidenceDisplayName})`
                        const kesStrings = evId ? kesByEvidenceId.get(evId) || [] : []
                        const kesText = kesStrings.length
                            ? kesStrings.map((s) => `• ${s}`).join('\n')
                            : '(No statements)'

                        const citationText = ev.citation?.trim() || '(No citation)'
                        const citationCell = {
                            text: citationText,
                            options: {
                                fontSize: 8,
                                fill: rowColor,
                                fontFace: 'Arial',
                                align: 'left',
                                valign: 'top',
                                hyperlink: ev.link ? { url: ev.link } : undefined,
                                color: ev.link ? '0563C1' : textColor,
                                underline: !!ev.link,
                            },
                        }

                        headersCopy.push([
                            {
                                text: evidenceText,
                                options: {
                                    fontSize: 8,
                                    fill: rowColor,
                                    fontFace: 'Arial',
                                    align: 'left',
                                    valign: 'top',
                                },
                            },
                            {
                                text: getEvidenceTypeLabel(ev),
                                options: {
                                    fontSize: 8,
                                    fill: rowColor,
                                    fontFace: 'Arial',
                                    align: 'center',
                                    valign: 'top',
                                },
                            },
                            {
                                text: kesText,
                                options: {
                                    fontSize: 8,
                                    fill: rowColor,
                                    fontFace: 'Arial',
                                    align: 'left',
                                    valign: 'top',
                                },
                            },
                            citationCell,
                        ])

                        rowsOnSlide++
                    }

                    renderSlide()
                }
                break

            case 'SIs + ' + activitiesDisplayName: {
                let strategicImperatives = await callAPI(
                    endpoints.getSIForTable.url + store.getState().strategy._id,
                    endpoints.getSIForTable.method,
                    token
                )
                if (!strategicImperatives.success) {
                    console.log('Failed to fetch SIs')
                    return
                }

                strategicImperatives = strategicImperatives.data

                currentCharCount = 0
                tableRowsWithHeaders = []
                let headerNames = [
                    strategicDisplayName,
                    activityDisplayName + ' TITLE',
                    'CATEGORY',
                    'FUNCTION',
                    'Q1',
                    'Q2',
                    'Q3',
                    'Q4',
                    'Q1',
                    'Q2',
                    'Q3',
                    'Q4',
                    'Q1',
                    'Q2',
                    'Q3',
                    'Q4',
                ]
                let widths = [1.4, 1, 1, 1, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4]
                headers = []
                for (let i = 0; i < headerNames.length; i++) {
                    headers.push({
                        text: headerNames[i],
                        options: {
                            fontSize: i > 3 ? 7 : 8,
                            fill: backgroundColor,
                            color: headerNames[i] === strategicDisplayName ? blueHeaders : pink,
                            valign: 'middle',
                            align: 'center',
                            bold: true,
                            width: widths[i],
                            // TRBL order
                            border: [{ color: white }, { color: white }, { color: '000000', pt: 2 }, { color: white }],
                        },
                    })
                }
                // Set Up Table headers
                tableRowsWithHeaders.push(headers)
                let headersCopy1 = Array.from(tableRowsWithHeaders)

                // ITERATE THROUGH VM'S IN EACH CATEGORY, PAGINATING IN CHUNKS
                let sisOnCurrentSlide = 0
                let actsOnSlide = 0
                for (let i = 0, j = strategicImperatives.length; i < j; i++) {
                    let activities = []
                    if (
                        strategicImperatives[i].linkedActivities &&
                        strategicImperatives[i].linkedActivities.length > 0
                    ) {
                        activities = await callSecureAPI(
                            endpoints.getLinkedActivities.url,
                            endpoints.getLinkedActivities.method,
                            token,
                            { listOfActivities: strategicImperatives[i].linkedActivities }
                        )
                        if (activities.success) {
                            activities = activities.data
                        }
                    }

                    let siActivitiesCharCount = 0
                    for (let act of activities) {
                        siActivitiesCharCount += act.title.length
                    }
                    // Ignoring no-loop-func warning currently because behavior is stable, need to persist presentation
                    // eslint-disable-next-line no-loop-func
                    function createSlide6() {
                        var newSlide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                        newSlide.addTable(headersCopy1, {
                            x: 0.5,
                            y: 0.7,
                            border: { type: 'none' },
                            fill: backgroundColor,
                            color: textColor,
                            margin: 10,
                            rowH: 0.4,
                            colW: [1.4, 1, 1, 1, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4, 0.4],
                        })

                        sisOnCurrentSlide = 0
                        actsOnSlide = 0
                        let thisYear = new Date().getFullYear()
                        newSlide.addText(
                            [
                                {
                                    text: thisYear,
                                    options: {
                                        color: pink,
                                        fontSize: 7,
                                        align: 'left',
                                        bold: true,
                                    },
                                },
                            ],
                            { y: 0.63, x: 5.51 }
                        )

                        newSlide.addText(
                            [
                                {
                                    text: thisYear + 1,
                                    options: {
                                        color: pink,
                                        fontSize: 7,
                                        align: 'left',
                                        bold: true,
                                    },
                                },
                            ],
                            { y: 0.63, x: 7.11 }
                        )
                        newSlide.addText(
                            [
                                {
                                    text: thisYear + 2,
                                    options: {
                                        color: pink,
                                        fontSize: 7,
                                        align: 'left',
                                        bold: true,
                                    },
                                },
                            ],
                            { y: 0.63, x: 8.68 }
                        )
                        newSlide.addText(
                            [
                                {
                                    text: '△ Start',
                                    options: {
                                        color: pink,
                                        fontSize: 7,
                                        align: 'left',
                                        bold: true,
                                    },
                                },
                            ],
                            { y: 5.03, x: 4.93 }
                        )
                        newSlide.addText(
                            [
                                {
                                    text: '◈ End',
                                    options: {
                                        color: blueHeaders,
                                        fontSize: 7,
                                        align: 'left',
                                        bold: true,
                                    },
                                },
                            ],
                            { y: 5.03, x: 6.18 }
                        )
                    }

                    if (
                        (currentCharCount + siActivitiesCharCount > MAX_CHARS_PER_SLIDE ||
                            sisOnCurrentSlide > 1 ||
                            actsOnSlide > 15) &&
                        sisOnCurrentSlide !== 0
                    ) {
                        createSlide6()
                        // reset counter and headers
                        currentCharCount = 0
                        headersCopy1 = Array.from(tableRowsWithHeaders)
                    }

                    let rowColor = i % 2 === 0 ? grey : white
                    // add this VM to current working slide
                    let rows = [
                        {
                            text: `${strategicImperatives[i].name}`,
                            options: { fontSize: 9, fill: rowColor, align: 'center' },
                        },
                    ]
                    if (activities && activities.length > 0) {
                        let year = new Date().getFullYear()
                        let fields = ['title', 'category', 'function']
                        let numberOfYears = 3
                        for (let i = 0; i < numberOfYears; i++) {
                            for (let n = 1; n <= 4; n++) {
                                fields.push(`Q${n}, ${year + i}`)
                            }
                        }

                        actsOnSlide += 1
                        for (let field of fields) {
                            let rowActivities = []
                            let counter = 0
                            for (let act of activities) {
                                if (counter === 3) {
                                    // limits the number of activities to 2 per slide...
                                    // some smarter pagination could possibly remove the need for this one day
                                    break
                                }
                                let start = null
                                let end = null
                                if (act['startDate']) {
                                    start = new Date(act['startDate'])
                                }
                                if (act['endDate']) {
                                    end = new Date(act['endDate'])
                                }

                                let breaks = Math.floor(act['title'].length / 12)
                                if (field === 'startDate' || field === 'endDate') {
                                    rowActivities.push({
                                        text: `Q${quarterOfYear(new Date(act[field]))} ${new Date(
                                            act[field]
                                        ).getFullYear()}`,
                                        options: { fontSize: 9, align: 'center', breakLine: true },
                                    })
                                }
                                if (field.includes('Q')) {
                                    if (!start || !end) {
                                        rowActivities.push({
                                            text: '.',
                                            options: { fontSize: 9, align: 'center', breakLine: true, color: rowColor },
                                        })
                                        break
                                    }
                                    let text = ''

                                    let parseYear = field.split(',')
                                    let year = parseInt(parseYear[1])
                                    let fieldQuarter = parseInt(field[1])

                                    let actYearStart = start.getFullYear()
                                    let actYearEnd = end.getFullYear()
                                    let actQuarterStart = quarterOfYear(start)
                                    let actQuarterEnd = quarterOfYear(end)

                                    let color = textColor
                                    if (
                                        year < actYearStart ||
                                        (year === actYearStart && fieldQuarter < actQuarterStart) ||
                                        year > actYearEnd ||
                                        (year === actYearEnd && fieldQuarter > actQuarterEnd)
                                    ) {
                                        // outside range
                                        text = '.'
                                        color = rowColor
                                    } else if (fieldQuarter === actQuarterStart && year === actYearStart) {
                                        // start date
                                        text = '△'
                                        color = pink
                                    } else if (fieldQuarter === actQuarterEnd && year === actYearEnd) {
                                        // end date
                                        text = '◈'
                                        color = blueHeaders
                                    } else {
                                        // between start/end
                                        text = '-'
                                    }

                                    rowActivities.push({
                                        text: text,
                                        options: {
                                            color: color,
                                            fontSize: 9,
                                            align: 'center',
                                            breakLine: true,
                                        },
                                    })
                                } else {
                                    rowActivities.push({
                                        text: `${act[field]}`,
                                        options: { fontSize: 9, align: 'center', breakLine: true },
                                    })
                                }
                                rowActivities.push({
                                    text: '\n',
                                    options: { fontSize: 9, align: 'center', breakLine: true },
                                })
                                if (field !== 'title' && counter !== activities.length - 1) {
                                    if (field !== 'function' || act['function'].length < 8)
                                        for (let x = 0; x < breaks; x++) {
                                            rowActivities.push({
                                                text: '\n',
                                                options: { fontSize: 9, align: 'center', breakLine: true },
                                            })
                                        }
                                }
                                counter++
                            }

                            rows.push({ text: rowActivities, options: { fontSize: 9, fill: rowColor } })
                        }
                    } else {
                        // number of columns, need to add empty text to cells otherwise
                        // there are cell borders
                        rows.push({
                            text: 'None to display',
                            options: {
                                fontSize: 9,
                                align: 'center',
                                breakLine: true,
                                fill: rowColor,
                                valign: 'middle',
                                italic: true,
                            },
                        })
                        for (let n = 0; n < 14; n++) {
                            rows.push({
                                text: '',
                                options: { fontSize: 9, align: 'center', breakLine: true, fill: rowColor },
                            })
                        }
                    }
                    headersCopy1.push(rows)
                    currentCharCount += siActivitiesCharCount
                    sisOnCurrentSlide += 1

                    // last VM
                    if (i === j - 1) {
                        createSlide6()
                    }
                }
                break
            }
            case activitiesDisplayName: {
                await (async () => {
                    currentCharCount = 0
                    tableRowsWithHeaders = []
                    headers = [
                        {
                            text: activitiesDisplayName,
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Objective / Rationale',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Start',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'End',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                    ]

                    // 1) Fetch activities
                    const activities = await callSecureAPI(
                        endpoints.getActivitiesForTable.url + store.getState().strategy._id,
                        endpoints.getActivitiesForTable.method,
                        token
                    )

                    if (!activities?.success) {
                        console.log('Failed to fetch activities')
                        return
                    }

                    if (activities.data?.length) {
                        await createActivitiesRightGanttSlide(
                            pptx,
                            activities, // API response with .data
                            activityStatusStylesBase, // org-aware colors (from component scope)
                            getStatusLabel, // org-aware resolver (ID-or-name → canonical ID)
                            {
                                // ---- Title / axis ----
                                title: `Timeline of ${activitiesDisplayName}`,
                                timeSplit: null, // auto: quarter/half/year based on window size
                                periodLabelMode: 'yearOver',
                                periodFont: 6, // smaller Q/H labels
                                yearFont: 7, // smaller year label

                                // ---- DATE WINDOW OVERRIDES (optional) ----
                                startDateOverride: new Date(2024, 0, 1), // Jan 1, 2024
                                endDateOverride: null, // new Date(2028, 11, 31), // Dec 31, 2028
                                maxYearsQuarter: 4, // ≤4y => quarters
                                maxYearsHalf: 8, // >4y & ≤8y => halves; >8y => years

                                // ---- Layout (left text + right bars) ----
                                slideWidth: 10.0,
                                slideHeight: 5.625,
                                yOffset: 0.7, // space between title and chart
                                leftWidthPct: 0.3, // narrower names column
                                chartHeightPct: 0.68,
                                rightPad: 0.05, // more room on right edge

                                // ---- Bars/rows (same “halved” look) ----
                                minBarH: 0.055,
                                maxBarH: 0.2,
                                rowGap: 0.035,

                                // ---- Sparse tuning (same behavior as other case) ----
                                sparseRowsTarget: 20, // treat ≤20 as “sparse”
                                maxPerSlide: 30,
                                minFont: 6,
                                maxFont: 11,
                                sparseMaxFont: 10, // cap when sparse
                                sparseMaxBarH: 0.2, // taller bars allowed when sparse
                                leftWidthPctSparse: 0.3, // widen names column when sparse

                                // ---- Snapping ----
                                snapStartToPeriod: true, // align start to whole period
                                snapEndToPeriod: false, // do NOT snap to the most recent period; stop at real end

                                // ---- Status filtering (defaults to all when null) ----
                                includeStatuses: null,

                                // ---- Optional grouping by Strategic Imperatives ----
                                groupBySI: false,
                                // getSIName: (id) => tempSIMap[id]?.name,    // REQUIRED only if groupBySI = true

                                // ---- Legend position ----
                                showLegend: true,
                                legendX: null,
                                legendY: 0.08,

                                // Notes
                                includeAllActivitiesInNotes: true,
                            }
                        )
                    }

                    // 3) Build the table (fixed pagination)
                    const ROWS_PER_SLIDE = 6 // <= change to taste
                    const COL_WIDTHS = [3.0, 4.0, 1.0, 1.0]

                    const baseHeader = [headers] // one header row
                    let pageRows = [...baseHeader] // working buffer for the current slide
                    let rowsOnThisSlide = 0

                    // Flush helper: render current buffer and reset state
                    function flushTableSlide() {
                        if (pageRows.length <= 1) return // nothing but header
                        const s = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                        s.addTable(pageRows, {
                            x: 0.5,
                            y: 0.7,
                            border: { type: 'none' },
                            colW: COL_WIDTHS,
                            fill: backgroundColor,
                            color: textColor,
                            margin: 10,
                            rowH: 0.4,
                        })
                        // reset for next page
                        pageRows = [...baseHeader]
                        rowsOnThisSlide = 0
                    }

                    for (let i = 0; i < activities.data.length; i++) {
                        // Start a new page *before* adding the next row if the current one is full
                        if (rowsOnThisSlide >= ROWS_PER_SLIDE) {
                            flushTableSlide()
                        }

                        const a = activities.data[i]
                        const rowColor = i % 2 === 0 ? grey : white
                        const startDate = a.startDate ? new Date(a.startDate) : null
                        const endDate = a.endDate ? new Date(a.endDate) : null

                        const row = [
                            {
                                text: a.title || '(Untitled Activity)',
                                options: { fontSize: 8, fill: rowColor, fontFace: 'Arial' },
                            },
                            {
                                text: a.description || '',
                                options: { fontSize: 8, fill: rowColor, fontFace: 'Arial' },
                            },
                            {
                                text: startDate ? `Q${quarterOfYear(startDate)}, ${startDate.getFullYear()}` : '',
                                options: { fontSize: 8, fill: rowColor, fontFace: 'Arial' },
                            },
                            {
                                text: endDate ? `Q${quarterOfYear(endDate)}, ${endDate.getFullYear()}` : '',
                                options: { fontSize: 8, fill: rowColor, fontFace: 'Arial' },
                            },
                        ]

                        pageRows.push(row)
                        rowsOnThisSlide += 1
                    }

                    // Flush the final partial page (if any)
                    flushTableSlide()
                })()

                break
            }

            case strategicDisplayName + ' + ' + activitiesDisplayName:
                // TODO The spinner keeps spinning, check out the budget if its forcing a failure.
                let EGPstrategicImperatives = await callAPI(
                    endpoints.getSIForTable.url + store.getState().strategy._id,
                    endpoints.getSIForTable.method,
                    token
                )
                if (!EGPstrategicImperatives.success) {
                    console.log('Failed to fetch SIs')
                    return
                }

                EGPstrategicImperatives = EGPstrategicImperatives.data
                let EGPTableRowsWithHeaders = []

                // TODO Test the ability to remove Budget or additional columns based on whether a specific category was selected yes or no.
                let EGPHeaderNames = [activitiesDisplayName, 'Category', 'Function', 'Start', 'End', 'Budget'] // TODO Remove Budget and Replace with Intended Use
                let EGPWidths = [4, 1.2, 1.2, 0.8, 0.8, 1] //Tyler: altered spacing to account for category and function widths
                let EGPHeaders = []
                for (let i = 0; i < EGPHeaderNames.length; i++) {
                    EGPHeaders.push({
                        text: EGPHeaderNames[i],
                        options: {
                            fontSize: 10, // Tyler: increased font size slightly
                            fill: backgroundColor,
                            color: textColor,
                            valign: 'middle',
                            align: 'center',
                            bold: true,
                            width: EGPWidths[i],
                            // TRBL order
                            border: [{ color: white }, { color: white }, { color: '000000', pt: 2 }, { color: white }],
                        },
                    })
                }
                // Set Up Table headers
                EGPTableRowsWithHeaders.push(EGPHeaders)
                let EGPHeadersCopy1 = Array.from(EGPTableRowsWithHeaders)

                // ITERATE THROUGH VM'S IN EACH CATEGORY, PAGINATING IN CHUNKS
                for (let i = 0, j = EGPstrategicImperatives.length; i < j; i++) {
                    let EGPactsOnSlide = 0

                    function createSlide7() {
                        var newSlide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                        newSlide.addTable(EGPHeadersCopy1, {
                            x: 0.5,
                            y: 1.3,
                            border: { type: 'none' },
                            fill: backgroundColor,
                            color: textColor,
                            margin: 10,
                            rowH: 0.4,
                            colW: [4, 1.2, 1.2, 0.8, 0.8, 1],
                        })
                        newSlide.addText(
                            // Tyler: Moving the two text elements into one box so that when either are bigger or smaller
                            // they don't begin to overlap as Otsuka's do.
                            [
                                {
                                    text: `${strategicDisplayName}: `,
                                    options: {
                                        color: blueHeaders,
                                        fontSize: 11,
                                        align: 'left',
                                        bold: true,
                                    },
                                },
                                {
                                    text: EGPstrategicImperatives[i].name,
                                    options: {
                                        color: blueHeaders,
                                        fontSize: 10,
                                        align: 'left',
                                        bold: true,
                                    },
                                },
                            ],
                            {
                                y: 0.8, // Adjust vertical placement
                                x: 0.5, // Align with table
                                w: '90%', // Give enough width so long text wraps nicely
                            }
                        )
                        EGPactsOnSlide = 0
                    }

                    let activities = []
                    if (
                        EGPstrategicImperatives[i].linkedActivities &&
                        EGPstrategicImperatives[i].linkedActivities.length > 0
                    ) {
                        activities = await callSecureAPI(
                            endpoints.getLinkedActivities.url,
                            endpoints.getLinkedActivities.method,
                            token,
                            { listOfActivities: EGPstrategicImperatives[i].linkedActivities }
                        )
                        if (activities.success) {
                            activities = activities.data
                        }
                    }

                    // Ignoring no-loop-func warning currently because behavior is stable, need to persist presentation
                    // eslint-disable-next-line no-loop-func

                    // add this VM to current working slide

                    if (activities && activities.length > 0) {
                        for (let [index, act] of activities.entries()) {
                            let rowColor = index % 2 === 0 ? grey : white

                            if (EGPactsOnSlide > 4) {
                                createSlide7()
                                // reset counter and headers
                                EGPHeadersCopy1 = Array.from(EGPTableRowsWithHeaders)
                            }

                            let startDate
                            let endDate
                            if (act.startDate) {
                                startDate = new Date(act.startDate)
                            }
                            if (act.endDate) {
                                endDate = new Date(act.endDate)
                            }
                            let rowActivities = [
                                {
                                    text: `${act.title}`,
                                    options: { fontSize: 8, fill: rowColor, fontFace: 'Arial' },
                                },
                                {
                                    text: `${act.category}`,
                                    options: { fontSize: 8, fill: rowColor, fontFace: 'Arial', align: 'center' },
                                },
                                {
                                    text: `${act.function}`,
                                    options: { fontSize: 8, fill: rowColor, fontFace: 'Arial', align: 'center' },
                                },
                                {
                                    text: startDate ? `Q${quarterOfYear(startDate)}, ${startDate.getFullYear()}` : '',
                                    options: { fontSize: 8, fill: rowColor, fontFace: 'Arial', align: 'center' },
                                },
                                {
                                    text: endDate ? `Q${quarterOfYear(endDate)}, ${endDate.getFullYear()}` : '',
                                    options: { fontSize: 8, fill: rowColor, fontFace: 'Arial', align: 'center' },
                                },
                                {
                                    text:
                                        '$' +
                                        act.budget.toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                        }),
                                    options: { fontSize: 8, fill: rowColor, fontFace: 'Arial', align: 'center' },
                                },
                            ]
                            EGPHeadersCopy1.push(rowActivities)
                            EGPactsOnSlide += 1
                        }
                    }
                    createSlide7()
                    EGPHeadersCopy1 = Array.from(EGPTableRowsWithHeaders)
                }

                break
            case vmsDisplayName + ' + Gaps': // This one reflects the Evidence Gap page
                let gaps = await callSecureAPI(
                    endpoints.getEvidenceGapsByStrategyId.url + store.getState().strategy._id,
                    endpoints.getEvidenceGapsByStrategyId.method,
                    token
                )
                let acts = await callSecureAPI(
                    endpoints.getActivitiesForTable.url + store.getState().strategy._id,
                    endpoints.getActivitiesForTable.method,
                    token
                )

                let gapMap = {}
                for (let gap of gaps.data) {
                    if (gapMap[gap.valueMessageId]) {
                        gapMap[gap.valueMessageId].push(gap)
                        let sorted = gapMap[gap.valueMessageId].sort((x, y) => x.order - y.order)
                        gapMap[gap.valueMessageId] = sorted
                    } else {
                        gapMap[gap.valueMessageId] = [gap]
                    }
                }

                let activitiesMap = {}
                for (let act of acts.data) {
                    activitiesMap[act._id] = act
                }

                for (let category of Object.keys(tempCategorizedVMs)) {
                    let i,
                        j,
                        currentCharCount = 0,
                        tableRowsWithHeaders = [],
                        headers = [
                            {
                                text: tempCategoryMap[category].name + ' ' + vmsDisplayName,
                                options: {
                                    fill: backgroundColor,
                                    color: '000000',
                                    valign: 'middle',
                                    align: 'left',
                                    bold: true,
                                    // TRBL order
                                    border: [
                                        { color: white },
                                        { color: white },
                                        { color: '000000', pt: 2 },
                                        { color: white },
                                    ],
                                },
                            },
                            {
                                text: 'Gaps',
                                options: {
                                    fill: backgroundColor,
                                    color: '000000',
                                    valign: 'middle',
                                    align: 'left',
                                    bold: true,
                                    // TRBL order
                                    border: [
                                        { color: white },
                                        { color: white },
                                        { color: '000000', pt: 2 },
                                        { color: white },
                                    ],
                                },
                            },
                            {
                                text: 'Activities',
                                options: {
                                    fill: backgroundColor,
                                    color: '000000',
                                    valign: 'middle',
                                    align: 'left',
                                    bold: true,
                                    // TRBL order
                                    border: [
                                        { color: white },
                                        { color: white },
                                        { color: '000000', pt: 2 },
                                        { color: white },
                                    ],
                                },
                            },
                        ]

                    // Set Up Table headers
                    tableRowsWithHeaders.push(headers)
                    let headersCopy = Array.from(tableRowsWithHeaders)

                    // ITERATE THROUGH VM'S IN EACH CATEGORY, PAGINATING IN CHUNKS
                    let vmsOnCurrentSlide = 0
                    let evidenceOnCurrentSlide = 0
                    for (i = 0, j = tempCategorizedVMs[category].length; i < j; i++) {
                        // let evidence = []
                        // if (
                        //     categorizedVMs[category][i].linkedEvidence &&
                        //     categorizedVMs[category][i].linkedEvidence.length > 0
                        // ) {
                        //     evidence = await callSecureAPI(
                        //         endpoints.getLinkedEvidence.url,
                        //         endpoints.getLinkedEvidence.method,
                        //         token,
                        //         { listOfEvidence: categorizedVMs[category][i].linkedEvidence }
                        //     )
                        //     evidence = evidence.data
                        // }
                        //
                        let vmEvidenceCharCount = 0
                        // for (let ev of evidence) {
                        //     vmEvidenceCharCount += ev.name.length
                        // }

                        // Ignoring no-loop-func warning currently because behavior is stable, need to persist presentation
                        // eslint-disable-next-line no-loop-func
                        function createSlide8() {
                            var newSlide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                            newSlide.addTable(headersCopy, {
                                x: 0.5,
                                y: 0.7,
                                colW: [3, 3, 3],
                                // border: [{ color: textColor }, { color: textColor }, { color: textColor }, { color: textColor }],
                                border: { type: 'none' },
                                fill: backgroundColor,
                                color: textColor,
                                margin: 10,
                                rowH: 0.4,
                            })

                            vmsOnCurrentSlide = 0
                            evidenceOnCurrentSlide = 0
                        }

                        if (
                            currentCharCount + vmEvidenceCharCount > MAX_CHARS_PER_SLIDE ||
                            vmsOnCurrentSlide > 6 ||
                            evidenceOnCurrentSlide > 15
                        ) {
                            createSlide8()
                            // reset counter and headers
                            currentCharCount = 0
                            headersCopy = Array.from(tableRowsWithHeaders)
                        }

                        // COMMENTED OUT WITH VMS PER SLIDE AT 3, THIS IS TO BE USED LATER
                        // WHEN MAKING CONFIGURABLE

                        // if (
                        //     currentCharCount + vmEvidenceCharCount > MAX_CHARS_PER_SLIDE ||
                        //     vmsOnCurrentSlide > 3 ||
                        //     evidenceOnCurrentSlide > 15
                        // ) {
                        //     createSlide()
                        //     // reset counter and headers
                        //     currentCharCount = 0
                        //     headersCopy = Array.from(tableRowsWithHeaders)
                        // }

                        let rowColor = i % 2 === 0 ? grey : white
                        // add this VM to current working slide
                        let rows = [
                            {
                                text: `${tempCategorizedVMs[category][i].name}`,
                                options: { fontSize: 10, fill: rowColor, fontFace: 'Arial' },
                            },
                        ]

                        let bullets = []
                        let actBullets = []
                        let actBulletsObj = []
                        if (
                            gapMap[tempCategorizedVMs[category][i]._id] &&
                            gapMap[tempCategorizedVMs[category][i]._id].length > 0
                        ) {
                            for (let gap of gapMap[tempCategorizedVMs[category][i]._id]) {
                                bullets.push({
                                    text: gap.text,
                                    options: { bullet: true, fontSize: 9 },
                                })
                                for (let act of gap.linkedActivities) {
                                    actBullets.push(activitiesMap[act].title)
                                }
                            }
                        } else {
                            bullets = ''
                        }

                        if (actBullets.length > 0) {
                            for (let act of actBullets) {
                                actBulletsObj.push({
                                    text: act,
                                    options: { bullet: true, fontSize: 9 },
                                })
                            }
                        } else {
                            actBulletsObj = ''
                        }

                        rows.push({ text: bullets, options: { fill: rowColor } })
                        rows.push({ text: actBulletsObj, options: { fill: rowColor } })

                        // let bullets = []
                        // if (evidence && evidence.length > 0) {
                        //     for (let ev of evidence) {
                        //         evidenceOnCurrentSlide += 1
                        //         bullets.push({
                        //             text: ev.name,
                        //             options: { bullet: true, fontSize: 9 },
                        //         })
                        //     }
                        // } else {
                        //     bullets = ''gi
                        // }
                        // rows.push({ text: bullets, options: { fill: rowColor } })
                        headersCopy.push(rows)
                        currentCharCount += vmEvidenceCharCount
                        vmsOnCurrentSlide += 1

                        // last VM
                        if (i === j - 1) {
                            createSlide8()
                        }
                    }
                }
                break
            case vmsDisplayName + ' + Status + Gaps': {
                await (async () => {
                    const slideWidth = 10.0
                    const slideHeight = 5.625

                    // Pagination controls amd tuning
                    // Pagination occurs based on estimated content height. Values seem slightly conservative
                    // But long gaps may create issues with pagination and cause overflow.
                    const CHARS_PER_LINE_VM = 65
                    const CHARS_PER_LINE_GAP = 40
                    const baseRowHeight = 0.32
                    const lineHeight = 0.2

                    // Layout trying to reflect the approaches used in other cases
                    const TABLE_X = 0.05 * slideWidth
                    const TABLE_Y = 0.14 * slideHeight
                    const PAGE_BODY_Y_MAX = 6.8
                    const MAX_TABLE_HEIGHT = PAGE_BODY_Y_MAX - TABLE_Y

                    // Legend position is exact dimensions which should work given we have a consistent 3 statuses
                    // Would need adjustment if configurable. The box should be drawn first at the X, Y position
                    // so that it sits in the back and the rest of the legend contents are in relation to that box.
                    const LEGEND_W = 0.4 * slideWidth // Should be 4.0
                    const LEGEND_H = 0.106 * slideHeight // Close to 0.6
                    const LEGEND_X = 0.55 * slideWidth // Could make it exact from the right side (0.95 * slideWidth) - LEGEND_W
                    const LEGEND_Y = 0.022 * slideHeight // Trying to get to 0.125 Y

                    // Helper for row height
                    function getTotalRowHeight(rowHeights) {
                        return rowHeights.reduce((sum, h) => sum + h, 0)
                    }

                    // Table header but we've now removed the Category because sometimes Categories get long and they
                    // were wrapping and creating inconsistency
                    const tableHeader = [
                        {
                            text: vmsDisplayName,
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                fontSize: 12,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Status',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'center',
                                bold: true,
                                fontSize: 12,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Priority',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'center',
                                bold: true,
                                fontSize: 12,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                        {
                            text: 'Gaps',
                            options: {
                                fill: backgroundColor,
                                color: '000000',
                                valign: 'middle',
                                align: 'left',
                                bold: true,
                                fontSize: 12,
                                border: [
                                    { color: white },
                                    { color: white },
                                    { color: '000000', pt: 2 },
                                    { color: white },
                                ],
                            },
                        },
                    ]

                    // Create + render slide
                    function renderSlide(categoryName, rows) {
                        const slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })

                        // Category header
                        slide.addText([{ text: categoryName, options: { bold: true, fontSize: 12 } }], {
                            x: 0.05 * slideWidth,
                            y: 0.1 * slideHeight,
                            w: 0.6 * slideWidth,
                            h: 0.04 * slideHeight,
                            align: 'left',
                        })

                        // Legend (now self-contained helper)
                        addStatusLegend(slide, {
                            x: 8.9,
                            y: 0.08,
                        })

                        // Table
                        slide.addTable(rows, {
                            x: TABLE_X,
                            y: TABLE_Y,
                            colW: [0.42 * slideWidth, 0.09 * slideWidth, 0.09 * slideWidth, 0.3 * slideWidth],
                            border: { type: 'none' },
                            fill: backgroundColor,
                            color: textColor,
                            margin: 10,
                            rowH: 0.4,
                        })
                    }

                    // Process each category
                    for (const category of getOrderedCategories(tempCategoryMap, tempCategorizedVMs)) {
                        const categoryName = tempCategoryMap?.[category]?.name

                        const categoryData = valueNarratives.find((item) => item?.name === categoryName)

                        const activeNarratives = (categoryData?.valueNarratives || []).filter((narrative) => {
                            const archiveValue =
                                narrative?.archived ?? narrative?.valueMessages?.[0]?.narrative?.archived

                            return archiveValue == null
                        })

                        const vms = activeNarratives.flatMap((narrative) =>
                            getOrderedValueMessages(narrative.valueMessages)
                        )

                        if (!vms.length) continue
                        let currentRows = [tableHeader]
                        let rowHeights = []

                        for (let i = 0; i < vms.length; i++) {
                            const vm = vms[i]
                            const rowColor = i % 2 === 0 ? grey : white

                            // Fetch gaps
                            const gapResponse = await callSecureAPI(
                                endpoints.getEvidenceGapsByValueMessageId.url + vm._id,
                                endpoints.getEvidenceGapsByValueMessageId.method,
                                token
                            )
                            const evidenceGaps = gapResponse?.data || []
                            const gapText = evidenceGaps.length
                                ? evidenceGaps.map((g) => `• ${g.text}`).join('\n')
                                : 'N/A'

                            // Pagination height
                            const vmLineCount = Math.max(1, Math.ceil((vm.name?.length || 0) / CHARS_PER_LINE_VM))
                            const gapLineCount = Math.max(
                                1,
                                evidenceGaps.reduce(
                                    (sum, g) => sum + Math.ceil((g.text?.length || 0) / CHARS_PER_LINE_GAP),
                                    0
                                )
                            )
                            const rowHeight = baseRowHeight + lineHeight * (vmLineCount + gapLineCount - 1)

                            // Page overflow → render current slide before adding new row
                            if (getTotalRowHeight(rowHeights) + rowHeight > MAX_TABLE_HEIGHT) {
                                renderSlide(getCategoryName(tempCategoryMap, category), currentRows)
                                currentRows = [tableHeader]
                                rowHeights = []
                            }

                            // Add row
                            currentRows.push([
                                {
                                    text: vm.name || `(No ${vmsDisplayName})`,
                                    options: { fontSize: 9, fill: rowColor, fontFace: 'Arial' },
                                },
                                {
                                    text: '◉',
                                    options: {
                                        fontSize: 14,
                                        fill: rowColor,
                                        fontFace: 'Arial',
                                        color:
                                            STATUS_COLORS?.[vm.status] ??
                                            STATUS_COLORS?.[(vm.status || '').replace(/^\w/, (c) => c.toUpperCase())] ??
                                            textColor,
                                        align: 'center',
                                        valign: 'middle',
                                    },
                                },
                                {
                                    text: vm.priority || 'N/A',
                                    options: {
                                        fontSize: 9,
                                        fill: rowColor,
                                        fontFace: 'Arial',
                                        align: 'center',
                                        valign: 'middle',
                                    },
                                },
                                {
                                    text: gapText,
                                    options: {
                                        fontSize: 9,
                                        fill: rowColor,
                                        fontFace: 'Arial',
                                        valign: 'top',
                                        align: 'left',
                                    },
                                },
                            ])

                            rowHeights.push(rowHeight)
                        }

                        // Render any remaining rows for this category
                        if (currentRows.length > 1) {
                            renderSlide(tempCategoryMap[category].name, currentRows)
                        }
                    }
                })()
                break
            }
            case vnsDisplayName: // vmsDisplayName + ' + Evidence Statements + Citations'
                createSummarySlide(pptx, valueNarratives, uniqueSubpopulations, subpopulationStyles)

                function getTotalRowHeight(rowHeights) {
                    return rowHeights.reduce((sum, h) => sum + h, 0)
                }

                for (let category of valueNarratives) {
                    for (let narrative of category.valueNarratives) {
                        const style = subpopulationStyles[narrative.subpopulation]

                        // const MAX_ROWS_PER_SLIDE = 5;
                        const MAX_CHARS_PER_SLIDE = 1800 // Testing threshold for pagination
                        const MAX_TABLE_HEIGHT = 3.0 // Adjust this based on the slide space available (if no logos or no text box at bottom)

                        function createSlideWithVN(category, narrative, style) {
                            const slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                            addLegendToSlide(slide, uniqueSubpopulations, subpopulationStyles) // Tyler replacing Legend details with helper function

                            // Category label
                            slide.addText([{ text: category.name, options: { bold: true, fontSize: 12 } }], {
                                x: 0.5,
                                y: 1,
                                w: 3,
                                h: 0.3,
                                align: 'left',
                            })

                            // Value Narrative
                            slide.addText(narrative.name, {
                                x: 0.5,
                                y: 1.33,
                                w: '90%',
                                h: 0.45, // size of the value narrative box
                                fontSize: getFontSizeForText(narrative.name, 250, 10, 7),
                                align: 'left',
                                color: '000000',
                                fill: { color: style.fill },
                                line: { color: style.line },
                                breakLine: true,
                            })

                            return slide
                        }

                        let currentSlide = createSlideWithVN(category, narrative, style)
                        let currentRowCount = 0
                        let currentCharCount = 0

                        // ✅ DEFINE HEADERS WITH THE CORRECT SUBPOPULATION BORDER COLOR
                        const headers = [
                            [
                                {
                                    text: vmsDisplayName,
                                    options: {
                                        fill: backgroundColor,
                                        color: textColor,
                                        align: 'left',
                                        bold: true,
                                        border: [
                                            { color: 'FFFFFF' }, // Top
                                            { color: 'FFFFFF' }, // Right
                                            { color: style.line, pt: 2 }, // Bottom (subpopulation)
                                            { color: 'FFFFFF' }, // Left
                                        ],
                                    },
                                },
                                {
                                    text: 'Key Statements',
                                    options: {
                                        fill: backgroundColor,
                                        color: textColor,
                                        align: 'left',
                                        bold: true,
                                        border: [
                                            { color: 'FFFFFF' },
                                            { color: 'FFFFFF' },
                                            { color: style.line, pt: 2 },
                                            { color: 'FFFFFF' },
                                        ],
                                    },
                                },
                                {
                                    text: 'Citation',
                                    options: {
                                        fill: backgroundColor,
                                        color: textColor,
                                        align: 'left',
                                        bold: true,
                                        border: [
                                            { color: 'FFFFFF' },
                                            { color: 'FFFFFF' },
                                            { color: style.line, pt: 2 },
                                            { color: 'FFFFFF' },
                                        ],
                                    },
                                },
                            ],
                        ]

                        let tableRows = [...headers]
                        let rowHeights = [0.25]

                        const orderedValueMessages = getOrderedValueMessages(narrative.valueMessages) // TKR: adding to get appropriate order

                        for (let vmIdx = 0; vmIdx < orderedValueMessages.length; vmIdx++) {
                            const vm = orderedValueMessages[vmIdx]
                            const vmText = vm.name?.trim() !== '' ? vm.name : `(No ${vmsDisplayName.toLowerCase()})`
                            const fill = vmIdx % 2 === 1 ? 'F2F2F2' : 'FFFFFF'
                            const fontColor = '000000'

                            const kesList = vm.keyEvidenceStatements || []

                            const kesByCitation = {}
                            for (let kes of kesList) {
                                // Defensive check if kes is a string (id) or missing citation
                                if (typeof kes !== 'object' || !kes.statement) continue

                                const citation = kes.parentEvidence?.citation?.trim() || '(No citation)'
                                if (!kesByCitation[citation]) kesByCitation[citation] = []
                                kesByCitation[citation].push(kes.statement.trim())
                            }

                            for (let kes of kesList) {
                                const citation = kes?.parentEvidence?.citation?.trim() || '(No citation)'
                                const link = kes?.parentEvidence?.link
                            }

                            // Replacement starting here
                            const citationGroups = Object.entries(kesByCitation)

                            // If there are neither KES nor linkedEvidence, still create a row with Value Messages
                            if (citationGroups.length === 0) {
                                const hasLinkedEvidence = vm.linkedEvidence?.length > 0
                                const citation = hasLinkedEvidence
                                    ? vm.linkedEvidence[0].citation?.trim() || '(No citation)'
                                    : '(No citations)'
                                const citationLink = hasLinkedEvidence ? vm.linkedEvidence[0].link : undefined

                                const rowOptions = { valign: 'top', fontSize: 9, fill, color: fontColor }

                                // PAGINATE IF NEEDED
                                if (
                                    currentCharCount + vmText.length + citation.length > MAX_CHARS_PER_SLIDE ||
                                    getTotalRowHeight(rowHeights) + 0.4 > MAX_TABLE_HEIGHT
                                ) {
                                    currentSlide.addTable(tableRows, {
                                        x: 0.5,
                                        y: 2.0,
                                        colW: [2.5, 4.5, 2.0],
                                        rowH: rowHeights,
                                        fontSize: 9,
                                        border: { type: 'none' },
                                    })

                                    currentSlide = createSlideWithVN(category, narrative, style)
                                    tableRows = [...headers]
                                    rowHeights = [0.25]
                                    currentRowCount = 0
                                    currentCharCount = 0
                                }

                                tableRows.push([
                                    { text: vmText, options: rowOptions },
                                    { text: '(No key statements)', options: rowOptions },
                                    {
                                        text: citation,
                                        options: {
                                            valign: 'top',
                                            fontSize: 9,
                                            color: citationLink ? '0563C1' : fontColor,
                                            underline: !!citationLink,
                                            hyperlink: citationLink ? { url: citationLink } : undefined,
                                            fill,
                                        },
                                    },
                                ])

                                rowHeights.push(0.4)
                                currentRowCount++
                                currentCharCount += vmText.length + citation.length
                            } else {
                                // Existing case: group KES by citation
                                citationGroups.forEach(([citationText, kesArray], groupIdx) => {
                                    const bulletKES = kesArray.map((kes) => `• ${kes}`).join('\n')
                                    const kesLineCount = bulletKES.split('\n').length
                                    const baseHeight = 0.4
                                    const lineHeight = 0.15
                                    const rowHeight = Math.min(baseHeight + (kesLineCount - 1) * lineHeight, 1.5)

                                    const vmColumnText = groupIdx === 0 ? vmText : ''
                                    const rowCharCount = vmColumnText.length + bulletKES.length + citationText.length

                                    if (
                                        currentCharCount + rowCharCount > MAX_CHARS_PER_SLIDE ||
                                        getTotalRowHeight(rowHeights) + rowHeight > MAX_TABLE_HEIGHT
                                    ) {
                                        currentSlide.addTable(tableRows, {
                                            x: 0.5,
                                            y: 2.0,
                                            colW: [2.5, 4.5, 2.0],
                                            rowH: rowHeights,
                                            fontSize: 9,
                                            border: { type: 'none' },
                                        })

                                        currentSlide = createSlideWithVN(category, narrative, style)
                                        tableRows = [...headers]
                                        rowHeights = [0.25]
                                        currentRowCount = 0
                                        currentCharCount = 0
                                    }

                                    const rowOptions = { valign: 'top', fontSize: 9, fill, color: fontColor }

                                    const citationLink = kesList.find(
                                        (k) =>
                                            typeof k === 'object' &&
                                            k.parentEvidence?.citation?.trim() === citationText &&
                                            k.parentEvidence?.link
                                    )?.parentEvidence.link

                                    const citationCell = {
                                        text: citationText,
                                        options: {
                                            valign: 'top',
                                            fontSize: 9,
                                            color: citationLink ? '0563C1' : fontColor,
                                            underline: !!citationLink,
                                            hyperlink: citationLink ? { url: citationLink } : undefined,
                                            fill,
                                        },
                                    }

                                    tableRows.push([
                                        { text: vmColumnText, options: rowOptions },
                                        { text: bulletKES, options: rowOptions },
                                        citationCell,
                                    ])

                                    rowHeights.push(rowHeight)
                                    currentRowCount++
                                    currentCharCount += rowCharCount
                                })
                            }

                            // FINAL FLUSH OF REMAINING ROWS
                            if (tableRows.length === headers.length) {
                                const hasVMs = orderedValueMessages.length > 0
                                if (!hasVMs) {
                                    tableRows.push([
                                        { text: `(No ${vmsDisplayName.toLowerCase()}s)`, options: { fontSize: 9 } },
                                        { text: '(No key evidence)', options: { fontSize: 9 } },
                                        { text: '(No citation)', options: { fontSize: 9 } },
                                    ])
                                }
                            }

                            currentSlide.addTable(tableRows, {
                                x: 0.5,
                                y: 2.0,
                                w: '90%',
                                colW: [2.5, 4.5, 2.0],
                                rowH: rowHeights,
                                fontSize: 9,
                                border: { type: 'none' },
                            })
                        }
                    }
                }

                break

            case tppDisplayName:
                await (async () => {
                    // -----------------------------
                    // 0) Transformation function for live DB data
                    // -----------------------------
                    // Shifted the transformation function step out and into the helper function file so that it can be used by both this and the fulfillment metrics slide

                    // -----------------------------
                    // 1) Data source
                    // -----------------------------
                    let trppData
                    let tppRes, rowsRes, slotsRes, columnsRes, cellsRes
                    let roadmapId

                    try {
                        const strategy = store.getState().strategy
                        roadmapId = strategy?._id
                        const assetName = `${strategy?.product || ''} for ${strategy?.indication || ''}`.trim()

                        if (!roadmapId) throw new Error('No strategy selected')

                        const tppIdRes = await callSecureAPI(`/api/tpps/roadmap/${roadmapId}`, 'get', token)
                        if (!tppIdRes.success || !tppIdRes.data) {
                            throw new Error('Could not retrieve TPP for this strategy')
                        }

                        const tppId = tppIdRes.data

                        const [tppResLocal, columnsResLocal, sectionsRes, rowsResLocal, slotsResLocal, cellsResLocal] =
                            await Promise.all([
                                callSecureAPI(`/api/tpps/${tppId}`, 'get', token),
                                callSecureAPI(`/api/tpps/columns/${tppId}`, 'get', token),
                                callSecureAPI(`/api/tpps/sections/${tppId}`, 'get', token),
                                callSecureAPI(`/api/tpps/rows/${tppId}`, 'get', token),
                                callSecureAPI(`/api/tpps/slots/${tppId}`, 'get', token),
                                callSecureAPI(`/api/tpps/cells/${tppId}`, 'get', token),
                            ])

                        tppRes = tppResLocal
                        columnsRes = columnsResLocal
                        rowsRes = rowsResLocal
                        slotsRes = slotsResLocal
                        cellsRes = cellsResLocal

                        console.log('[TrPP JSON] first cell:', cellsRes?.data?.[0])

                        console.log(
                            '[TrPP JSON] cells with possible links:',
                            (cellsRes?.data || []).filter(
                                (cell) =>
                                    cell?.linkedActivities?.length ||
                                    cell?.linkedEvidence?.length ||
                                    cell?.linkedValueMessages?.length ||
                                    cell?.activities?.length ||
                                    cell?.evidence?.length ||
                                    cell?.valueMessages?.length
                            )
                        )

                        if (!tppRes.success) throw new Error('Failed to fetch TPP data')

                        // Fetch missing slots referenced by rows but not returned
                        const fetchedSlotIds = new Set((slotsRes.data || []).map((s) => s._id.toString()))
                        const allReferencedSlotIds = (rowsRes.data || [])
                            .flatMap((r) => r.slotIds || [])
                            .map((id) => id.toString())

                        const missingSlotIds = allReferencedSlotIds.filter((id) => !fetchedSlotIds.has(id))

                        if (missingSlotIds.length > 0) {
                            const missingSlotResults = await Promise.all(
                                missingSlotIds.map((slotId) =>
                                    callSecureAPI(`/api/tpps/slot/${slotId}`, 'get', token).catch(() => null)
                                )
                            )

                            const foundMissingSlots = missingSlotResults
                                .filter((res) => res?.success && res?.data)
                                .map((res) => res.data)

                            if (foundMissingSlots.length > 0) {
                                slotsRes.data = [...(slotsRes.data || []), ...foundMissingSlots]
                            }
                        }

                        trppData = transformLiveTppDataForExport({
                            tpp: tppRes.data,
                            columns: columnsRes.data || [],
                            sections: sectionsRes.data || [],
                            rows: rowsRes.data || [],
                            slots: slotsRes.data || [],
                            cells: cellsRes.data || [],
                            assetName,
                        })
                    } catch (err) {
                        console.error('Error fetching TPP data for export:', err)
                        cannotExportPPTX(`Failed to load TPP data: ${err.message}`)
                        return
                    }

                    // enrichTrppDataForExecSummary, stripControlChars
                    // Shifted to separate file:
                    // Removed as unnecessary:
                    // cleanOneLine
                    // getTotalRowHeight
                    // buildRuns
                    // estimateHeightFromRuns
                    // countCharsForRuns
                    // groupHasAnyBullets
                    //
                    // Shifting these into helper functions in the new pptTPPHelpers.js

                    // -----------------------------
                    // 3) Rendering constants + helpers
                    // -----------------------------
                    const fontFace = 'Arial'
                    const SLIDE_W = 10.0
                    const SLIDE_H = 5.625

                    const NORMAL_TEXT_COLOR = '000000'
                    const HIGHLIGHT_COLOR = '268500'
                    const EXEC_BULLET_COLOR = NORMAL_TEXT_COLOR

                    const ATTRIBUTE_BG = '2F3A4A'
                    const ATTRIBUTE_FG = 'FFFFFF'

                    const CATEGORY_X = 0.0
                    const CATEGORY_Y = 0.7

                    const TABLE_Y = 0.95
                    const BOTTOM_PADDING = 0.0
                    const MAX_TABLE_HEIGHT = SLIDE_H - TABLE_Y - BOTTOM_PADDING

                    const HEADER_ROW_H = 0.28
                    const BASE_ROW_H = 0.42
                    const LINE_INC = 0.16

                    const MAX_SLIDE_CHARS = 1000
                    const MAX_ROW_CHARS = 1000

                    function estimateChunkRowHeight(
                        attrRuns,
                        chunkByScenarioId,
                        scenarios,
                        { bulletFontSize = 9 } = {}
                    ) {
                        const heights = scenarios.map((s) => {
                            const runs = buildTppBulletRuns(chunkByScenarioId[s.id] || [], {
                                fontSize: bulletFontSize,
                                highlightColor: HIGHLIGHT_COLOR,
                                normalTextColor: NORMAL_TEXT_COLOR,
                            })

                            return estimateTppHeightFromRuns(runs, {
                                charsPerLine: 34,
                                baseRowH: BASE_ROW_H,
                                lineInc: LINE_INC,
                                maxH: MAX_TABLE_HEIGHT - HEADER_ROW_H,
                            })
                        })

                        const attrH = estimateTppHeightFromRuns(attrRuns, {
                            charsPerLine: 28,
                            baseRowH: BASE_ROW_H,
                            lineInc: LINE_INC,
                            maxH: MAX_TABLE_HEIGHT - HEADER_ROW_H,
                        })

                        return Math.max(attrH, ...heights, 0.38)
                    }

                    function createBaseSlide({
                        categoryName,
                        tableX,
                        tableW,
                        versionFontSize = 7,
                        versionBoxH = 0.18,
                        categoryFontSize = 12,
                        masterName,
                    }) {
                        const slide = pptx.addSlide({ masterName })

                        slide.addText(categoryName || '(Untitled)', {
                            x: CATEGORY_X,
                            y: CATEGORY_Y,
                            w: 6.8,
                            h: 0.25,
                            fontFace,
                            fontSize: categoryFontSize,
                            bold: true,
                            color: textColor,
                            align: 'left',
                        })

                        const nextApDate = '2026-01-01' // <- set dynamically later if you have it
                        const versionText = `Version X • Next AP: ${nextApDate}`
                        slide.addText(versionText, {
                            x: tableX + tableW - 3.0,
                            y: 0.78, // your tuning point for Version box Y
                            w: 3.0,
                            h: versionBoxH,
                            fontFace,
                            fontSize: versionFontSize,
                            bold: true,
                            color: textColor,
                            align: 'right',
                            valign: 'bottom',
                        })

                        return slide
                    }

                    // If there is no profile named 'Asset Profile' then this will break.
                    // If there is no attribute named 'mechanism of action' then this will break.
                    // Likely will need some more dynamic approach (labeling a column as the "Asset Profile" and configuring which attribute name is the MOA
                    function extractMechanismOfActionFromTrpp(normalizedFull) {
                        const assetScenario = (normalizedFull.scenarios || []).find(
                            (s) => (s.name || '').trim() === 'Asset Profile'
                        )
                        const assetId = assetScenario?.id

                        const moaAttr = (normalizedFull.categories || [])
                            .flatMap((c) => c.attributes || [])
                            .find((a) => (a.name || '').trim().toLowerCase() === 'mechanism of action')

                        if (!moaAttr || !assetId) return ''

                        const collected = []
                        for (const g of moaAttr.groups || []) {
                            const arr = g.bulletsByScenarioId?.[assetId] || []
                            collected.push(...arr.map((b) => b.text).filter(Boolean))
                        }
                        if (collected.length) return collected.join(' ')

                        for (const g of moaAttr.groups || []) {
                            for (const s of normalizedFull.scenarios || []) {
                                const arr = g.bulletsByScenarioId?.[s.id] || []
                                const txt = arr.map((b) => b.text).filter(Boolean)
                                if (txt.length) return txt.join(' ')
                            }
                        }
                        return ''
                    }

                    // -----------------------------
                    // 5) Enrich + Normalize
                    // -----------------------------
                    trppData = enrichTppDataForExecSummary(trppData, {
                        tppRes,
                        rows: rowsRes?.data || [],
                        slots: slotsRes?.data || [],
                    })

                    const normalizedFull = normalizeTppForStandardExport(trppData, {
                        highlightedOnly: false,
                        includeSlotContext: true,
                        includeAttributeInfo: true,
                    })

                    const normalizedExec = normalizeTppForStandardExport(trppData, {
                        highlightedOnly: true,
                        includeSlotContext: true,
                        includeAttributeInfo: true,
                    })

                    if (!normalizedFull) {
                        cannotExportPPTX('TPP data is missing or malformed.')
                        return
                    }

                    // -----------------------------
                    // 6) EXEC SUMMARY (DROP-IN, SELF-CONTAINED -> fixes ESLint no-undef)
                    // -----------------------------
                    ;(function renderExecutiveSummary() {
                        const baseId = (normalizedFull.scenarios || []).find(
                            (s) => (s.name || '').trim() === 'Base Case'
                        )?.id
                        const bestId = (normalizedFull.scenarios || []).find(
                            (s) => (s.name || '').trim() === 'Best Case'
                        )?.id
                        const assetId = (normalizedFull.scenarios || []).find(
                            (s) => (s.name || '').trim() === 'Asset Profile'
                        )?.id

                        if (!baseId || !bestId || !assetId) {
                            console.warn(
                                '[EXEC SUMMARY] Could not map Base/Best/Asset scenario IDs; skipping exec summary.'
                            )
                            return
                        }

                        // TKR Updating to address Tim's bugs//
                        const execAttrs = (normalizedExec.categories || []).flatMap((c) => c.attributes || [])
                        const fullAttrs = (normalizedFull.categories || []).flatMap((c) => c.attributes || [])

                        const execAttrKeys = new Set(
                            execAttrs.map(
                                (a) => `${(a.categoryName || '').toLowerCase()}|${(a.name || '').toLowerCase()}`
                            )
                        )

                        const allAttrs = fullAttrs.filter((a) =>
                            execAttrKeys.has(`${(a.categoryName || '').toLowerCase()}|${(a.name || '').toLowerCase()}`)
                        )

                        const UPDATES_W = SLIDE_W / 6
                        const TABLE_X = UPDATES_W
                        const TABLE_W = SLIDE_W - UPDATES_W
                        const EXEC_COL_W = Array(5).fill(TABLE_W / 5)

                        const execCategoryFontSize = 9
                        const execBulletFontSize = 8
                        const execHeaderFontSize = 9
                        const execTableFontSize = 8

                        const execAttributeCellOptions = {
                            valign: 'top',
                            fontSize: 9,
                            fill: ATTRIBUTE_BG,
                            color: ATTRIBUTE_FG,
                            bold: true,
                            align: 'left',
                        }

                        const standardCellOptions = (fill, fontSize) => ({
                            valign: 'top',
                            fontSize,
                            fill,
                            color: NORMAL_TEXT_COLOR,
                            align: 'left',
                        })

                        function groupHasExecDifferentiation(g) {
                            return [baseId, bestId, assetId].some((scenarioId) =>
                                (g.bulletsByScenarioId?.[scenarioId] || []).some((b) => b?.isHighlighted)
                            )
                        }

                        function buildCommentsBulletsFromGroups(groups) {
                            const texts = []
                            for (const g of groups || []) {
                                const c = (g.slotContext || '').toString().trim()
                                if (c) texts.push(c)
                            }
                            const seen = new Set()
                            const unique = []
                            for (const t of texts) {
                                const k = t.toLowerCase()
                                if (seen.has(k)) continue
                                seen.add(k)
                                unique.push({ text: t, isHighlighted: false })
                            }
                            return unique
                        }

                        // =====================================================
                        // Exec chrome helpers (IN-SCOPE to this IIFE -> ESLint OK)
                        // =====================================================
                        function addExecSummaryTopBoxesSquare(slide, opts = {}) {
                            const {
                                assetAmbition = '',
                                mechanismOfAction = '',
                                topY = 0.1,
                                boxH = 0.6,
                                rightPadding = 0.1,
                                gapBetweenPairs = 0.1,
                            } = opts

                            const stroke = ATTRIBUTE_BG
                            const labelFill = ATTRIBUTE_BG
                            const labelTextColor = 'FFFFFF'

                            const labelW = 0.78
                            const gapLabelToValue = 0.0
                            const ambitionValueW = 2.35
                            const moaValueW = 2.55

                            const totalW =
                                labelW +
                                gapLabelToValue +
                                ambitionValueW +
                                gapBetweenPairs +
                                labelW +
                                gapLabelToValue +
                                moaValueW

                            const startX = SLIDE_W - rightPadding - totalW

                            const ambLabelX = startX
                            const ambValueX = ambLabelX + labelW + gapLabelToValue

                            const moaLabelX = ambValueX + ambitionValueW + gapBetweenPairs
                            const moaValueX = moaLabelX + labelW + gapLabelToValue

                            // background shapes
                            slide.addShape(pptx.ShapeType.rect, {
                                x: ambLabelX,
                                y: topY,
                                w: labelW,
                                h: boxH,
                                fill: { color: labelFill },
                                line: { color: stroke, pt: 1 },
                            })
                            slide.addShape(pptx.ShapeType.rect, {
                                x: ambValueX,
                                y: topY,
                                w: ambitionValueW,
                                h: boxH,
                                fill: { color: 'FFFFFF' },
                                line: { color: stroke, pt: 1 },
                            })
                            slide.addShape(pptx.ShapeType.rect, {
                                x: moaLabelX,
                                y: topY,
                                w: labelW,
                                h: boxH,
                                fill: { color: labelFill },
                                line: { color: stroke, pt: 1 },
                            })
                            slide.addShape(pptx.ShapeType.rect, {
                                x: moaValueX,
                                y: topY,
                                w: moaValueW,
                                h: boxH,
                                fill: { color: 'FFFFFF' },
                                line: { color: stroke, pt: 1 },
                            })

                            // label text
                            slide.addText('Asset\nAmbition', {
                                x: ambLabelX,
                                y: topY + 0.06,
                                w: labelW,
                                h: boxH - 0.12,
                                fontFace,
                                fontSize: 7,
                                bold: true,
                                color: labelTextColor,
                                align: 'left',
                                valign: 'mid',
                            })

                            slide.addText('Mechanism\nof Action', {
                                x: moaLabelX,
                                y: topY + 0.06,
                                w: labelW,
                                h: boxH - 0.12,
                                fontFace,
                                fontSize: 7,
                                bold: true,
                                color: labelTextColor,
                                align: 'left',
                                valign: 'mid',
                            })

                            // value text
                            const ambText = cleanTppOneLine(assetAmbition || '')
                            const moaText = cleanTppOneLine(mechanismOfAction || '')

                            slide.addText(ambText ? `• ${ambText}` : '', {
                                x: ambValueX,
                                y: topY,
                                w: ambitionValueW,
                                h: boxH,
                                fontFace,
                                fontSize: 7,
                                bold: false,
                                color: textColor,
                                align: 'left',
                                valign: 'top',
                            })

                            slide.addText(moaText ? `• ${moaText}` : '', {
                                x: moaValueX,
                                y: topY,
                                w: moaValueW,
                                h: boxH,
                                fontFace,
                                fontSize: 7,
                                bold: false,
                                color: textColor,
                                align: 'left',
                                valign: 'top',
                            })
                        }

                        function addExecSummaryImportantUpdates(slide, opts = {}) {
                            const { updatesBox } = opts
                            if (!updatesBox) return

                            const x = updatesBox.x
                            const y = updatesBox.y
                            const w = updatesBox.w
                            const h = updatesBox.h

                            slide.addShape(pptx.ShapeType.rect, {
                                x,
                                y,
                                w,
                                h,
                                fill: { color: 'DAE3F3' },
                                line: { color: ATTRIBUTE_BG, pt: 1 },
                            })

                            slide.addText('Important Updates', {
                                x,
                                y: y + 0.05,
                                w,
                                h: 0.2,
                                fontFace,
                                fontSize: 8,
                                bold: true,
                                color: textColor,
                                align: 'left',
                            })

                            slide.addText('• [Enter any important update since most recent version.]', {
                                x,
                                y: y + 0.28,
                                w,
                                h: h - 0.35,
                                fontFace,
                                fontSize: 7,
                                bold: false,
                                color: '666666',
                                align: 'left',
                                valign: 'top',
                            })
                        }

                        function createExecSlide() {
                            const slide = createBaseSlide({
                                categoryName: 'Executive Summary',
                                tableX: TABLE_X,
                                tableW: TABLE_W,
                                versionFontSize: 7,
                                versionBoxH: 0.18,
                                categoryFontSize: execCategoryFontSize,
                                masterName: 'TrPP_SLIDE',
                            })

                            // SAME HEIGHT as "Executive Summary" but shifted right to TABLE_X
                            slide.addText('Key Elements for Differentiation', {
                                x: TABLE_X,
                                y: CATEGORY_Y,
                                w: 6.0,
                                h: 0.25,
                                fontFace,
                                fontSize: execCategoryFontSize,
                                bold: true,
                                color: textColor,
                                align: 'left',
                            })

                            addExecSummaryTopBoxesSquare(slide, {
                                assetAmbition: normalizedFull.assetAmbition || '',
                                mechanismOfAction: extractMechanismOfActionFromTrpp(normalizedFull),
                                topY: 0.1,
                                boxH: 0.6,
                                gapBetweenPairs: 0.1,
                                rightPadding: 0.1,
                            })

                            return slide
                        }

                        function flushExecTable(slide, tableRows, rowHeights) {
                            flushTppTable(slide, pptx, tableRows, rowHeights, {
                                x: TABLE_X,
                                y: TABLE_Y,
                                w: TABLE_W,
                                colW: EXEC_COL_W,
                                fontSize: execTableFontSize,
                                slideW: SLIDE_W,
                            })

                            // redraw after table so outline always visible
                            addExecSummaryImportantUpdates(slide, {
                                updatesBox: { x: 0.0, y: TABLE_Y, w: UPDATES_W, h: 4.0 },
                            })
                        }

                        let slide = createExecSlide()

                        const headers = makeTppHeaderRow({
                            headers: ['Elements', 'Base Case', 'Best Case', 'Asset Profile', 'Comments'],
                            headerFontSize: execHeaderFontSize,
                        })

                        let tableRows = [...headers]
                        let rowHeights = [HEADER_ROW_H]
                        let slideCharsUsed = 0

                        const execScenarios = [
                            { id: baseId, name: 'Base Case' },
                            { id: bestId, name: 'Best Case' },
                            { id: assetId, name: 'Asset Profile' },
                            { id: '__COMMENTS__', name: 'Comments' },
                        ]

                        for (let aIdx = 0; aIdx < allAttrs.length; aIdx++) {
                            const attr = allAttrs[aIdx]

                            const hasAny = (attr.groups || []).some((g) =>
                                [baseId, bestId, assetId].some((scenarioId) =>
                                    (g.bulletsByScenarioId?.[scenarioId] || []).some((b) => b?.isHighlighted)
                                )
                            )
                            if (!hasAny) continue

                            const fill = aIdx % 2 === 0 ? 'FFFFFF' : 'F2F2F2'
                            const baseCell = standardCellOptions(fill, execBulletFontSize)

                            let groups = Array.isArray(attr.groups)
                                ? attr.groups.filter(groupHasExecDifferentiation)
                                : []

                            if (!groups.length) continue

                            let gStart = 0
                            let continuedOnNewSlide = false

                            while (gStart < groups.length) {
                                let gEnd = Math.min(groups.length, gStart + 1)

                                while (gEnd < groups.length) {
                                    const chunkGroups = groups.slice(gStart, gEnd + 1)

                                    const chunkByScenarioId = {
                                        [baseId]: [],
                                        [bestId]: [],
                                        [assetId]: [],
                                        __COMMENTS__: [],
                                    }

                                    for (const grp of chunkGroups) {
                                        chunkByScenarioId[baseId].push(...(grp.bulletsByScenarioId?.[baseId] || []))
                                        chunkByScenarioId[bestId].push(...(grp.bulletsByScenarioId?.[bestId] || []))
                                        chunkByScenarioId[assetId].push(...(grp.bulletsByScenarioId?.[assetId] || []))
                                    }
                                    chunkByScenarioId.__COMMENTS__ = buildCommentsBulletsFromGroups(chunkGroups)

                                    const runsByScenario = execScenarios.map((s) => {
                                        const bullets =
                                            s.id === '__COMMENTS__'
                                                ? chunkByScenarioId.__COMMENTS__
                                                : chunkByScenarioId[s.id]
                                        return buildTppBulletRuns(bullets, {
                                            highlightColor: HIGHLIGHT_COLOR,
                                            normalTextColor: NORMAL_TEXT_COLOR,
                                            fontSize: execBulletFontSize,
                                        })
                                    })

                                    const tryChars = Math.max(0, ...runsByScenario.map(countTppCharsForRuns))
                                    const attrRuns = [
                                        { text: attr.name, options: { bold: true, color: ATTRIBUTE_FG, fontSize: 9 } },
                                    ]
                                    const tryH = estimateChunkRowHeight(attrRuns, chunkByScenarioId, execScenarios, {
                                        bulletFontSize: execBulletFontSize,
                                    })

                                    const wouldOverflowChars = slideCharsUsed + tryChars > MAX_SLIDE_CHARS
                                    const wouldOverflowHeight =
                                        getTppTotalRowHeight(rowHeights) + tryH > MAX_TABLE_HEIGHT
                                    if (wouldOverflowChars || wouldOverflowHeight) break

                                    gEnd++
                                }

                                const chunkGroups = groups.slice(gStart, gEnd)
                                const chunkByScenarioId = {
                                    [baseId]: [],
                                    [bestId]: [],
                                    [assetId]: [],
                                    __COMMENTS__: [],
                                }
                                for (const grp of chunkGroups) {
                                    chunkByScenarioId[baseId].push(...(grp.bulletsByScenarioId?.[baseId] || []))
                                    chunkByScenarioId[bestId].push(...(grp.bulletsByScenarioId?.[bestId] || []))
                                    chunkByScenarioId[assetId].push(...(grp.bulletsByScenarioId?.[assetId] || []))
                                }
                                chunkByScenarioId.__COMMENTS__ = buildCommentsBulletsFromGroups(chunkGroups)

                                const runsByScenario = execScenarios.map((s) => {
                                    const bullets =
                                        s.id === '__COMMENTS__'
                                            ? chunkByScenarioId.__COMMENTS__
                                            : chunkByScenarioId[s.id]
                                    return buildTppBulletRuns(bullets, {
                                        highlightColor: HIGHLIGHT_COLOR,
                                        normalTextColor: NORMAL_TEXT_COLOR,
                                        fontSize: execBulletFontSize,
                                    })
                                })

                                const chunkChars = Math.max(0, ...runsByScenario.map(countTppCharsForRuns))
                                const attrRuns = [
                                    { text: attr.name, options: { bold: true, color: ATTRIBUTE_FG, fontSize: 9 } },
                                ]
                                const rowH = estimateChunkRowHeight(attrRuns, chunkByScenarioId, execScenarios, {
                                    bulletFontSize: execBulletFontSize,
                                })

                                const chunkTooBig = chunkChars > MAX_ROW_CHARS
                                const needsNewSlide =
                                    chunkTooBig ||
                                    slideCharsUsed + chunkChars > MAX_SLIDE_CHARS ||
                                    getTppTotalRowHeight(rowHeights) + rowH > MAX_TABLE_HEIGHT

                                if (needsNewSlide && tableRows.length > headers.length) {
                                    flushExecTable(slide, tableRows, rowHeights)
                                    slide = createExecSlide()

                                    tableRows = [...headers]
                                    rowHeights = [HEADER_ROW_H]
                                    slideCharsUsed = 0
                                    continuedOnNewSlide = true
                                }

                                const scenarioCells = runsByScenario.map((runs) =>
                                    runs.length ? { text: runs, options: baseCell } : { text: '', options: baseCell }
                                )
                                const attrLabel = gStart === 0 || continuedOnNewSlide ? attr.name : ''

                                tableRows.push([
                                    { text: attrLabel, options: execAttributeCellOptions },
                                    ...scenarioCells,
                                ])
                                rowHeights.push(rowH)
                                slideCharsUsed += chunkChars

                                continuedOnNewSlide = false
                                gStart = gEnd
                            }
                        }

                        if (tableRows.length > headers.length) {
                            flushExecTable(slide, tableRows, rowHeights)
                        }
                    })()

                    // -----------------------------
                    // 7) MAIN TrPP
                    // -----------------------------
                    ;(function renderMainTrpp() {
                        const normalized = normalizedFull

                        const TABLE_X = 0.0
                        const TABLE_W = SLIDE_W
                        const colW = [2, 2, 2, 2, 2]

                        const attributeCellOptions = {
                            valign: 'top',
                            fontSize: 10,
                            fill: ATTRIBUTE_BG,
                            color: ATTRIBUTE_FG,
                            bold: false,
                            align: 'left',
                        }

                        const standardCellOptions = (fill) => ({
                            valign: 'top',
                            fontSize: 9,
                            fill,
                            color: NORMAL_TEXT_COLOR,
                            align: 'left',
                        })

                        function createSlideMain(categoryName) {
                            const slide = pptx.addSlide({ masterName: 'TrPP_SLIDE' })

                            slide.addText(categoryName || '(Untitled category)', {
                                x: CATEGORY_X,
                                y: CATEGORY_Y,
                                w: 6.8,
                                h: 0.25,
                                fontFace,
                                fontSize: 12,
                                bold: true,
                                color: textColor,
                                align: 'left',
                            })

                            const nextApDate = '2026-01-01' // <- set dynamically later if you have it
                            const versionText = `Version X • Next AP: ${nextApDate}`
                            slide.addText(versionText, {
                                x: TABLE_X + TABLE_W - 3.0,
                                y: 0.78,
                                w: 3.0,
                                h: 0.18,
                                fontFace,
                                fontSize: 7,
                                bold: true,
                                color: textColor,
                                align: 'right',
                                valign: 'bottom',
                            })

                            // your callout tuning stays
                            const boxW = 3.5
                            const offRight = 0.0
                            const insetRight = 0.1
                            const boxH = 0.45
                            const boxY = 0.1

                            const boxX = SLIDE_W - boxW - insetRight // Makes the green box and text box slightly left of the right edge

                            slide.addShape(pptx.ShapeType.rect, {
                                x: boxX,
                                y: boxY,
                                w: boxW,
                                h: boxH,
                                fill: { color: 'EAF7EA' },
                                line: { color: 'B7E3B7', pt: 1 },
                            })

                            slide.addText(
                                'Green text represents elements that most significantly impact differentiation.',
                                {
                                    x: boxX,
                                    y: boxY + 0.03,
                                    w: boxW,
                                    h: boxH - 0.1,
                                    fontFace,
                                    fontSize: 8,
                                    color: textColor,
                                    align: 'right',
                                    valign: 'top',
                                }
                            )

                            return slide
                        }

                        function makeHeaderRowMain(scenarios) {
                            return makeTppHeaderRow({
                                headers: ['', ...(scenarios || []).map((s) => s.name)],
                                tableFill: backgroundColor,
                                textColor,
                            })
                        }

                        // Main updates:
                        // - info not bold (Written to not be bold but still is bold.
                        // - remove double spacing: put newline only on name run
                        function buildAttributeCellText(attr) {
                            const name = (attr?.name || '').toString().trim()
                            const info = (attr?.info || '').toString().trim()

                            // ALWAYS return rich text so we control bolding consistently
                            if (!info) {
                                return [
                                    {
                                        text: name,
                                        options: { bold: true, color: ATTRIBUTE_FG, fontSize: 10 },
                                    },
                                ]
                            }

                            return [
                                {
                                    text: name,
                                    options: { bold: true, color: ATTRIBUTE_FG, fontSize: 10 },
                                },
                                {
                                    // put info on next line ONLY when it exists
                                    text: `${cleanTppOneLine(info)}`,
                                    options: { bold: false, color: ATTRIBUTE_FG, fontSize: 6 },
                                },
                            ]
                        }

                        for (const cat of normalized.categories) {
                            let slide = createSlideMain(cat.name)

                            const headers = makeHeaderRowMain(normalized.scenarios)
                            let tableRows = [...headers]
                            let rowHeights = [HEADER_ROW_H]

                            let slideCharsUsed = 0
                            let emptyAttrsOnSlide = 0
                            const MAX_EMPTY_ATTRS_PER_SLIDE = 5
                            const EMPTY_ATTR_ROW_H = 0.4

                            const attrs = cat.attributes || []
                            const safeAttrs = attrs.length
                                ? attrs
                                : [{ name: '(No attributes)', info: '', groups: [], bulletsByScenarioId: {} }]
                            const scenarios = normalized.scenarios

                            for (let aIdx = 0; aIdx < safeAttrs.length; aIdx++) {
                                const attr = safeAttrs[aIdx]
                                const fill = aIdx % 2 === 0 ? 'FFFFFF' : 'F2F2F2'
                                const base = standardCellOptions(fill)

                                let groups = Array.isArray(attr.groups) ? attr.groups : []

                                if (!groups.length)
                                    groups = [{ rowId: 'fallback', slotContext: '', bulletsByScenarioId: {} }]

                                let gStart = 0
                                let continuedOnNewSlide = false

                                const isEmptyAttribute = groups.every((g) => !tppGroupHasAnyBullets(g, scenarios))

                                if (isEmptyAttribute) {
                                    emptyAttrsOnSlide++

                                    if (
                                        emptyAttrsOnSlide > MAX_EMPTY_ATTRS_PER_SLIDE &&
                                        tableRows.length > headers.length
                                    ) {
                                        flushTppTable(slide, pptx, tableRows, rowHeights, {
                                            x: TABLE_X,
                                            y: TABLE_Y,
                                            w: TABLE_W,
                                            colW,
                                            fontSize: 9,
                                            slideW: SLIDE_W,
                                        })
                                        slide = createSlideMain(cat.name)
                                        tableRows = [...headers]
                                        rowHeights = [HEADER_ROW_H]
                                        slideCharsUsed = 0
                                        emptyAttrsOnSlide = 1
                                    }

                                    if (
                                        getTppTotalRowHeight(rowHeights) + EMPTY_ATTR_ROW_H > MAX_TABLE_HEIGHT &&
                                        tableRows.length > headers.length
                                    ) {
                                        flushTppTable(slide, pptx, tableRows, rowHeights, {
                                            x: TABLE_X,
                                            y: TABLE_Y,
                                            w: TABLE_W,
                                            colW,
                                            fontSize: 9,
                                            slideW: SLIDE_W,
                                        })
                                        slide = createSlideMain(cat.name)
                                        tableRows = [...headers]
                                        rowHeights = [HEADER_ROW_H]
                                        slideCharsUsed = 0
                                        emptyAttrsOnSlide = 1
                                    }

                                    const scenarioCells = scenarios.map(() => ({ text: '', options: base }))
                                    tableRows.push([
                                        { text: buildAttributeCellText(attr), options: attributeCellOptions },
                                        ...scenarioCells,
                                    ])
                                    rowHeights.push(EMPTY_ATTR_ROW_H)
                                    continue
                                }

                                while (gStart < groups.length) {
                                    let gEnd = Math.min(groups.length, gStart + 1)

                                    while (gEnd < groups.length) {
                                        const chunkGroups = groups.slice(gStart, gEnd + 1)
                                        const chunkByScenarioId = {}
                                        for (const s of scenarios) chunkByScenarioId[s.id] = []

                                        for (const grp of chunkGroups) {
                                            for (const s of scenarios) {
                                                const arr = grp.bulletsByScenarioId?.[s.id] || []
                                                chunkByScenarioId[s.id].push(...arr)
                                            }
                                        }

                                        const tryRunsByScenario = scenarios.map((s) =>
                                            buildTppBulletRuns(chunkByScenarioId[s.id] || [])
                                        )
                                        const tryChars = Math.max(0, ...tryRunsByScenario.map(countTppCharsForRuns))

                                        const attrRuns = buildAttributeCellText(attr)
                                        const tryH = estimateChunkRowHeight(attrRuns, chunkByScenarioId, scenarios, {
                                            bulletFontSize: 9,
                                        })

                                        const wouldOverflowChars = slideCharsUsed + tryChars > MAX_SLIDE_CHARS
                                        const wouldOverflowHeight =
                                            getTppTotalRowHeight(rowHeights) + tryH > MAX_TABLE_HEIGHT
                                        if (wouldOverflowChars || wouldOverflowHeight) break

                                        gEnd++
                                    }

                                    const chunkGroups = groups.slice(gStart, gEnd)
                                    const chunkByScenarioId = {}
                                    for (const s of scenarios) chunkByScenarioId[s.id] = []

                                    for (const grp of chunkGroups) {
                                        for (const s of scenarios) {
                                            const arr = grp.bulletsByScenarioId?.[s.id] || []
                                            chunkByScenarioId[s.id].push(...arr)
                                        }
                                    }

                                    const runsByScenario = scenarios.map((s) =>
                                        buildTppBulletRuns(chunkByScenarioId[s.id] || [])
                                    )
                                    const chunkChars = Math.max(0, ...runsByScenario.map(countTppCharsForRuns))

                                    const attrRuns = buildAttributeCellText(attr)
                                    const rowH = estimateChunkRowHeight(attrRuns, chunkByScenarioId, scenarios, {
                                        bulletFontSize: 9,
                                    })

                                    const chunkTooBig = chunkChars > MAX_ROW_CHARS
                                    const needsNewSlide =
                                        chunkTooBig ||
                                        slideCharsUsed + chunkChars > MAX_SLIDE_CHARS ||
                                        getTppTotalRowHeight(rowHeights) + rowH > MAX_TABLE_HEIGHT

                                    if (needsNewSlide && tableRows.length > headers.length) {
                                        flushTppTable(slide, pptx, tableRows, rowHeights, {
                                            x: TABLE_X,
                                            y: TABLE_Y,
                                            w: TABLE_W,
                                            colW,
                                            fontSize: 9,
                                            slideW: SLIDE_W,
                                        })
                                        slide = createSlideMain(cat.name)
                                        tableRows = [...headers]
                                        rowHeights = [HEADER_ROW_H]
                                        slideCharsUsed = 0
                                        continuedOnNewSlide = true
                                    }

                                    const scenarioCells = scenarios.map((s, idx) => {
                                        const runs = runsByScenario[idx]
                                        return runs.length ? { text: runs, options: base } : { text: '', options: base }
                                    })

                                    const attrLabel =
                                        gStart === 0 || continuedOnNewSlide ? buildAttributeCellText(attr) : ''
                                    tableRows.push([
                                        { text: attrLabel, options: attributeCellOptions },
                                        ...scenarioCells,
                                    ])
                                    rowHeights.push(rowH)
                                    slideCharsUsed += chunkChars

                                    continuedOnNewSlide = false
                                    gStart = gEnd
                                }

                                const MIN_REMAINING_HEIGHT_FOR_NEXT_ATTR = 0.55
                                const remainingHeight = MAX_TABLE_HEIGHT - getTppTotalRowHeight(rowHeights)
                                if (
                                    remainingHeight < MIN_REMAINING_HEIGHT_FOR_NEXT_ATTR &&
                                    aIdx < safeAttrs.length - 1 &&
                                    tableRows.length > headers.length
                                ) {
                                    flushTppTable(slide, pptx, tableRows, rowHeights, {
                                        x: TABLE_X,
                                        y: TABLE_Y,
                                        w: TABLE_W,
                                        colW,
                                        fontSize: 9,
                                        slideW: SLIDE_W,
                                    })
                                    slide = createSlideMain(cat.name)
                                    tableRows = [...headers]
                                    rowHeights = [HEADER_ROW_H]
                                    slideCharsUsed = 0
                                    emptyAttrsOnSlide = 0
                                }
                            }

                            if (tableRows.length > headers.length) {
                                flushTppTable(slide, pptx, tableRows, rowHeights, {
                                    x: TABLE_X,
                                    y: TABLE_Y,
                                    w: TABLE_W,
                                    colW,
                                    fontSize: 9,
                                    slideW: SLIDE_W,
                                })
                            }
                        }
                    })()
                })()
                break

            // Testing a new export for Aspirational Value Messages and a Timeline
            case 'Aspirational ' + vmsDisplayName + ' + ' + activitiesDisplayName: {
                // isolate scope to avoid cross-case const collisions
                await (async () => {
                    const slideWidth = 10.0
                    const slideHeight = 5.625

                    // ─────────────────────────────────────────────────────────────
                    // USER FILTERS: Control what data appears in the slides
                    // ─────────────────────────────────────────────────────────────
                    // // Short-term vs. Future Design
                    // //    - In the short term, these filters will remain **defaulted** (e.g., to Aspirational VMs and
                    // //      Planned/Ongoing activities).
                    // //    - However, because this logic is fully parameterized, we can
                    // //      *quickly switch* these defaults for users who prefer a different
                    // //      “cut” of the data (e.g., Supported or Retrospective views).
                    // //    - TODO Longer term,
                    // //      this exact structure enables seamless **front-end
                    // //      connections**, where users can adjust filters directly through
                    // //      the UI and instantly regenerate the export with their chosen
                    // //      Value Message and Activity combinations.

                    // This section lets users (or developers) define which Value Messages
                    // and which Activities should appear in the exported deck.
                    //
                    // These filters are used *everywhere* — both in the Gantt chart
                    // and in the per-category tables — to ensure the data shown stays consistent.
                    //
                    // Typical use cases:
                    //
                    // (1) Limit slides by VALUE MESSAGE STATUS
                    //    - Controls which VM tiers are included in the export.
                    //    - Examples:
                    //        ['Aspirational'] → show only aspirational VMs (default)
                    //        ['Supported-suboptimal', 'Supported'] → show only supported VMs
                    //        ['Aspirational', 'Supported'] → show both
                    //
                    // (2) Limit slides by ACTIVITY STATUS
                    //    - Controls which activities are counted as “active” or displayed.
                    //    - Examples:
                    //        ['planned', 'initiated'] → show upcoming work only
                    //        ['ongoing', 'on hold'] → show current + paused projects
                    //        ['completed'] → build a retrospective Gantt
                    //
                    // (3) Combine both filters
                    //    - For example, to show only “Aspirational” VMs that have
                    //      “Planned” or “Initiated” activities, set:
                    //        userFilters = {
                    //          vmStatuses: ['Aspirational'],
                    //          activityStatuses: ['planned','initiated']
                    //        }
                    //
                    // (4) Change filters dynamically from the UI
                    //    - These filters can be connected to dropdowns, checkboxes, or
                    //      multi-select components in the ATLAS interface.
                    //    - When a user updates selections, they’ll flow into
                    //      `store.getState().ppt.filters` and drive this logic.
                    //
                    // (5) The “includeStatuses” array below is passed directly to the
                    //      Gantt helper (`createAspirationalRightGanttSlide`) so that
                    //      filtering rules remain identical between chart and tables.
                    //
                    // Summary of Variables:
                    //  • vmStatusFilter       → which Value Messages are shown
                    //  • activityStatusFilter → which Activities are included
                    //  • includeStatuses      → array version used by the Gantt helper
                    //
                    // ─────────────────────────────────────────────────────────────

                    // USER FILTERS (kept simple; can be wired to UI later)

                    const userFilters = store.getState()?.ppt?.filters ?? {}

                    const vmStatusFilter = new Set(
                        (userFilters.vmStatuses ?? ['Aspirational']) // default: Aspirational only, 'Supported', 'Supported-suboptimal'
                            .map((s) => (s || '').toLowerCase())
                    )

                    // define here to avoid "not defined" later
                    const MAX_ROWS_PER_SLIDE = 7
                    const STATUS_COLOR = {
                        Supported: '09cc9e',
                        'Supported-suboptimal': 'ff9c2b',
                        Aspirational: 'c30a30',
                    }

                    // 1) Fetch activities
                    const activityResponse = await callSecureAPI(
                        endpoints.getActivitiesForTable.url + store.getState().strategy._id,
                        endpoints.getActivitiesForTable.method,
                        token
                    )

                    if (!activityResponse?.success || !Array.isArray(activityResponse.data)) {
                        console.log('[Aspirational] Failed to fetch activities or no data.')
                        return // exit the async IIFE safely (don’t use break)
                    }

                    // ─────────────────────────────────────────────────────────────
                    // CONTROL: Include all statuses or only active ones?
                    //   true  → include *every* status
                    //   false → exclude terminal states (Cancelled/Completed/Terminated if present)
                    // ─────────────────────────────────────────────────────────────
                    const includeAllStatuses = false // Flip as needed, false → exclude terminal states (Cancelled/Completed/Terminated if present)

                    // SAFETY: pull org-aware config defined at top of component (with guards)
                    const SAFE_STATUSES = Array.isArray(activityStatuses) ? activityStatuses : []
                    const SAFE_STYLES = activityStatusStylesBase || {}

                    // Normalizer (handles case and hyphen/space variants)
                    const norm = (s) =>
                        (s || '')
                            .toLowerCase()
                            .replace(/[-_\s]+/g, ' ')
                            .trim()

                    // Allow ONLY these for this export
                    const ALLOWED_STATUSES = new Set([
                        'proposed',
                        'planned',
                        'active',
                        'initiated',
                        'ongoing',
                        'on going',
                        'on-going',
                        'ideation', // Added because these will eventually be included.
                        'on hold',
                        'uncategorized', // defensive fallback for those activities that did not have anything. I think these being missing was confusing the team
                    ])

                    // If the hook hasn't provided statuses yet, derive a seen list from data
                    let observedIds = []
                    if (!SAFE_STATUSES.length) {
                        const seen = new Set(
                            (activityResponse.data || [])
                                .map((a) => getStatusLabel?.(a) || a?.status || a?.activityStatus || 'Uncategorized')
                                .filter(Boolean)
                        )
                        observedIds = Array.from(seen)
                    }

                    // Build includeStatuses from canonical config if present; else from observed,
                    // then trim to the allow-list (normalized).
                    const includeStatuses = (SAFE_STATUSES.length ? SAFE_STATUSES : observedIds).filter((id) =>
                        ALLOWED_STATUSES.has(norm(id))
                    )

                    // Human-readable label for the table header
                    const includeStatusesLabel = includeStatuses.map((id) => SAFE_STYLES[id]?.label || id).join(', ')

                    // 2) Build rows for Gantt + a per-category map for the tables
                    const ganttRows = [] // [{ vm, acts, category }]
                    const categoryRowsMap = {} // { [categoryId]: [{ vm, acts }] }

                    for (const category of getOrderedCategories(tempCategoryMap, tempCategorizedVMs)) {
                        const categoryName = tempCategoryMap?.[category]?.name

                        const categoryData = valueNarratives.find((item) => item?.name === categoryName)

                        const activeNarratives = (categoryData?.valueNarratives || []).filter((narrative) => {
                            const archiveValue =
                                narrative?.archived ?? narrative?.valueMessages?.[0]?.narrative?.archived

                            return archiveValue == null
                        })

                        const vms = activeNarratives
                            .flatMap((narrative) => getOrderedValueMessages(narrative.valueMessages))
                            .filter((vm) => vmStatusFilter.has((vm.status || '').toLowerCase()))

                        const rowsForCat = []
                        for (const vm of vms) {
                            // fetch linked activities
                            let linked = []
                            if (vm?.linkedActivities?.length) {
                                const resp = await callSecureAPI(
                                    endpoints.getLinkedActivities.url,
                                    endpoints.getLinkedActivities.method,
                                    token,
                                    { listOfActivities: vm.linkedActivities }
                                )
                                if (resp?.success) linked = resp.data || []
                            }

                            const acts = (linked || []).filter((a) => {
                                const st = (getStatusLabel?.(a) || a?.status || a?.activityStatus || 'Uncategorized')
                                    .toLowerCase()
                                    .replace(/[-_\s]+/g, ' ')
                                    .trim()
                                return ALLOWED_STATUSES.has(st) && a.startDate && a.endDate
                            })

                            const row = { vm, acts, category } // Updated to show all aspirational value messages in the tables (even those without activities) while only showing those with activities in the Gantt chart.
                            rowsForCat.push(row)

                            if (acts.length) {
                                ganttRows.push(row)
                            }
                        }

                        if (rowsForCat.length) categoryRowsMap[category] = rowsForCat
                    }

                    // 3) Right-side Gantt slide(s) FIRST
                    if (ganttRows.length) {
                        await createAspirationalRightGanttSlide(pptx, ganttRows, SAFE_STYLES, getStatusLabel, {
                            // Dynamic title using display names
                            slideWidth,
                            slideHeight,
                            title: `${vmsDisplayName} + Timeline of ${activitiesDisplayName}`,
                            vmFilterLabel: Array.from(vmStatusFilter).join(', '),

                            // ────────────── LAYOUT & SPACING CONTROLS ──────────────
                            yOffset: 0.75, // vertical offset from title to chart start (inches)
                            chartHeightPct: 0.65, // portion of total slide height used for chart area
                            leftWidthPct: 0.3, // portion of slide width for Value Message column
                            barHeight: 0.15, // height (thickness) of each activity bar
                            stackGap: 0.05, // vertical space between overlapping activity bars
                            rowPadTop: 0.06, // padding above bars per VM row
                            rowPadBottom: 0.06, // padding below bars per VM row
                            minRowH: 0.6, // minimum row height (ensures readability)
                            vmRowGap: 0.1, // spacing between consecutive VM rows
                            centerSingleActivity: true, // center a single activity bar within its row

                            // ────────────── TIME AXIS CONTROLS ──────────────
                            periodLabelMode: 'yearOver', // style of time labels ("yearOver" = quarters/halves under one year)
                            periodFont: 7, // font size for smaller period labels (Q1, H1, etc.)
                            yearFont: 7, // font size for larger year labels (e.g., "2025")
                            timeSplit: 'half', // time division mode ('quarter' | 'half' | 'year')

                            // ────────────── DATE WINDOW OVERRIDES (OPTIONAL) ──────────────
                            startDateOverride: new Date('2025-01-01'), // force chart start (null = auto)
                            endDateOverride: null, // new Date('2027-12-31'), // force chart end (null = auto)
                            padPeriodsBefore: 0, // add blank periods before start
                            padPeriodsAfter: 0, // add blank periods after end
                            clampToOverrides: false, // trim bars outside override window (true to enforce)

                            // ────────────── FONT CONTROLS ──────────────
                            vmListFont: 7, // font size for VM text (left column)
                            actFontMax: 7, // max font size for activity titles on bars
                            actFontMin: 3, // min font size when bars are small

                            // ────────────── FILTERING (MATCHES CASE FILTERS) ──────────────
                            onlyWithActiveActivities: false, // show only active activities (true) or all (false)
                            includeStatuses, // list of canonical status IDs to include (built earlier)
                        })
                    }

                    // 4) Category tables: Value Message | Status | Activities (skip empty categories)
                    for (const category of getOrderedCategories(tempCategoryMap, tempCategorizedVMs)) {
                        const rowsForCat = categoryRowsMap[category] || [] // already filtered
                        if (!rowsForCat.length) continue // no matching rows → no slide

                        let rowColorToggle = false

                        function createSlideWithCategoryHeader(categoryName) {
                            const slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })

                            slide.addText([{ text: categoryName, options: { bold: true, fontSize: 12 } }], {
                                x: 0.05 * slideWidth,
                                y: 0.1 * slideHeight,
                                w: 0.6 * slideWidth,
                                h: 0.04 * slideHeight,
                                align: 'left',
                            })

                            addStatusLegend(slide, {
                                x: 8.9,
                                y: 0.08,
                                labels: [
                                    { label: 'Supported', color: STATUS_COLOR['Supported'] },
                                    { label: 'Supp.-subopt.', color: STATUS_COLOR['Supported-suboptimal'] },
                                    { label: 'Aspirational', color: STATUS_COLOR['Aspirational'] },
                                ],
                            })

                            const headers = [
                                [
                                    {
                                        text: `${vmsDisplayName} (${Array.from(vmStatusFilter).join(', ')})`,
                                        options: {
                                            fill: backgroundColor,
                                            color: '000000',
                                            valign: 'middle',
                                            align: 'left',
                                            bold: true,
                                            border: [
                                                { color: white },
                                                { color: white },
                                                { color: '000000', pt: 2 },
                                                { color: white },
                                            ],
                                        },
                                    },
                                    {
                                        text: 'Status',
                                        options: {
                                            fill: backgroundColor,
                                            color: '000000',
                                            valign: 'middle',
                                            align: 'center',
                                            bold: true,
                                            border: [
                                                { color: white },
                                                { color: white },
                                                { color: '000000', pt: 2 },
                                                { color: white },
                                            ],
                                        },
                                    },
                                    {
                                        // use org-aware, human labels for activity statuses
                                        text: `${activitiesDisplayName} (${includeStatusesLabel})`, //TODO Remove
                                        options: {
                                            fill: backgroundColor,
                                            color: '000000',
                                            valign: 'middle',
                                            align: 'left',
                                            bold: true,
                                            border: [
                                                { color: white },
                                                { color: white },
                                                { color: '000000', pt: 2 },
                                                { color: white },
                                            ],
                                        },
                                    },
                                ],
                            ]

                            return { slide, tableRows: [...headers] }
                        }

                        let { slide: currentSlide, tableRows } = createSlideWithCategoryHeader(
                            getCategoryName(tempCategoryMap, category)
                        )

                        for (let i = 0; i < rowsForCat.length; i++) {
                            const { vm, acts } = rowsForCat[i]
                            const rowColor = rowColorToggle ? grey : white
                            rowColorToggle = !rowColorToggle

                            // status dot color for VM column (unchanged; VM status colors)
                            const statusColor =
                                STATUS_COLOR[vm.status] ||
                                STATUS_COLOR[(vm.status || '').replace(/^\w/, (c) => c.toUpperCase())] ||
                                textColor

                            const statusDot = {
                                text: '◉',
                                options: {
                                    fontSize: 14,
                                    fontFace: 'Arial',
                                    color: statusColor,
                                    align: 'center', // Push to the top to see if that looks better
                                    valign: 'top',
                                    fill: rowColor,
                                },
                            }

                            const bullets = acts.length
                                ? acts.map((a) => `• ${getActivityDisplayLabel(a)}`).join('\n')
                                : `-`

                            tableRows.push([
                                { text: vm.name, options: { fontSize: 9, fill: rowColor } },
                                statusDot,
                                { text: bullets, options: { fill: rowColor } },
                            ])

                            // paginate
                            if (tableRows.length > MAX_ROWS_PER_SLIDE + 1) {
                                currentSlide.addTable(tableRows, {
                                    x: 0.05 * slideWidth,
                                    y: 0.14 * slideHeight,
                                    colW: [0.35 * slideWidth, 0.07 * slideWidth, 0.48 * slideWidth],
                                    rowH: [0.25, ...Array(tableRows.length - 1).fill(0.4)],
                                    fontSize: 9,
                                    border: { type: 'none' },
                                })
                                ;({ slide: currentSlide, tableRows } = createSlideWithCategoryHeader(
                                    tempCategoryMap[category].name
                                ))
                            }
                        }

                        // flush remaining
                        if (tableRows.length > 1) {
                            currentSlide.addTable(tableRows, {
                                x: 0.05 * slideWidth,
                                y: 0.14 * slideHeight,
                                colW: [0.4 * slideWidth, 0.1 * slideWidth, 0.4 * slideWidth],
                                rowH: [0.25, ...Array(tableRows.length - 1).fill(0.4)],
                                fontSize: 9,
                                border: { type: 'none' },
                            })
                        }
                    }
                })()
                break
            }

            case 'Fulfillment: ' + vmsDisplayName:
                await (async () => {
                    const formatMonthYear = (value) => {
                        if (!value) return '?'
                        const d = new Date(value)
                        if (Number.isNaN(d.getTime())) return '?'
                        return d.toLocaleDateString('en-US', {
                            month: 'short',
                            year: 'numeric',
                        })
                    }

                    const getActivityStatus = (a) => a?.status || a?.activityStatus || a?.studyStatus || 'Uncategorized'

                    const getActivityStatusColor = (status) => {
                        const normalizedStatus = (status || '').replace(/^\w/, (c) => c.toUpperCase())

                        const statusStyle =
                            activityStatusStylesBase?.[status] ||
                            activityStatusStylesBase?.[normalizedStatus] ||
                            activityStatusStylesBase?.Uncategorized

                        return statusStyle?.fill || '000000'
                    }

                    const getGapText = (gap) =>
                        gap?.text || gap?.name || gap?.description || gap?.gapText || gap?.title || ''

                    // Build the Value Message support metric summary.
                    let valueMessageSupportMetrics = []

                    try {
                        const strategyId = store.getState().strategy?._id
                        const marketId = store.getState().market?._id

                        const metricsUrl = `${endpoints.getValueMessageSupport.url}${strategyId}/${marketId}`

                        const metricsResponse = await callSecureAPI(
                            metricsUrl,
                            endpoints.getValueMessageSupport.method,
                            token
                        )

                        const categoryOrder = (valueNarratives || []).map((category) => category.name)

                        valueMessageSupportMetrics = buildValueMessageSupportMetricData(
                            metricsResponse?.data || [],
                            categoryOrder
                        )

                        addValueMessageSupportMetricsSlide(pptx, valueMessageSupportMetrics, {
                            title: `${vmsDisplayName} Support`,
                            backgroundColor: white,
                            titleColor: textColor,
                        })
                    } catch (err) {
                        console.error('Error adding Value Message Support metrics slide:', err)
                    }

                    // VALUE MESSAGE FULFILLMENT GANTT — grouped by VM category / pillar
                    const allActivities = await fetchActivitiesForExport({
                        callSecureAPI,
                        endpoints,
                        strategyId: store.getState().strategy._id,
                        token,
                    })

                    const fulfillmentGanttActivities = allActivities.map((activity) => {
                        const timelineDates = resolveActivityTimelineDates(activity)

                        return {
                            ...activity,

                            // The existing Gantt currently expects these field names.
                            startDate: timelineDates.resolvedStartDate,
                            endDate: timelineDates.resolvedEndDate,

                            // Preserve the date-source information for Gantt styling.
                            exportTimeline: timelineDates,
                        }
                    })

                    const fulfillmentGanttGroups = buildValueMessageFulfillmentGanttGroups({
                        valueNarratives,
                        activities: allActivities,
                    })

                    if (fulfillmentGanttGroups.length) {
                        await createValueMessageFulfillmentGanttSlide(
                            pptx,
                            fulfillmentGanttGroups,
                            activityStatusStylesBase,
                            getStatusLabel,
                            {
                                title: `Timeline of ${activitiesDisplayName}`,
                                activitiesDisplayName,

                                startDateOverride: new Date(2024, 0, 1),
                                endDateOverride: null,

                                includeAllActivitiesInNotes: true,

                                showLegend: true,
                                legendX: null,
                                legendY: 0.08,

                                createActivityStatusLegendFn: createActivityStatusLegend,
                            }
                        )
                    }

                    for (let category of valueNarratives) {
                        for (let narrative of category.valueNarratives) {
                            const orderedValueMessages = getOrderedValueMessages(narrative.valueMessages)

                            for (let vm of orderedValueMessages) {
                                const style = subpopulationStyles[narrative.subpopulation] || {
                                    fill: 'FFFFFF',
                                    line: '000000',
                                }

                                const slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })

                                // ─────────────────────────────
                                // LEGENDS
                                // ─────────────────────────────
                                const LEGEND_TOP_Y = 0.08
                                const LEGEND_RIGHT_X = 9.85
                                const LEGEND_GAP = 0.05
                                const STATUS_LEGEND_WIDTH = 0.93

                                const populationLegendWidth = getPopulationLegendWidth(uniqueSubpopulations)

                                const populationLegendBox = addLegendToSlide(
                                    slide,
                                    uniqueSubpopulations,
                                    subpopulationStyles,
                                    {
                                        x: LEGEND_RIGHT_X - populationLegendWidth,
                                        y: LEGEND_TOP_Y,
                                    }
                                )

                                addStatusLegend(slide, {
                                    x: populationLegendBox.x - STATUS_LEGEND_WIDTH - LEGEND_GAP,
                                    y: LEGEND_TOP_Y,
                                })

                                // ─────────────────────────────
                                // TOP SECTION LAYOUT
                                // ─────────────────────────────
                                const TOP_X = 0.25
                                const TOP_RIGHT = 9.75
                                const TOP_Y = 0.72
                                const SECTION_GAP = 0.12

                                // Category / pillar
                                slide.addText(category.name, {
                                    x: TOP_X,
                                    y: TOP_Y,
                                    w: 3.5,
                                    h: 0.25,
                                    fontSize: 12,
                                    bold: true,
                                    color: '000000',
                                })

                                // ─────────────────────────────
                                // VALUE MESSAGE CARD
                                // ─────────────────────────────
                                const vmText = vm.name || '(No Value Message)'
                                const vmBoxX = TOP_X
                                const vmBoxY = 1.05
                                const vmBoxW = 5.22
                                const vmBoxH = vmText.length > 300 ? 1.15 : 0.9

                                slide.addShape('rect', {
                                    x: vmBoxX,
                                    y: vmBoxY,
                                    w: vmBoxW,
                                    h: vmBoxH,
                                    fill: { color: style.fill },
                                    line: { color: style.line },
                                })

                                slide.addText(vmText, {
                                    x: vmBoxX + 0.08,
                                    y: vmBoxY + 0.07,
                                    w: vmBoxW - 0.16,
                                    h: vmBoxH - 0.14,
                                    fontSize: getFontSizeForText(vmText, 260, 9.5, 6.5),
                                    valign: 'middle',
                                    color: '000000',
                                })

                                // ─────────────────────────────
                                // MESSAGE STATUS + PRIORITY
                                // ─────────────────────────────
                                const statusColor =
                                    STATUS_COLORS?.[vm.status] ??
                                    STATUS_COLORS?.[(vm.status || '').replace(/^\w/, (c) => c.toUpperCase())] ??
                                    '000000'

                                const statusBoxX = 5.59
                                const statusBoxY = vmBoxY
                                const statusBoxW = 1.33
                                const statusBoxH = 0.9

                                slide.addShape('rect', {
                                    x: statusBoxX,
                                    y: statusBoxY,
                                    w: statusBoxW,
                                    h: statusBoxH,
                                    fill: { color: 'FFFFFF' },
                                    line: { color: '000000', pt: 0.75 },
                                })

                                // Message Status label
                                slide.addText('Message Status:', {
                                    x: statusBoxX + 0.08,
                                    y: statusBoxY + 0.2,
                                    w: 0.7,
                                    h: 0.2,
                                    fontSize: 6.5,
                                    bold: true,
                                    color: '000000',
                                    margin: 0,
                                })

                                // Status symbol
                                slide.addText('◉', {
                                    x: statusBoxX + 0.8,
                                    y: statusBoxY + 0.16,
                                    w: 0.25,
                                    h: 0.25,
                                    fontSize: 14,
                                    color: statusColor,
                                    align: 'center',
                                    valign: 'middle',
                                    margin: 0,
                                })

                                slide.addText(
                                    [
                                        {
                                            text: 'Priority: ',
                                            options: {
                                                fontSize: 7,
                                                bold: true,
                                                color: '000000',
                                            },
                                        },
                                        {
                                            text: vm.priority || 'N/A',
                                            options: {
                                                fontSize: 10,
                                                bold: true,
                                                color: '000000',
                                            },
                                        },
                                    ],
                                    {
                                        x: statusBoxX + 0.08,
                                        y: statusBoxY + 0.58,
                                        w: statusBoxW - 0.16,
                                        h: 0.2,
                                        valign: 'middle',
                                        margin: 0,
                                    }
                                )

                                // ─────────────────────────────
                                // EVIDENCE GAPS
                                // ─────────────────────────────
                                let evidenceGaps = []
                                try {
                                    const gapResponse = await callSecureAPI(
                                        endpoints.getEvidenceGapsByValueMessageId.url + vm._id,
                                        endpoints.getEvidenceGapsByValueMessageId.method,
                                        token
                                    )
                                    evidenceGaps = gapResponse?.data || []
                                } catch (e) {
                                    evidenceGaps = []
                                }

                                const gapText = evidenceGaps.length
                                    ? evidenceGaps
                                          .map((g) => getGapText(g))
                                          .filter(Boolean)
                                          .map((t) => `• ${t}`)
                                          .join('\n')
                                    : 'No evidence gaps'

                                const gapBoxX = statusBoxX + statusBoxW + SECTION_GAP
                                const gapBoxY = vmBoxY
                                const gapBoxW = TOP_RIGHT - gapBoxX
                                const gapBoxH = gapText.length > 220 ? 1.35 : vmBoxH

                                // Draw evidence gap box first
                                slide.addShape('rect', {
                                    x: gapBoxX,
                                    y: gapBoxY,
                                    w: gapBoxW,
                                    h: gapBoxH,
                                    fill: { color: 'FFFFFF' },
                                    line: { color: '000000', pt: 0.75 },
                                })

                                // Then draw label inside box
                                slide.addText('Evidence Gaps', {
                                    x: gapBoxX + 0.07,
                                    y: gapBoxY + 0.04,
                                    w: gapBoxW - 0.14,
                                    h: 0.16,
                                    fontSize: 7,
                                    bold: true,
                                    color: '000000',
                                    margin: 0,
                                })

                                slide.addText(gapText, {
                                    x: gapBoxX + 0.12,
                                    y: gapBoxY + 0.25,
                                    w: gapBoxW - 0.24,
                                    h: gapBoxH - 0.32,
                                    fontSize: getFontSizeForText(gapText, 300, 7.5, 5.5),
                                    valign: 'top',
                                    color: evidenceGaps.length ? '000000' : '666666',
                                    italic: !evidenceGaps.length,
                                    margin: 0,
                                })

                                // ─────────────────────────────
                                // ACTIVITIES
                                // ─────────────────────────────
                                let activities = []

                                if (vm?.linkedActivities?.length) {
                                    const resp = await callSecureAPI(
                                        endpoints.getLinkedActivities.url,
                                        endpoints.getLinkedActivities.method,
                                        token,
                                        { listOfActivities: vm.linkedActivities }
                                    )
                                    if (resp?.success) activities = resp.data || []
                                }

                                const tableRows = [
                                    [
                                        {
                                            text: activitiesDisplayName,
                                            options: {
                                                bold: true,
                                                fontSize: 10,
                                                fill: backgroundColor,
                                                color: textColor,
                                                border: [
                                                    { color: 'FFFFFF' },
                                                    { color: 'FFFFFF' },
                                                    { color: '000000', pt: 2 },
                                                    { color: 'FFFFFF' },
                                                ],
                                            },
                                        },
                                        {
                                            text: 'Status',
                                            options: {
                                                bold: true,
                                                fontSize: 10,
                                                fill: backgroundColor,
                                                color: textColor,
                                                border: [
                                                    { color: 'FFFFFF' },
                                                    { color: 'FFFFFF' },
                                                    { color: '000000', pt: 2 },
                                                    { color: 'FFFFFF' },
                                                ],
                                            },
                                        },
                                        {
                                            text: 'Function',
                                            options: {
                                                bold: true,
                                                fontSize: 10,
                                                fill: backgroundColor,
                                                color: textColor,
                                                border: [
                                                    { color: 'FFFFFF' },
                                                    { color: 'FFFFFF' },
                                                    { color: '000000', pt: 2 },
                                                    { color: 'FFFFFF' },
                                                ],
                                            },
                                        },
                                        {
                                            text: 'Timeline',
                                            options: {
                                                bold: true,
                                                fontSize: 10,
                                                fill: backgroundColor,
                                                color: textColor,
                                                border: [
                                                    { color: 'FFFFFF' },
                                                    { color: 'FFFFFF' },
                                                    { color: '000000', pt: 2 },
                                                    { color: 'FFFFFF' },
                                                ],
                                            },
                                        },
                                    ],
                                ]

                                if (activities.length) {
                                    activities.forEach((a, idx) => {
                                        const status = getActivityStatus(a)
                                        const timelineDates = resolveActivityTimelineDates(a)
                                        const rowFill = idx % 2 === 0 ? 'FFFFFF' : 'F2F2F2'

                                        tableRows.push([
                                            {
                                                text: a.title || '(Untitled)',
                                                options: {
                                                    fontSize: 8,
                                                    fill: rowFill,
                                                    valign: 'top',
                                                },
                                            },
                                            {
                                                text: status,
                                                options: {
                                                    fontSize: 8,
                                                    fill: rowFill,
                                                    color: getActivityStatusColor(status),
                                                    bold: true,
                                                    valign: 'top',
                                                },
                                            },
                                            {
                                                text: a.function || a.responsibleFunction || a.responsibleTeam || '---',
                                                options: {
                                                    fontSize: 8,
                                                    fill: rowFill,
                                                    valign: 'top',
                                                },
                                            },
                                            {
                                                text: [
                                                    {
                                                        text: formatMonthYear(timelineDates.resolvedStartDate),
                                                        options: {
                                                            italic: timelineDates.startDateType === 'planned',
                                                        },
                                                    },
                                                    {
                                                        text: ' – ',
                                                        options: {},
                                                    },
                                                    {
                                                        text: formatMonthYear(timelineDates.resolvedEndDate),
                                                        options: {
                                                            italic: timelineDates.endDateType === 'planned',
                                                        },
                                                    },
                                                ],
                                                options: {
                                                    fontSize: 8,
                                                    fill: rowFill,
                                                    valign: 'top',
                                                },
                                            },
                                        ])
                                    })
                                } else {
                                    tableRows.push([
                                        {
                                            text: `No linked ${activitiesDisplayName.toLowerCase()}`,
                                            options: { fontSize: 8 },
                                        },
                                        { text: '', options: { fontSize: 8 } },
                                        { text: '', options: { fontSize: 8 } },
                                        { text: '', options: { fontSize: 8 } },
                                    ])
                                }

                                slide.addTable(tableRows, {
                                    x: 0.25,
                                    y: 2.55,
                                    colW: [5.95, 1.05, 1.2, 1.3],
                                    rowH: [0.28, ...Array(tableRows.length - 1).fill(0.38)],
                                    fontSize: 8,
                                    border: { type: 'none' },
                                })

                                // Slide footnotes to explain why some dates may be italicized.
                                slide.addText('* Italicized dates are planned dates.', {
                                    x: 1.25,
                                    y: 5.3,
                                    w: 3.5,
                                    h: 0.16,
                                    fontSize: 6.5,
                                    italic: true,
                                    color: '666666',
                                    margin: 0,
                                })

                                // Notes additions
                                if (activities.length) {
                                    const activityNumberMap = buildActivityNumberingMap(
                                        activities.map((a) => ({ acts: [a] }))
                                    )

                                    const notesText = buildActivityNotesText(
                                        activityNumberMap,
                                        activities.map((a) => ({ acts: [a] }))
                                    )

                                    slide.addNotes(notesText)
                                }

                                // ─────────────────────────────
                                // Hidden Metadata (Off-canvas)
                                // ─────────────────────────────
                                const hiddenX = 11
                                const hiddenY = 1.0
                                const hiddenW = 3.0
                                const hiddenH = 2.1

                                slide.addShape('rect', {
                                    x: hiddenX,
                                    y: hiddenY,
                                    w: hiddenW,
                                    h: hiddenH,
                                    fill: { color: 'FFFFFF' },
                                    line: { color: '000000', pt: 1 },
                                })

                                const audienceList = Object.entries(vm?.audiences || {})
                                    .filter(([_, val]) => val)
                                    .map(([key]) => key)

                                slide.addText(`Audiences:\n${audienceList.length ? audienceList.join(', ') : 'None'}`, {
                                    x: hiddenX + 0.1,
                                    y: hiddenY + 0.12,
                                    w: hiddenW - 0.2,
                                    h: 0.8,
                                    fontSize: 8,
                                    color: '000000',
                                    valign: 'top',
                                })

                                const markets = vm?.localMarkets || []

                                slide.addText(`Markets:\n${markets.length ? markets.join(', ') : 'None'}`, {
                                    x: hiddenX + 0.1,
                                    y: hiddenY + 1.05,
                                    w: hiddenW - 0.2,
                                    h: 0.8,
                                    fontSize: 8,
                                    color: '000000',
                                    valign: 'top',
                                })
                            }
                        }
                    }
                })()
                break

            case 'Fulfillment: ' + tppDisplayName:
                await (async () => {
                    try {
                        const strategy = store.getState().strategy
                        const strategyId = strategy?._id
                        const assetName = `${strategy?.product || ''} for ${strategy?.indication || ''}`.trim()

                        if (!strategyId) throw new Error('No strategy selected')

                        const TPP_FULFILLMENT_SCOPE = 'both'

                        const fontFace = 'Arial'
                        const SLIDE_W = 10.0
                        const SLIDE_H = 5.625
                        const textColor = '000000'
                        const ATTRIBUTE_BG = '2F3A4A'
                        const ATTRIBUTE_FG = 'FFFFFF'
                        const GREEN = '268500'

                        const TABLE_X = 0.0
                        const TABLE_Y = 0.95
                        const TABLE_W = 10.0
                        const MAX_TABLE_H = SLIDE_H - TABLE_Y - 0.12

                        const HEADER_ROW_H = 0.24
                        const SUBHEADER_ROW_H = 0.28
                        const colW = [1.65, 2.25, 1.9, 2.25, 1.95]

                        const tppIdRes = await callSecureAPI(`/api/tpps/roadmap/${strategyId}`, 'get', token)
                        if (!tppIdRes.success || !tppIdRes.data) {
                            throw new Error('Could not retrieve TPP for this strategy')
                        }

                        const tppId = tppIdRes.data

                        const [tppRes, columnsRes, sectionsRes, rowsRes, slotsRes, cellsRes] = await Promise.all([
                            callSecureAPI(`/api/tpps/${tppId}`, 'get', token),
                            callSecureAPI(`/api/tpps/columns/${tppId}`, 'get', token),
                            callSecureAPI(`/api/tpps/sections/${tppId}`, 'get', token),
                            callSecureAPI(`/api/tpps/rows/${tppId}`, 'get', token),
                            callSecureAPI(`/api/tpps/slots/${tppId}`, 'get', token),
                            callSecureAPI(`/api/tpps/cells/${tppId}`, 'get', token),
                        ])

                        if (!tppRes.success) throw new Error('Failed to fetch TPP data')

                        const columns = columnsRes?.data || []

                        // TODO: Make scenario/column matching configurable by organization.
                        // Some customers may use Base/Best, while others may use Upside/Downside,
                        // Low/High, Conservative/Optimistic, or other profile names.
                        // Future enhancement: allow org-level configuration for fulfillment column roles
                        // rather than hardcoding exact column titles.

                        const baseColumn = columns.find((c) => cleanTppText(c?.title) === 'Base Case')
                        const bestColumn = columns.find((c) => cleanTppText(c?.title) === 'Best Case')

                        if (!baseColumn || !bestColumn) {
                            throw new Error('Could not find Base Case and Best Case columns')
                        }

                        const makeSupportUrl = (columnId, highlightedOnly) =>
                            endpoints.getTppElementSupport.url +
                            strategyId +
                            '/' +
                            columnId +
                            `?highlightedOnly=${highlightedOnly}`

                        const [baseExecSupportRes, bestExecSupportRes, baseAllSupportRes, bestAllSupportRes] =
                            await Promise.all([
                                callSecureAPI(
                                    makeSupportUrl(baseColumn._id, true),
                                    endpoints.getTppElementSupport.method,
                                    token
                                ),
                                callSecureAPI(
                                    makeSupportUrl(bestColumn._id, true),
                                    endpoints.getTppElementSupport.method,
                                    token
                                ),
                                callSecureAPI(
                                    makeSupportUrl(baseColumn._id, false),
                                    endpoints.getTppElementSupport.method,
                                    token
                                ),
                                callSecureAPI(
                                    makeSupportUrl(bestColumn._id, false),
                                    endpoints.getTppElementSupport.method,
                                    token
                                ),
                            ])

                        const activityMap = buildTppActivityMapFromElementSupportResponses(
                            baseAllSupportRes,
                            bestAllSupportRes
                        )

                        const trppData = transformLiveTppDataForExport({
                            tpp: tppRes.data,
                            columns: columnsRes.data || [],
                            sections: sectionsRes.data || [],
                            rows: rowsRes.data || [],
                            slots: slotsRes.data || [],
                            cells: cellsRes.data || [],
                            assetName,
                        })

                        const categoryOrder = (sectionsRes?.data || []).map((section) => section.title)

                        function createFulfillmentSlide(categoryName, scopeLabel) {
                            const slide = pptx.addSlide({ masterName: 'TrPP_SLIDE' })

                            slide.addText(categoryName || '(Untitled category)', {
                                x: 0.0,
                                y: 0.7,
                                w: 6.8,
                                h: 0.25,
                                fontFace,
                                fontSize: 12,
                                bold: true,
                                color: textColor,
                                align: 'left',
                            })

                            slide.addText(
                                scopeLabel === 'All' ? 'All TrPP Fulfillment' : 'Executive Summary Fulfillment',
                                {
                                    x: 2.5,
                                    y: 0.78,
                                    w: 5.0,
                                    h: 0.18,
                                    fontFace,
                                    fontSize: 8,
                                    bold: true,
                                    color: '666666',
                                    align: 'center',
                                    valign: 'bottom',
                                }
                            )

                            slide.addText('Version X • Next AP: 2026-01-01', {
                                x: 7.0,
                                y: 0.78,
                                w: 3.0,
                                h: 0.18,
                                fontFace,
                                fontSize: 7,
                                bold: true,
                                color: textColor,
                                align: 'right',
                                valign: 'bottom',
                            })

                            createActivityStatusLegend(pptx, slide, activityStatusStylesBase, SLIDE_W, null, 0.1, {
                                maxCols: 3,
                                minCols: 3,
                                maxColsCap: 3,
                                cellW: 0.9,
                                cellH: 0.15,
                                baseFont: 5.5,
                                denseFont: 5.2,
                                rightMargin: 0.15,
                                align: 'right',
                            })

                            slide.addText(
                                'Green text represents elements that most significantly impact differentiation.',
                                {
                                    x: 0.1,
                                    y: 5.1,
                                    w: 4.8,
                                    h: 0.14,
                                    fontFace,
                                    fontSize: 5.5,
                                    color: GREEN,
                                    italic: true,
                                    margin: 0,
                                }
                            )

                            return slide
                        }

                        function makeHeaderRows() {
                            const noBorder = { color: 'FFFFFF', transparency: 100 }

                            const header1 = [
                                {
                                    text: '',
                                    options: {
                                        fill: 'FFFFFF',
                                        border: noBorder,
                                    },
                                },
                                {
                                    text: 'Base Case',
                                    options: {
                                        fill: 'FFFFFF',
                                        color: textColor,
                                        bold: true,
                                        align: 'center',
                                        valign: 'mid',
                                        colspan: 2,
                                        fontSize: 8,
                                        border: noBorder,
                                    },
                                },
                                {
                                    text: 'Best Case',
                                    options: {
                                        fill: 'FFFFFF',
                                        color: textColor,
                                        bold: true,
                                        align: 'center',
                                        valign: 'mid',
                                        colspan: 2,
                                        fontSize: 8,
                                        border: noBorder,
                                    },
                                },
                            ]

                            const header2 = [
                                'Attribute',
                                'Data Elements',
                                'Activities',
                                'Data Elements',
                                'Activities',
                            ].map((h) => ({
                                text: h,
                                options: {
                                    fill: 'FFFFFF',
                                    color: textColor,
                                    bold: true,
                                    align: 'center',
                                    valign: 'mid',
                                    fontSize: 8,
                                    border: noBorder,
                                },
                            }))

                            return [header1, header2]
                        }

                        function flushTable(slide, tableRows, rowHeights) {
                            slide.addTable(tableRows, {
                                x: TABLE_X,
                                y: TABLE_Y,
                                w: TABLE_W,
                                colW,
                                rowH: rowHeights,
                                fontSize: 7,
                                border: { type: 'none' },
                                margin: 0.1,
                            })

                            slide.addShape(pptx.ShapeType.line, {
                                x: TABLE_X,
                                y: TABLE_Y,
                                w: TABLE_W,
                                h: 0,
                                line: { color: ATTRIBUTE_BG, pt: 1 },
                            })

                            slide.addShape(pptx.ShapeType.line, {
                                x: TABLE_X,
                                y: TABLE_Y + HEADER_ROW_H,
                                w: TABLE_W,
                                h: 0,
                                line: { color: ATTRIBUTE_BG, pt: 0.75 },
                            })

                            slide.addShape(pptx.ShapeType.line, {
                                x: TABLE_X,
                                y: TABLE_Y + HEADER_ROW_H + SUBHEADER_ROW_H,
                                w: TABLE_W,
                                h: 0,
                                line: { color: ATTRIBUTE_BG, pt: 1.25 },
                            })
                        }

                        const fulfillmentRuns =
                            TPP_FULFILLMENT_SCOPE === 'both'
                                ? [
                                      {
                                          label: 'Executive Summary',
                                          highlightedOnly: true,
                                          baseSupportRes: baseExecSupportRes,
                                          bestSupportRes: bestExecSupportRes,
                                      },
                                      {
                                          label: 'All',
                                          highlightedOnly: false,
                                          baseSupportRes: baseAllSupportRes,
                                          bestSupportRes: bestAllSupportRes,
                                      },
                                  ]
                                : [
                                      {
                                          label: TPP_FULFILLMENT_SCOPE === 'all' ? 'All' : 'Executive Summary',
                                          highlightedOnly: TPP_FULFILLMENT_SCOPE === 'all' ? false : true,
                                          baseSupportRes:
                                              TPP_FULFILLMENT_SCOPE === 'all' ? baseAllSupportRes : baseExecSupportRes,
                                          bestSupportRes:
                                              TPP_FULFILLMENT_SCOPE === 'all' ? bestAllSupportRes : bestExecSupportRes,
                                      },
                                  ]

                        for (const run of fulfillmentRuns) {
                            const baseMetricData = buildTppFulfillmentMetricData(run.baseSupportRes?.data || [], {
                                activityStatusStyles: activityStatusStylesBase,
                                getStatusLabel,
                                categoryOrder,
                                activityStatusOrderMap,
                            })

                            const bestMetricData = buildTppFulfillmentMetricData(run.bestSupportRes?.data || [], {
                                activityStatusStyles: activityStatusStylesBase,
                                getStatusLabel,
                                categoryOrder,
                                activityStatusOrderMap,
                            })

                            addTppFulfillmentMetricsSlide(pptx, {
                                title:
                                    run.label === 'All'
                                        ? 'TrPP Fulfillment Metrics: All TrPP'
                                        : 'TrPP Fulfillment Metrics: Executive Summary',
                                subtitle: assetName,
                                baseMetricData,
                                bestMetricData,
                                activityStatusStyles: activityStatusStylesBase,
                                createActivityStatusLegend,
                                masterName: 'CONTENT_SLIDE',
                            })

                            const normalized = normalizeLiveTppForRows(trppData, {
                                highlightedOnly: run.highlightedOnly,
                            })

                            if (!normalized) {
                                throw new Error('TPP data is missing or malformed')
                            }

                            const baseScenario = (normalized.scenarios || []).find(
                                (s) => cleanTppText(s.name) === 'Base Case'
                            )
                            const bestScenario = (normalized.scenarios || []).find(
                                (s) => cleanTppText(s.name) === 'Best Case'
                            )

                            if (!baseScenario || !bestScenario) {
                                throw new Error('Could not map Base Case and Best Case scenario IDs')
                            }

                            const allActivitiesForTppGantt = await fetchActivitiesForExport({
                                callSecureAPI,
                                endpoints,
                                strategyId,
                                token,
                            })

                            const tppFulfillmentGanttGroups = buildTppFulfillmentGanttGroups({
                                categories: normalized.categories || [],
                                baseScenarioId: baseScenario.id,
                                bestScenarioId: bestScenario.id,
                                activityMap,
                                allActivities: allActivitiesForTppGantt,
                            })

                            console.log(`[TPP GANTT] ${run.label} timeline data`)

                            console.table(
                                tppFulfillmentGanttGroups.flatMap((group) =>
                                    (group.activities || []).map((activity) => ({
                                        category: group.category,
                                        title: activity?.title,
                                        startDate: activity?.startDate || '',
                                        endDate: activity?.endDate || '',
                                        plannedStartDate: activity?.plannedStartDate || '',
                                        plannedEndDate: activity?.plannedEndDate || '',
                                        ganttStartDate: activity?._ganttStartDate || '',
                                        ganttEndDate: activity?._ganttEndDate || '',
                                        startType: activity?._ganttTimeline?.startDateType || '',
                                        endType: activity?._ganttTimeline?.endDateType || '',
                                        hasPlannedDate: activity?._ganttTimeline?.hasPlannedDate ?? '',
                                    }))
                                )
                            )

                            if (tppFulfillmentGanttGroups.length) {
                                console.log('[TPP GANTT] creating slide')
                                await createTppFulfillmentGanttSlide(
                                    pptx,
                                    tppFulfillmentGanttGroups,
                                    activityStatusStylesBase,
                                    getStatusLabel,
                                    {
                                        title: `Timeline of ${activitiesDisplayName}`,
                                        activitiesDisplayName,

                                        startDateOverride: new Date(2024, 0, 1),
                                        endDateOverride: null,

                                        includeAllActivitiesInNotes: true,

                                        showLegend: true,
                                        legendY: 0.08,
                                        createActivityStatusLegendFn: createActivityStatusLegend,
                                    }
                                )
                            }

                            for (const category of normalized.categories || []) {
                                const fulfillmentRows = buildTppFulfillmentRowsForCategory(
                                    category,
                                    baseScenario.id,
                                    bestScenario.id,
                                    activityMap
                                )

                                if (!fulfillmentRows.length) continue

                                let slide = createFulfillmentSlide(category.name, run.label)
                                let tableRows = makeHeaderRows()
                                let rowHeights = [HEADER_ROW_H, SUBHEADER_ROW_H]

                                fulfillmentRows.forEach((row, idx) => {
                                    const rowH = estimateTppFulfillmentRowHeight(row)

                                    if (getTppTotalHeight(rowHeights) + rowH > MAX_TABLE_H && tableRows.length > 2) {
                                        flushTable(slide, tableRows, rowHeights)

                                        slide = createFulfillmentSlide(category.name, run.label)
                                        tableRows = makeHeaderRows()
                                        rowHeights = [HEADER_ROW_H, SUBHEADER_ROW_H]
                                    }

                                    const fill = idx % 2 === 0 ? 'FFFFFF' : 'F2F2F2'

                                    tableRows.push([
                                        {
                                            text: row.attributeName,
                                            options: {
                                                fill: ATTRIBUTE_BG,
                                                color: ATTRIBUTE_FG,
                                                bold: true,
                                                fontSize: 7.2,
                                                valign: 'top',
                                                margin: 0.08,
                                            },
                                        },
                                        {
                                            text: buildTppElementRuns(row.baseText, row.baseHighlighted, {
                                                green: GREEN,
                                                textColor,
                                            }),
                                            options: {
                                                fill,
                                                color: row.baseHighlighted ? GREEN : textColor,
                                                valign: 'top',
                                                margin: 0.1,
                                            },
                                        },
                                        {
                                            text: buildTppActivityRuns(row.baseActivities, {
                                                textColor,
                                                activityStatusStyles: activityStatusStylesBase,
                                                getStatusLabel,
                                            }),
                                            options: {
                                                fill,
                                                color: textColor,
                                                valign: 'top',
                                                margin: 0.1,
                                            },
                                        },
                                        {
                                            text: buildTppElementRuns(row.bestText, row.bestHighlighted, {
                                                green: GREEN,
                                                textColor,
                                            }),
                                            options: {
                                                fill,
                                                color: row.bestHighlighted ? GREEN : textColor,
                                                valign: 'top',
                                                margin: 0.1,
                                            },
                                        },
                                        {
                                            text: buildTppActivityRuns(row.bestActivities, {
                                                textColor,
                                                activityStatusStyles: activityStatusStylesBase,
                                                getStatusLabel,
                                            }),
                                            options: {
                                                fill,
                                                color: textColor,
                                                valign: 'top',
                                                margin: 0.1,
                                            },
                                        },
                                    ])

                                    rowHeights.push(rowH)
                                })

                                if (tableRows.length > 2) {
                                    flushTable(slide, tableRows, rowHeights)
                                }
                            }
                        }
                    } catch (err) {
                        console.error('Error exporting TPP Fulfillment:', err)

                        if (typeof cannotExportPPTX === 'function') {
                            cannotExportPPTX(`Failed to export ${tppDisplayName} Fulfillment: ${err.message}`)
                        }
                    }
                })()
                break

            // TODO Add a case for a Competitor Landscape export
            default:
                break
        }

        // TODO Make export name more descriptive for organization and roadmap (example - Organization + Product + Indication
        await pptx.writeFile(
            'Atlas Export - ' +
                reportType +
                ' - ' +
                date.toLocaleString('en', { month: 'short' }) +
                ' ' +
                date.getDate() +
                ', ' +
                date.getFullYear() +
                '.pptx'
        )
        switch (reportType) {
            case vmsDisplayName:
                setVMExporting(false)
                break
            case vmsDisplayName + ' + ' + evidenceDisplayName: //Switched to evidenceDisplayName
                setVMAndEvidenceExporting(false)
                break
            case vmsDisplayName + ' + ' + activitiesDisplayName:
                setVMAndActExporting(false)
                break
            case 'Strategic Imperatives + ' + activitiesDisplayName:
                setSIAndActExporting(false)
                break
            case evidenceDisplayName: //Switched to evidenceDisplayName
                setEvidenceExporting(false)
                break
            case activitiesDisplayName:
                setActExporting(false)
                break
            case strategicDisplayName + ' + ' + activitiesDisplayName:
                setEGPExporting(false)
                break
            case vmsDisplayName + ' + Gaps':
                setVMsGapsExporting(false)
                break
            case vmsDisplayName + ' + Status + Gaps':
                setVMsStatusGapsExporting(false)
                break
            case vnsDisplayName: // vmsDisplayName + ' + Evidence Statements + Citations'
                setIsValueNarrativeExporting(false)
                break
            case 'Key Evidence Statements':
                setIsKeyEvidenceExporting(false)
                break
            // case tppDisplayName + ' (from Strategic Anchors)':
            //     setIsTPPExporting(false)
            //    break
            case 'Aspirational ' + vmsDisplayName + ' + ' + activitiesDisplayName: //
                setIsAspirationalExporting(false)
                break
            case tppDisplayName:
                setIsTrPPExporting(false)
                break
            case 'Fulfillment: ' + vmsDisplayName:
                setIsFulfillmentVMExporting(false)
                break
            case 'Fulfillment: ' + tppDisplayName:
                setIsFulfillmentTPPExporting(false)
                break
            // TODO Add a case for a competitor landscape export
            default:
                break
        }
    }

    //TODO Treat summary slide the way we handle the Value Proposition which could be checked on or off if folks want to include it or not.

    function createSummarySlide(pptx, valueNarratives, uniqueSubpopulations, subpopulationStyles) {
        const slideWidth = 10.0
        const slideHeight = 5.625

        // Spacing controls
        const spacingAfterCategoryLabel = 0.05 * slideHeight
        const spacingBetweenNarrativeRows = 0.015 * slideHeight
        const spacingBetweenCategories = 0.02 * slideHeight

        const boxW = 0.3 * slideWidth
        const boxH = 0.12 * slideHeight
        const hSpacing = 0.01 * slideWidth
        const maxCols = 3

        let slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
        addLegendToSlide(slide, uniqueSubpopulations, subpopulationStyles)

        slide.addText(`Summary of ${vnsDisplayName}`, {
            x: 0.05 * slideWidth,
            y: 0.08 * slideHeight,
            fontSize: 16,
            bold: true,
            color: '000000',
        })

        let yPos = 0.14 * slideHeight

        for (let category of valueNarratives) {
            if (!category.valueNarratives || category.valueNarratives.length === 0) {
                console.log(`Skipping category "${category.name}" — no narratives to display.`)
                continue
            }

            let categoryPrinted = false
            let isFirstNarrative = true
            let xPos = 0.05 * slideWidth
            let col = 0
            let rowJustWrapped = false

            for (let narrativeIdx = 0; narrativeIdx < category.valueNarratives.length; narrativeIdx++) {
                const narrative = category.valueNarratives[narrativeIdx]
                const style = subpopulationStyles[narrative.subpopulation]

                // Check if category label + 1 box would overflow
                const needsNewSlide =
                    (!categoryPrinted && yPos + spacingAfterCategoryLabel + boxH > 0.9 * slideHeight) ||
                    (categoryPrinted && yPos + boxH > 0.9 * slideHeight)

                if (needsNewSlide) {
                    slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
                    addLegendToSlide(slide, uniqueSubpopulations, subpopulationStyles)

                    slide.addText(`Summary of ${vnsDisplayName}`, {
                        x: 0.05 * slideWidth,
                        y: 0.08 * slideHeight,
                        fontSize: 16,
                        bold: true,
                        color: '000000',
                    })

                    // Always print category label on new slide
                    const labelText = categoryPrinted ? `${category.name} (cont’d)` : category.name

                    slide.addText([{ text: labelText, options: { bold: true, fontSize: 12 } }], {
                        x: 0.05 * slideWidth,
                        y: 0.14 * slideHeight,
                        w: 0.9 * slideWidth,
                        h: 0.05 * slideHeight,
                        align: 'left',
                    })

                    categoryPrinted = true
                    yPos = 0.14 * slideHeight + spacingAfterCategoryLabel
                    xPos = 0.05 * slideWidth
                    col = 0
                }

                // If category label hasn't been added yet (and we’re sure there’s space), do it now
                if (!categoryPrinted) {
                    slide.addText([{ text: category.name, options: { bold: true, fontSize: 12 } }], {
                        x: 0.05 * slideWidth,
                        y: yPos,
                        w: 0.9 * slideWidth,
                        h: 0.05 * slideHeight,
                        align: 'left',
                    })

                    yPos += spacingAfterCategoryLabel
                    categoryPrinted = true
                }

                // Add narrative box
                slide.addText(narrative.name, {
                    x: xPos,
                    y: yPos,
                    w: boxW,
                    h: boxH,
                    fontSize: getFontSizeForText(narrative.name, 245, 8, 6),
                    align: 'left',
                    color: '000000',
                    fill: { color: style.fill },
                    line: { color: style.line },
                    breakLine: true,
                })

                col++
                if (col >= maxCols) {
                    col = 0
                    xPos = 0.05 * slideWidth
                    yPos += boxH + spacingBetweenNarrativeRows
                    rowJustWrapped = true
                } else {
                    xPos += boxW + hSpacing
                    rowJustWrapped = false
                }
            }

            // Add spacing after last narrative row before next category
            if (rowJustWrapped) {
                yPos += spacingBetweenCategories
            } else {
                yPos += boxH + spacingBetweenNarrativeRows + spacingBetweenCategories
            }
        }
    }

    // Updated getSubpopulationStyles (handles grouped narrative categories directly)
    function getSubpopulationStyles(narrativeData) {
        if (!Array.isArray(narrativeData)) {
            console.warn('⚠️ Provided narrativeData is not an array. Returning empty styles.')
            return { uniqueSubpopulations: [], subpopulationStyles: {} }
        }

        const allSubpopulations = getSettingsQuery?.data?.vmSubpopulations || []

        const subpopulationSet = new Set()

        narrativeData.forEach((category) => {
            if (!Array.isArray(category.valueNarratives)) return
            category.valueNarratives.forEach((narrative) => {
                subpopulationSet.add(narrative.subpopulation)
                if (!narrative.subpopulation) {
                    narrative.subpopulation = 'Uncategorized'
                }
            })
        })

        const uniqueSubpopulations = [
            ...Array.from(subpopulationSet)
                .filter(Boolean)
                .sort((a, b) => a.localeCompare(b)),
            'Uncategorized',
        ]

        const subpopulationStyles = uniqueSubpopulations.reduce((acc, item) => {
            const subpopulationIndex = allSubpopulations.indexOf(item)

            return {
                ...acc,
                [item]: subpopulationStylesList[subpopulationIndex % subpopulationStylesList.length] || colors.grey,
            }
        }, {})

        return { uniqueSubpopulations, subpopulationStyles }
    }

    // Font size determined by width & character count to account for different edge cases (eg, narrow box + few characters = base size)
    function getFontSizeForText(text, maxChars = 300, baseSize = 10, minSize = 6) {
        if (!text) return baseSize

        const length = text.length
        if (length <= maxChars) return baseSize
        if (length <= maxChars * 1.25) return Math.max(baseSize - 1, minSize)
        if (length <= maxChars * 1.5) return Math.max(baseSize - 2, minSize)
        return minSize
    }

    // Dynamic helper function for the Gantt chart's Activity box font size:
    function getFontSizeForGantt(text, boxWidth, baseSize = 8, minSize = 3) {
        if (!text) return baseSize

        // 1) If the label is short enough to fit at full size, use baseSize.
        //    Assume ~10 characters per inch at baseSize.
        const maxCharsPerInch = 12
        if (text.length <= boxWidth * maxCharsPerInch) {
            return baseSize
        }

        // 2) Width‐based fallbacks
        if (boxWidth >= 1.5) return baseSize // wide, keep full
        if (boxWidth >= 1.0) return baseSize - 1 // medium
        if (boxWidth >= 0.7) return baseSize - 2 // snug
        if (boxWidth >= 0.5) return baseSize - 3 // narrow → ~5pt
        if (boxWidth >= 0.3) return Math.max(baseSize - 4, minSize)
        return minSize
    }

    function getTruncatedTextForGantt(text, boxWidth, fontSize, baseSize = 8, baseCharsPerInch = 12) {
        if (!text) return ''
        const charsPerInch = baseCharsPerInch * (fontSize / baseSize)
        const paddingInches = 0.1
        const usableWidth = Math.max(boxWidth - paddingInches, 0)
        const maxChars = Math.floor(usableWidth * charsPerInch)
        if (text.length <= maxChars) return text
        if (maxChars <= 1) return '…'
        return text.slice(0, Math.max(0, maxChars - 1)) + '…'
    }

    function getPopulationLegendWidth(uniqueSubpopulations = [], cfg = {}) {
        const { maxRows = 3, itemW = 0.95, padX = 0.08 } = cfg

        const numCols = Math.max(1, Math.ceil((uniqueSubpopulations || []).length / maxRows))
        return padX * 2 + numCols * itemW
    }

    // Population Legend
    function addLegendToSlide(slide, uniqueSubpopulations, subpopulationStyles, cfg = {}) {
        const slideWidth = 10.0
        const slideHeight = 5.625

        const {
            x = 0.65 * slideWidth,
            y = 0.025 * slideHeight,
            maxRows = 3,
            itemW = 0.95,
            itemH = 0.16,
            padX = 0.08,
            padY = 0.07,
            swatch = 0.075,
            fontSize = 6,
            linePt = 0.75,
        } = cfg

        const items = uniqueSubpopulations || []
        const numCols = Math.max(1, Math.ceil(items.length / maxRows))
        const legendW = padX * 2 + numCols * itemW
        const legendH = padY * 2 + maxRows * itemH

        slide.addShape('rect', {
            x,
            y,
            w: legendW,
            h: legendH,
            fill: { color: 'FFFFFF' },
            line: { color: '000000', pt: linePt },
        })

        items.forEach((subpop, i) => {
            const col = Math.floor(i / maxRows)
            const row = i % maxRows

            const baseX = x + padX + col * itemW
            const baseY = y + padY + row * itemH

            slide.addShape('rect', {
                x: baseX,
                y: baseY + (itemH - swatch) / 2,
                w: swatch,
                h: swatch,
                fill: { color: subpopulationStyles[subpop].fill },
                line: { color: subpopulationStyles[subpop].line },
            })

            slide.addText([{ text: subpop, options: { fontSize } }], {
                x: baseX + swatch + 0.035,
                y: baseY,
                w: itemW - swatch - 0.045,
                h: itemH,
                valign: 'middle',
                margin: 0,
            })
        })

        return { x, y, w: legendW, h: legendH, right: x + legendW, bottom: y + legendH }
    }

    // TODO Adjust text box color for the status

    // -----------------------------------------------------------------------------
    // Backward-compatible version of getActivityStatusStyles
    // Works with both:
    //   • getActivityStatusStyles(activities)
    //   • getActivityStatusStyles(activities, activityStatusDetails, activityStatuses, userFilters)
    // -----------------------------------------------------------------------------

    /* // Should be able to remove the below helper function after some additional testing.
    function getActivityStatusStyles(activities, activityStatusDetailsArg, activityStatusesArg, userFilters = {}) {
        const data = Array.isArray(activities?.data) ? activities.data : []

        // Handle missing org-aware inputs gracefully
        const details = Array.isArray(activityStatusDetailsArg) ? activityStatusDetailsArg : []
        const ids = Array.isArray(activityStatusesArg) ? activityStatusesArg : []

        // Build a neutral fallback list of raw statuses if no org config is passed
        const rawUnique = Array.from(
            new Set(data.map((a) => (a?.status ?? a?.activityStatus ?? '').toString().trim()).filter(Boolean))
        )

        // --- 1️⃣ Build styles (org-aware if details provided, else generic gray) ---
        let statusStyles
        if (details.length) {
            statusStyles = Object.fromEntries(
                details.map((d) => {
                    const hex = (d.color || '').replace('#', '')
                    return [d.id, { line: hex, fill: hex, label: d.name }]
                })
            )
        } else {
            statusStyles = Object.fromEntries(
                rawUnique.map((s) => {
                    const hex = '666666'
                    return [s, { line: hex, fill: hex, label: s }]
                })
            )
        }

        if (!statusStyles['Uncategorized']) {
            statusStyles['Uncategorized'] = { fill: '999999', line: '999999', label: 'Uncategorized' }
        }

        // --- 2️⃣ Canonical resolvers (only meaningful if org details exist) ---
        const idByLowerId = new Map(details.map((d) => [String(d.id).toLowerCase(), d.id]))
        const idByLowerName = new Map(details.map((d) => [String(d.name).toLowerCase(), d.id]))
        const toId = (val) => {
            if (!val) return null
            const k = String(val).trim().toLowerCase()
            return idByLowerId.get(k) || idByLowerName.get(k) || null
        }

        // --- 3️⃣ Status label resolver ---
        function getStatusLabel(activity) {
            const raw = activity?.status ?? activity?.activityStatus ?? ''
            return details.length ? toId(raw) || 'Uncategorized' : raw || 'Uncategorized'
        }

        // --- 4️⃣ Unique statuses (canonical if possible) ---
        const uniqueStatuses = Array.from(new Set(data.map((a) => getStatusLabel(a)))).filter(Boolean)

        // --- 5️⃣ Include list (org-aware if possible; else everything) ---
        let includeStatuses
        let includeStatusesLabel

        if (ids.length) {
            const terminalIds = ['Cancelled', 'Completed', 'Terminated'].filter((id) => ids.includes(id))
            const defaultInclude = ids.filter((id) => !terminalIds.includes(id))

            includeStatuses = (userFilters.activityStatuses ?? defaultInclude)
                .map((x) => (toId ? toId(x) : x))
                .filter(Boolean)

            includeStatusesLabel = includeStatuses.map((id) => statusStyles[id]?.label || id).join(', ')
        } else {
            includeStatuses = rawUnique
            includeStatusesLabel = rawUnique.join(', ')
        }

        return {
            uniqueStatuses,
            activityStatusStyles: statusStyles,
            getStatusLabel,
            includeStatuses,
            includeStatusesLabel,
        }
    }

    */

    /**
     * createActivitiesRightGanttSlide
     *
     * Left column = Activity titles (no text on bars)
     * Right = timeline bars colored by activity status
     * Rows/bars auto-resize based on how many activities you have.
     *
     * Required:
     *  - activityStatusStyles: { [canonicalStatusId]: { fill, line, label } }
     *  - getStatusLabel(activity): returns canonicalStatusId (e.g., "Planned", "Initiated", etc.)
     *
     * Optional filtering:
     *  - includeStatuses: array of canonicalStatusIds to include (default: include all)
     *
     * Optional grouping by Strategic Imperatives:
     *  - groupBySI: boolean (default false)
     *  - getSIName: (siId) => string  (required only if groupBySI = true)
     *    If an activity links to multiple SIs, it will appear in each relevant group.
     */
    // === BEGIN NEW HELPER: createActivitiesRightGanttSlide (LEFT TEXT + RIGHT BARS) ===
    // === ACTIVITIES GANTT (left labels, right bars) ===
    async function createActivitiesRightGanttSlide(
        pptx,
        activitiesResp, // { success, data: Activity[] }
        activityStatusStyles, // { [canonicalStatusId]: { fill, line, label } }
        getStatusLabel, // (activity) => canonicalStatusId
        {
            // ── Title / axis
            title = `Timeline of ${activitiesDisplayName}`,
            timeSplit = null, // null => auto; or 'quarter' | 'half' | 'year'
            periodLabelMode = 'yearOver', // 'yearOver' | 'yearHeader' | 'compact'
            periodFont = 6, // smaller Q/H labels
            yearFont = 7, // smaller year strap

            // ── Layout
            slideWidth = 10.0,
            slideHeight = 5.625,
            yOffset = 0.7,
            leftWidthPct = 0.24, // baseline left column (narrower)
            chartHeightPct = 0.68,
            rightPad = 0.25, // extra room on right edge

            // ── Date overrides (auto from data unless provided)
            startDateOverride = null,
            endDateOverride = null,
            // auto granularity thresholds (years)
            maxYearsQuarter = 5, // ≤5y => quarters
            maxYearsHalf = 10, // >5y & ≤10y => halves (else years)

            // ── Rows & bars (half-height feel)
            maxPerSlide = 40,
            minFont = 6,
            maxFont = 10,
            minBarH = 0.055,
            maxBarH = 0.11,
            rowGap = 0.035,

            // ── Snap window to whole periods?
            snapStartToPeriod = true,
            snapEndToPeriod = true,

            // ── Filtering (null => all)
            includeStatuses = null,

            // ── Optional grouping by Strategic Imperatives
            groupBySI = false,
            getSIName = (id) => id,

            // ── Legend
            showLegend = true,
            legendX = null,
            legendY = 0.08,

            // ── Sparse slide boost (use space when there are few rows)
            sparseRowsTarget = 20, // if total activities <= this, treat as sparse
            sparseMaxFont = 12, // allow bigger label font when sparse
            sparseMaxBarH = 0.25, // taller bars allowed on sparse slides
            leftWidthPctSparse = 0.3, // left column widens a bit when sparse
            includeAllActivitiesInNotes = false,
        } = {}
    ) {
        const data = Array.isArray(activitiesResp?.data) ? activitiesResp.data : []
        if (!data.length) return

        function formatNoteDate(value) {
            if (!value) return 'Unknown'
            const d = new Date(value)
            if (Number.isNaN(d.getTime())) return 'Unknown'
            return d.toLocaleDateString('en-US', {
                month: 'short',
                year: 'numeric',
            })
        }

        function buildAllActivitiesNotesText(activityRows = []) {
            const activityLabel = (activitiesDisplayName || 'activities').toLowerCase()

            return [
                `All ${activityLabel}, including those without timeline information, are included in these slide notes.`,
                '',
                ...activityRows.map((a, idx) => {
                    const status = getStatusLabel(a) || a?.status || a?.activityStatus || 'Uncategorized'
                    const start = formatNoteDate(a?.startDate)
                    const end = formatNoteDate(a?.endDate)

                    return `${idx + 1}. ${getActivityTitle(a)} | Status: ${status} | Timeline: ${start} – ${end}`
                }),
            ].join('\n')
        }

        const allActivitiesNotesText = includeAllActivitiesInNotes ? buildAllActivitiesNotesText(data) : ''

        // ===== GEOMETRY (base) =====
        const MARGIN_X = 0.025 * slideWidth
        const LEFT_X = MARGIN_X
        const LEFT_W = leftWidthPct * slideWidth

        const TITLE_Y = 0.1 * slideHeight
        const CHART_Y = TITLE_Y + yOffset

        const CHART_X = LEFT_X + LEFT_W + 0.02 * slideWidth
        const CHART_W = 0.9 * slideWidth - (CHART_X - MARGIN_X) - rightPad
        const CHART_H = chartHeightPct * slideHeight

        // ===== TIME HELPERS =====
        const addQuarter = (d, n) => new Date(d.getFullYear(), d.getMonth() + 3 * n, 1)
        const addHalf = (d, n) => new Date(d.getFullYear(), d.getMonth() + 6 * n, 1)
        const addYear = (d, n) => new Date(d.getFullYear() + n, 0, 1)

        function floorToSplit(d, split) {
            if (split === 'year') return new Date(d.getFullYear(), 0, 1)
            if (split === 'half') return new Date(d.getFullYear(), d.getMonth() < 6 ? 0 : 6, 1)
            return new Date(d.getFullYear(), Math.floor(d.getMonth() / 3) * 3, 1)
        }
        function addSplit(d, n, split) {
            if (split === 'year') return addYear(d, n)
            if (split === 'half') return addHalf(d, n)
            return addQuarter(d, n)
        }

        // ===== WINDOW: earliest→latest with optional overrides =====
        const intervals = data
            .filter((a) => a.startDate && a.endDate)
            .map((a) => [new Date(a.startDate), new Date(a.endDate)])

        let rawStart, rawEnd
        if (startDateOverride instanceof Date && endDateOverride instanceof Date) {
            rawStart = startDateOverride
            rawEnd = endDateOverride
        } else if (intervals.length) {
            const min = new Date(Math.min(...intervals.map((i) => i[0].getTime())))
            const max = new Date(Math.max(...intervals.map((i) => i[1].getTime())))
            rawStart = startDateOverride instanceof Date ? startDateOverride : min
            rawEnd = endDateOverride instanceof Date ? endDateOverride : max
        } else {
            const now = new Date() // small default window
            rawStart = new Date(now.getFullYear() - 1, 0, 1)
            rawEnd = new Date(now.getFullYear() + 1, 0, 1)
        }
        if (rawEnd <= rawStart) rawEnd = addYear(rawStart, 1)

        // Auto granularity if not forced
        let split = timeSplit
        if (!split) {
            const years = (rawEnd - rawStart) / (365.25 * 24 * 3600 * 1000)
            split = years <= maxYearsQuarter ? 'quarter' : years <= maxYearsHalf ? 'half' : 'year'
        }

        const chartStart = snapStartToPeriod ? floorToSplit(rawStart, split) : new Date(rawStart)
        const chartEnd = snapEndToPeriod ? addSplit(floorToSplit(rawEnd, split), 1, split) : new Date(rawEnd)
        const chartDuration = chartEnd - chartStart

        // Build periods for headers/grid
        const periods = []
        for (let t = new Date(chartStart); t < chartEnd; t = addSplit(t, 1, split)) {
            const q = Math.floor(t.getMonth() / 3) + 1
            const label =
                split === 'year'
                    ? String(t.getFullYear())
                    : split === 'half'
                      ? `H${Math.floor(t.getMonth() / 6) + 1}`
                      : `Q${q}`
            periods.push({ label, year: t.getFullYear(), start: new Date(t), end: addSplit(t, 1, split) })
        }
        const colW = CHART_W / periods.length

        // ===== FILTERING =====
        const allowed =
            Array.isArray(includeStatuses) && includeStatuses.length
                ? new Set(includeStatuses.map((s) => String(s).toLowerCase()))
                : null

        const filtered = data.filter((a) => {
            if (!a.startDate || !a.endDate) return false
            if (!allowed) return true
            const id = (getStatusLabel(a) || '').toLowerCase()
            return allowed.has(id)
        })
        if (!filtered.length) return

        // ===== GROUPING =====
        let groups = [{ key: null, label: null, items: filtered }]
        if (groupBySI) {
            const by = new Map()
            for (const a of filtered) {
                const arr = Array.isArray(a?.strategicImperatives)
                    ? a.strategicImperatives
                    : [a?.strategicImperatives].filter(Boolean)
                const keys = arr.length ? arr : ['(Unassigned)']
                for (const k of keys) {
                    if (!by.has(k)) by.set(k, [])
                    by.get(k).push(a)
                }
            }
            groups = Array.from(by.entries()).map(([key, items]) => ({
                key,
                label: key === '(Unassigned)' ? '(Unassigned)' : getSIName(key),
                items,
            }))
        }

        // ===== Truncation (gentler; breathes when fewer rows) =====
        function softTruncate(text, cap) {
            const t = String(text || '')
            return t.length > cap ? t.slice(0, Math.max(0, cap - 1)) + '…' : t
        }

        // ===== Slide factory =====
        function startNewSlide(isCont = false, sectionLabel = null) {
            const slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })

            // Main title
            slide.addText(title, {
                x: MARGIN_X,
                y: TITLE_Y - 0.1,
                w: 0.9 * slideWidth,
                h: 0.35,
                fontSize: 12,
                bold: true,
                color: '000000',
            })

            // Left column label (activity display name)
            slide.addText(activitiesDisplayName, {
                x: LEFT_X,
                y: CHART_Y - 0.26,
                w: LEFT_W,
                h: 0.18,
                align: 'left',
                valign: 'middle',
                fontSize: 9,
                bold: true,
                color: '222222',
            })

            // Optional section label
            if (sectionLabel) {
                slide.addText(sectionLabel, {
                    x: LEFT_X,
                    y: CHART_Y - 0.1,
                    w: LEFT_W,
                    h: 0.16,
                    align: 'left',
                    valign: 'middle',
                    fontSize: 9,
                    color: '444444',
                })
            }

            // Period labels + grid
            if (periodLabelMode === 'yearOver') {
                periods.forEach((p, idx) => {
                    slide.addText(p.label, {
                        x: CHART_X + idx * colW,
                        y: CHART_Y - 0.2,
                        w: colW,
                        h: 0.16,
                        align: 'center',
                        valign: 'middle',
                        fontSize: periodFont,
                        bold: true,
                    })
                })
                const firstIdx = new Map(),
                    lastIdx = new Map()
                periods.forEach((p, idx) => {
                    if (!firstIdx.has(p.year)) firstIdx.set(p.year, idx)
                    lastIdx.set(p.year, idx)
                })
                for (const [year, sIdx] of firstIdx.entries()) {
                    const eIdx = lastIdx.get(year),
                        x0 = CHART_X + sIdx * colW
                    slide.addText(String(year), {
                        x: x0,
                        y: CHART_Y - 0.34,
                        w: (eIdx - sIdx + 1) * colW,
                        h: 0.12,
                        align: 'center',
                        valign: 'middle',
                        fontSize: yearFont,
                        bold: true,
                        color: '444444',
                    })
                }
            }
            periods.forEach((_, idx) => {
                slide.addShape(pptx.ShapeType.line, {
                    x: CHART_X + idx * colW,
                    y: CHART_Y,
                    w: 0.01,
                    h: CHART_H,
                    line: { color: '999999' },
                })
            })
            slide.addShape(pptx.ShapeType.line, {
                x: CHART_X + periods.length * colW,
                y: CHART_Y,
                w: 0.01,
                h: CHART_H,
                line: { color: '999999' },
            })

            if (showLegend && typeof createActivityStatusLegend === 'function') {
                try {
                    createActivityStatusLegend(pptx, slide, activityStatusStyles, slideWidth, legendX, legendY)
                } catch {}
            }

            if (allActivitiesNotesText) {
                const activityLabel = (activitiesDisplayName || 'activities').toLowerCase()

                slide.addText(
                    `All ${activityLabel}, including those without timeline information, are included in the slide notes.`,
                    {
                        x: 1.15,
                        y: 5.32,
                        w: 1.85,
                        h: 0.18,
                        fontSize: 6,
                        italic: true,
                        color: '666666',
                    }
                )

                slide.addNotes(allActivitiesNotesText)
            }
            return slide
        }

        // ===== DRAW =====
        for (const group of groups) {
            const items = group.items
                .filter((a) => a.startDate && a.endDate)
                .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
            if (!items.length) continue

            let slide = null
            let placed = 0

            while (placed < items.length) {
                // helper (place once, outside the loop)
                function softTruncate(txt, cap) {
                    const s = String(txt || '')
                    return s.length > cap ? s.slice(0, cap - 1) + '…' : s
                }

                while (placed < items.length) {
                    const remaining = items.length - placed
                    let rowsThisSlide = Math.min(remaining, maxPerSlide)

                    // ---- Sparse detection & local geometry ---------------------------------
                    // Treat the WHOLE dataset as sparse (so we scale labels/bars consistently across slides)
                    const isSparse = items.length <= (sparseRowsTarget ?? 20)
                    const localLeftW = isSparse ? Math.max(LEFT_W, (leftWidthPctSparse ?? 0.3) * slideWidth) : LEFT_W
                    const chartX_this = isSparse ? LEFT_X + localLeftW + 0.02 * slideWidth : CHART_X
                    const chartW_this = isSparse ? 0.9 * slideWidth - (chartX_this - MARGIN_X) - rightPad : CHART_W

                    // ---- Bar height (allow taller when sparse) ------------------------------
                    const hAvail = CHART_H - (rowsThisSlide - 1) * rowGap
                    const effectiveMaxBarH = isSparse ? Math.max(maxBarH, sparseMaxBarH ?? 0.2) : maxBarH
                    let barH = Math.min(effectiveMaxBarH, Math.max(minBarH, hAvail / rowsThisSlide))
                    if (barH > effectiveMaxBarH) {
                        barH = effectiveMaxBarH
                        rowsThisSlide = Math.max(1, Math.floor((CHART_H + rowGap) / (barH + rowGap)))
                    }

                    // ---- Label font (allow higher ceiling when sparse) ----------------------
                    const effectiveMaxFont = isSparse ? Math.max(maxFont, sparseMaxFont ?? 12) : maxFont
                    const labelFont = Math.max(minFont, Math.min(effectiveMaxFont, Math.round(barH * 24)))

                    // ---- Make the slide -----------------------------------------------------
                    slide = startNewSlide(placed > 0, groupBySI ? group.label : null)

                    // local time→X using chartX_this/chartW_this
                    const timeToX_this = (s, e) => {
                        const ss = new Date(Math.max(new Date(s), chartStart))
                        const ee = new Date(Math.max(ss, Math.min(new Date(e), chartEnd)))
                        const xs = chartX_this + ((ss - chartStart) / chartDuration) * chartW_this
                        const xe = chartX_this + ((ee - chartStart) / chartDuration) * chartW_this
                        return [xs, Math.max(0.02, xe - xs)]
                    }

                    for (let r = 0; r < rowsThisSlide && placed < items.length; r++, placed++) {
                        const a = items[placed]
                        const s = new Date(a.startDate)
                        const e = new Date(a.endDate)
                        const [x, w] = timeToX_this(s, e)
                        const y = CHART_Y + r * (barH + rowGap)

                        // Softer truncation: allow more chars when the overall list is sparse
                        const baseCap = 75
                        const breathing = Math.max(0, (sparseRowsTarget ?? 20) - items.length) * 2 // +2 chars per row below target
                        const labelCap = baseCap + breathing
                        const labelText = softTruncate(getActivityTitle(a), labelCap)
                        // Left label
                        slide.addText(labelText, {
                            x: LEFT_X + 0.06,
                            y,
                            w: localLeftW - 0.12,
                            h: barH,
                            align: 'left',
                            valign: 'middle',
                            fontSize: labelFont,
                            color: '0A0A0A',
                        })

                        // Bar (no text inside)
                        const stId = getStatusLabel(a)
                        const style = activityStatusStyles[stId] ||
                            activityStatusStyles['Uncategorized'] || {
                                fill: '999999',
                                line: '999999',
                            }
                        slide.addShape(pptx.ShapeType.roundRect, {
                            x,
                            y,
                            w,
                            h: barH,
                            fill: { color: style.fill },
                            line: { color: style.line, width: 1 },
                            rectRadius: 0.05,
                        })
                    }
                }
            }
        }
    }

    async function createAspirationalRightGanttSlide(
        pptx,
        rowsIn,
        activityStatusStyles,
        getStatusLabel,
        {
            // layout / geometry
            slideWidth = 10.0,
            slideHeight = 5.625,
            title = `${vmsDisplayName} + Timeline of ${activitiesDisplayName}`, // dynamic title based on displayNames
            yOffset = 0.7,
            leftWidthPct = 0.39,
            chartHeightPct = 0.7,

            vmFilterLabel = 'aspirational', // shown above the VM column; e.g. "aspirational, supported-suboptimal"

            // time axis
            timeSplit = 'quarter', //  'quarter' | 'half' | 'year'
            periodLabelMode = 'yearOver', // 'yearOver' | 'compact' | 'yearHeader'
            periodFont = 7,
            yearFont = 9, // size for the single YEAR label above the chart

            // date-window overrides
            startDateOverride = null,
            endDateOverride = null,
            padPeriodsBefore = 0,
            padPeriodsAfter = 0,
            clampToOverrides = false,

            // bars & spacing (no overlap)
            barHeight = 0.22,
            stackGap = 0.16,
            rowPadTop = 0.06,
            rowPadBottom = 0.06,
            minRowH = 0.46,
            centerSingleActivity = true,

            // VM-to-VM fixed gap (Option 1)
            vmRowGap = 0.08, // extra space AFTER each VM row

            // VM list & optional VM window
            vmListFont = 8,
            showVmWindowBar = true,
            vmBarStyle = { fill: 'B4A7D6', line: '8064A2' },

            // activity label sizing
            actFontMax = 7,
            actFontMin = 3,

            // filtering
            onlyWithActiveActivities = true,
            includeStatuses = ['planned', 'initiated', 'ongoing', 'uncategorized', 'proposed', 'active'], // 'on-hold',

            // VM header sizing (above the VM column)
            vmHeaderMinHeight = 0.2, // default height (inches)
            vmHeaderLineHeight = 0.14, // added per extra wrapped line
            vmHeaderGap = 0.04, // visual gap between header bottom and chart top
            vmHeaderMaxCharsPerLine = 34, // rough wrap heuristic for auto-height

            // legend
            showLegend = true,
            legendX = null,
            legendY = 0.08,

            // ── TKR debug - remove after: debug toggle
            debugColors = true,
        } = {}
    ) {
        if (!rowsIn || !rowsIn.length) return

        // Normalize statuses before filtering
        const normalize = (s) =>
            (s || '')
                .toLowerCase()
                .replace(/[-_\s]+/g, ' ')
                .trim()
        const allowed = new Set(includeStatuses.map(normalize))

        const rows = rowsIn
            .map((r) => ({
                ...r,
                acts: (r.acts || []).filter((a) =>
                    allowed.has(normalize(getStatusLabel?.(a) || a?.status || a?.activityStatus))
                ),
            }))
            .filter((r) => !onlyWithActiveActivities || (r.acts && r.acts.length))

        if (!rows.length) return

        const activityNumberMap = buildActivityNumberingMap(rows)
        const activityNotesText = buildActivityNotesText(activityNumberMap, rows)

        // geometry
        const MARGIN_X = 0.05 * slideWidth
        const LEFT_X = MARGIN_X
        const LEFT_W = leftWidthPct * slideWidth
        const CHART_X = LEFT_X + LEFT_W + 0.02 * slideWidth

        const TITLE_Y = 0.1 * slideHeight
        const CHART_Y = TITLE_Y + yOffset
        const CHART_W = 0.9 * slideWidth - (CHART_X - MARGIN_X)
        const CHART_H = chartHeightPct * slideHeight

        function measureVmHeaderHeight() {
            const label = vmFilterLabel ? `${vmsDisplayName} (${vmFilterLabel})` : vmsDisplayName
            if (!vmFilterLabel) return vmHeaderMinHeight // single-line default
            const estLines = Math.max(1, Math.ceil(label.length / vmHeaderMaxCharsPerLine))
            return Math.max(vmHeaderMinHeight, estLines * vmHeaderLineHeight)
        }
        const VM_HEADER_H = measureVmHeaderHeight()

        // Timeline windows with manual override
        // collect all date intervals from VMs + activities
        const intervals = []
        rows.forEach(({ vm, acts }) => {
            if (vm?.startDate && vm?.endDate) intervals.push([new Date(vm.startDate), new Date(vm.endDate)])
            ;(acts || []).forEach((a) => {
                if (a.startDate && a.endDate) intervals.push([new Date(a.startDate), new Date(a.endDate)])
            })
        })

        // split-aware floor/adder
        function floorToSplit(d) {
            if (timeSplit === 'year') return new Date(d.getFullYear(), 0, 1)
            if (timeSplit === 'half') return new Date(d.getFullYear(), d.getMonth() < 6 ? 0 : 6, 1)
            return new Date(d.getFullYear(), Math.floor(d.getMonth() / 3) * 3, 1) // quarter
        }
        function addSplit(d, n) {
            if (timeSplit === 'year') return new Date(d.getFullYear() + n, 0, 1)
            if (timeSplit === 'half') return new Date(d.getFullYear(), d.getMonth() + n * 6, 1)
            return new Date(d.getFullYear(), d.getMonth() + n * 3, 1) // quarter
        }

        // derive base window from data (or fallback to "now")
        const now = new Date()
        let chartStart, chartEnd
        if (intervals.length) {
            const min = new Date(Math.min(...intervals.map((i) => i[0].getTime())))
            const max = new Date(Math.max(...intervals.map((i) => i[1].getTime())))
            chartStart = floorToSplit(min)
            chartEnd = addSplit(floorToSplit(max), 1) // include last period fully
        } else {
            chartStart = floorToSplit(now)
            chartEnd = addSplit(chartStart, 8) // default window = 8 periods
        }

        // apply explicit overrides (optional)
        if (startDateOverride instanceof Date) chartStart = floorToSplit(startDateOverride)
        if (endDateOverride instanceof Date) chartEnd = addSplit(floorToSplit(endDateOverride), 1)

        // optional padding periods (before/after)
        if (padPeriodsBefore) chartStart = addSplit(chartStart, -padPeriodsBefore)
        if (padPeriodsAfter) chartEnd = addSplit(chartEnd, +padPeriodsAfter)

        // Helper functions for each increment
        const addQuarter = (d, n) => new Date(d.getFullYear(), d.getMonth() + n * 3, 1)
        const addHalf = (d, n) => new Date(d.getFullYear(), d.getMonth() + n * 6, 1)
        const addYear = (d, n) => new Date(d.getFullYear() + n, 0, 1)

        const periods = []

        if (timeSplit === 'half') {
            // --- Biannual (H1, H2)
            for (let t = new Date(chartStart); t < chartEnd; t = addHalf(t, 1)) {
                const h = Math.floor(t.getMonth() / 6) + 1 // 1 or 2
                const label = 'H' + h // H1, H2
                periods.push({
                    label,
                    half: h,
                    year: t.getFullYear(),
                    start: new Date(t),
                    end: addHalf(t, 1),
                })
            }
        } else if (timeSplit === 'year') {
            // --- Annual (Y2025)
            for (let t = new Date(chartStart); t < chartEnd; t = addYear(t, 1)) {
                const y = t.getFullYear()
                const label = String(y) // Just the year (e.g., 2025)
                periods.push({
                    label,
                    year: y,
                    start: new Date(t),
                    end: addYear(t, 1),
                })
            }
        } else {
            // --- Quarterly (Q1–Q4)
            for (let t = new Date(chartStart); t < chartEnd; t = addQuarter(t, 1)) {
                const q = Math.floor(t.getMonth() / 3) + 1
                const label = 'Q' + q // Q1, Q2, Q3, Q4
                periods.push({
                    label,
                    quarter: q,
                    year: t.getFullYear(),
                    start: new Date(t),
                    end: addQuarter(t, 1),
                })
            }
        }

        const chartDuration = chartEnd - chartStart
        const colWidth = CHART_W / periods.length

        function timeToX(start, end) {
            let s = new Date(start)
            let e = new Date(end)

            // Apply clamping rules only if clampToOverrides is TRUE
            if (clampToOverrides) {
                s = new Date(Math.max(s, chartStart))
                e = new Date(Math.min(e, chartEnd))
                if (e < s) e = s // avoid negative width
            } else {
                // still calculate coordinates but don’t hard-cut bars
                s = new Date(Math.max(s, chartStart))
                e = new Date(Math.max(s, Math.min(e, chartEnd)))
            }

            const xs = CHART_X + ((s - chartStart) / chartDuration) * CHART_W
            const xe = CHART_X + ((e - chartStart) / chartDuration) * CHART_W
            return [xs, Math.max(0.04, xe - xs)]
        }

        // pack overlapping activities into levels
        function packLevels(acts) {
            const LABEL_COLLISION_PAD_MS = 240 * 24 * 60 * 60 * 1000

            const items = (acts || [])
                .filter((a) => a.startDate && a.endDate)
                .map((a) => {
                    const rawS = new Date(a.startDate).getTime()
                    const rawE = new Date(a.endDate).getTime()

                    const visibleS = Math.max(rawS, chartStart.getTime())
                    const visibleE = Math.min(rawE, chartEnd.getTime())

                    return {
                        a,
                        rawS,
                        rawE,

                        // Use padded visible dates for collision detection so outside labels
                        // are less likely to overlap nearby bars on the same row.
                        s: visibleS - LABEL_COLLISION_PAD_MS,
                        e: visibleE + LABEL_COLLISION_PAD_MS,

                        // Only draw activities that actually intersect the visible chart window.
                        isVisible: rawE >= chartStart.getTime() && rawS <= chartEnd.getTime(),
                    }
                })
                .filter((item) => item.isVisible)
                .sort((x, y) => x.s - y.s)

            const placed = []
            const out = []

            for (const it of items) {
                let level = 0
                while (placed.some((p) => p.level === level && !(it.e <= p.s || it.s >= p.e))) level++
                placed.push({ s: it.s, e: it.e, level })
                out.push({ a: it.a, level })
            }

            const levelsUsed = placed.length ? Math.max(...placed.map((p) => p.level)) + 1 : 0
            return { packed: out, levelsUsed }
        }

        let slide = null
        function startNewSlide(isCont = false) {
            slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })

            // Title
            slide.addText(title, {
                x: MARGIN_X,
                y: TITLE_Y - 0.1,
                w: 0.9 * slideWidth,
                h: 0.35,
                fontSize: 12,
                bold: true,
                color: '000000',
            })

            // Left header
            const vmHeader = vmFilterLabel ? `${vmsDisplayName} (${vmFilterLabel})` : vmsDisplayName
            const HEADER_Y = CHART_Y - VM_HEADER_H - vmHeaderGap
            slide.addText(vmHeader, {
                x: LEFT_X,
                y: HEADER_Y,
                w: LEFT_W,
                h: VM_HEADER_H,
                align: 'left',
                valign: 'middle',
                fontSize: 9,
                bold: true,
            })

            // Legend
            if (showLegend && typeof createActivityStatusLegend === 'function') {
                try {
                    createActivityStatusLegend(pptx, slide, activityStatusStyles, slideWidth, legendX, legendY)
                } catch {}
            }

            slide.addText('Superscript numbers correspond to activity details in slide notes.', {
                x: MARGIN_X,
                y: 5.02,
                w: 4.8,
                h: 0.2,
                fontSize: 6,
                italic: true,
                color: '666666',
            })

            if (activityNotesText) {
                slide.addNotes(activityNotesText)
            }
        }

        // renderAxisAndGrid (draws period labels + grid BEHIND content with dynamic H)
        function renderAxisAndGrid(slideRef, gridH) {
            const effectiveH = Math.max(0.01, gridH)

            // PERIOD LABELS
            if (periodLabelMode === 'yearOver') {
                periods.forEach((p, idx) => {
                    slideRef.addText(p.label, {
                        x: CHART_X + idx * colWidth,
                        y: CHART_Y - 0.2,
                        w: colWidth,
                        h: 0.18,
                        align: 'center',
                        valign: 'middle',
                        fontSize: periodFont,
                        bold: true,
                    })
                })
                const firstIdxByYear = new Map()
                const lastIdxByYear = new Map()
                periods.forEach((p, idx) => {
                    if (!firstIdxByYear.has(p.year)) firstIdxByYear.set(p.year, idx)
                    lastIdxByYear.set(p.year, idx)
                })
                for (const [year, startIdx] of firstIdxByYear.entries()) {
                    const endIdx = lastIdxByYear.get(year)
                    const xStart = CHART_X + startIdx * colWidth
                    const wSpan = (endIdx - startIdx + 1) * colWidth
                    slideRef.addText(String(year), {
                        x: xStart,
                        y: CHART_Y - 0.34,
                        w: wSpan,
                        h: 0.14,
                        align: 'center',
                        valign: 'middle',
                        fontSize: yearFont,
                        bold: true,
                        color: '444444',
                    })
                }
            } else if (periodLabelMode === 'yearHeader') {
                let lastYear = null
                periods.forEach((p, idx) => {
                    if (p.year !== lastYear) {
                        slideRef.addText(String(p.year), {
                            x: CHART_X + idx * colWidth,
                            y: CHART_Y - 0.32,
                            w: colWidth,
                            h: 0.12,
                            align: 'left',
                            fontSize: periodFont,
                            bold: true,
                            color: '444444',
                        })
                        lastYear = p.year
                    }
                    slideRef.addText(p.label, {
                        x: CHART_X + idx * colWidth,
                        y: CHART_Y - 0.2,
                        w: colWidth,
                        h: 0.18,
                        align: 'center',
                        valign: 'middle',
                        fontSize: periodFont,
                        bold: true,
                    })
                })
            } else {
                // compact
                let lastYear = null
                periods.forEach((p, idx) => {
                    const showYear = p.year !== lastYear || timeSplit === 'year'
                    const yy = String(p.year).slice(-2)
                    const txt = timeSplit === 'year' ? String(p.year) : showYear ? `${p.label} ${yy}` : p.label
                    slideRef.addText(txt, {
                        x: CHART_X + idx * colWidth,
                        y: CHART_Y - 0.22,
                        w: colWidth,
                        h: 0.18,
                        align: 'center',
                        valign: 'middle',
                        fontSize: periodFont,
                        bold: true,
                    })
                    lastYear = p.year
                })
            }

            // GRID LINES (drawn first so they sit behind subsequent content)
            periods.forEach((_, idx) => {
                slideRef.addShape(pptx.ShapeType.line, {
                    x: CHART_X + idx * colWidth,
                    y: CHART_Y,
                    w: 0.01,
                    h: effectiveH,
                    line: { color: '999999' },
                })
            })
            slideRef.addShape(pptx.ShapeType.line, {
                x: CHART_X + periods.length * colWidth,
                y: CHART_Y,
                w: 0.01,
                h: effectiveH,
                line: { color: '999999' },
            })
        }

        // paginateAndRender (two-pass per slide: MEASURE, then RENDER grid, then ROWS)

        ;(function paginateAndRender() {
            let i = 0 // global row pointer across slides

            while (i < rows.length) {
                // 1) MEASURE how many rows fit on this slide and the total used height
                const startIdx = i
                let y = CHART_Y

                while (i < rows.length) {
                    const { acts } = rows[i]
                    const { levelsUsed } = packLevels(acts)
                    const stackedBlockH =
                        levelsUsed > 0 ? levelsUsed * barHeight + (levelsUsed - 1) * stackGap : barHeight
                    const rowH = Math.max(minRowH, rowPadTop + stackedBlockH + rowPadBottom)

                    const addGap = i > startIdx ? vmRowGap : 0
                    if (y + addGap + rowH > CHART_Y + CHART_H) break

                    y += addGap + rowH
                    i++
                }

                // ensure at least one row renders
                if (i === startIdx) {
                    i = startIdx + 1
                    y = Math.min(CHART_Y + CHART_H, CHART_Y + minRowH)
                }

                const endIdx = i // non-inclusive
                const usedH = Math.max(0.01, y - CHART_Y)
                const isCont = startIdx > 0

                // 2) RENDER: start slide, draw grid behind with measured height, then draw rows on top
                startNewSlide(isCont)
                renderAxisAndGrid(slide, usedH)

                // draw rows slice
                let currentY = CHART_Y
                for (let r = startIdx; r < endIdx; r++) {
                    const { vm, acts } = rows[r]
                    const { packed, levelsUsed } = packLevels(acts)
                    const stackedBlockH =
                        levelsUsed > 0 ? levelsUsed * barHeight + (levelsUsed - 1) * stackGap : barHeight
                    const rowH = Math.max(minRowH, rowPadTop + stackedBlockH + rowPadBottom)

                    if (r > startIdx) currentY += vmRowGap

                    // LEFT: VM box + text (not bold, no numbering)
                    slide.addShape(pptx.ShapeType.rect, {
                        x: LEFT_X,
                        y: currentY,
                        w: LEFT_W,
                        h: rowH,
                        fill: r % 2 === 0 ? 'F7FAFF' : 'FFFFFF',
                        line: 'E0E6EF',
                    })
                    slide.addText(vm?.name || `(No ${vmsDisplayName})`, {
                        x: LEFT_X + 0.04,
                        y: currentY + 0.03,
                        w: LEFT_W - 0.08,
                        h: rowH - 0.06,
                        fontFace: 'Arial',
                        fontSize: vmListFont,
                        color: '0A0A0A',
                        bold: false,
                        valign: 'middle',
                    })

                    // Optional VM window bar
                    if (showVmWindowBar && vm?.startDate && vm?.endDate) {
                        const [vx, vw] = timeToX(new Date(vm.startDate), new Date(vm.endDate))
                        const vmY = currentY + Math.max(rowPadTop, (rowH - barHeight) * 0.15)
                        slide.addShape(pptx.ShapeType.roundRect, {
                            x: vx,
                            y: vmY,
                            w: vw,
                            h: barHeight,
                            fill: { color: vmBarStyle.fill },
                            line: { color: vmBarStyle.line, width: 1 },
                            rectRadius: 0.05,
                        })
                        if (vw >= 0.22) {
                            const fs = Math.min(actFontMax, 8)
                            const label = getTruncatedTextForGantt(vm.name || 'VM', vw, fs)
                            slide.addText(label, {
                                x: vx + 0.03,
                                y: vmY,
                                w: Math.max(0, vw - 0.06),
                                h: barHeight,
                                fontSize: fs,
                                bold: true,
                                color: '1E293B',
                                valign: 'middle',
                            })
                        }
                    }

                    // RIGHT: activities
                    if (packed.length) {
                        for (const { a, level } of packed) {
                            const [x, w] = timeToX(new Date(a.startDate), new Date(a.endDate))
                            const yBar =
                                levelsUsed === 1 && centerSingleActivity
                                    ? currentY + (rowH - barHeight) / 2
                                    : currentY + rowPadTop + level * (barHeight + stackGap)

                            const statusLabel = getStatusLabel(a)
                            const style = activityStatusStyles[statusLabel] || activityStatusStyles['Uncategorized']

                            slide.addShape(pptx.ShapeType.roundRect, {
                                x,
                                y: yBar,
                                w,
                                h: barHeight,
                                fill: { color: style.fill },
                                line: { color: style.line, width: 1 },
                                rectRadius: 0.05,
                            })

                            // Replacing to have numbering for the truncated activities that correspond to the right activities in the slide notes
                            /*const fs = getFontSizeForGantt(a.title, w, actFontMax, actFontMin)
                            const label = getTruncatedTextForGantt(a.title, w, fs)
                            if (w >= 0.16) {
                                slide.addText(label, {
                                    x: x + 0.03,
                                    y: yBar,
                                    w: Math.max(0, w - 0.06),
                                    h: barHeight,
                                    fontSize: fs,
                                    color: '000000',
                                    align: 'center',
                                    valign: 'middle',
                                })
                            }*/

                            const activityNumber = getActivityNumber(a, activityNumberMap)
                            const activityTitle = getActivityTitle(a)

                            const MIN_TEXT_WIDTH = 0.9
                            const OUTSIDE_LABEL_MAX_W = 3.2
                            const OUTSIDE_LABEL_GAP = 0.03

                            let textX = x + 0.015
                            let textW = Math.max(0, w - 0.03)
                            let align = 'center'
                            let isOutsideLabel = false

                            if (w < MIN_TEXT_WIDTH) {
                                const spaceRight = CHART_X + CHART_W - (x + w)
                                const spaceLeft = x - CHART_X

                                if (spaceRight >= spaceLeft) {
                                    textX = x + w + OUTSIDE_LABEL_GAP
                                    textW = Math.max(0.6, Math.min(OUTSIDE_LABEL_MAX_W, spaceRight - OUTSIDE_LABEL_GAP))
                                    align = 'left'
                                } else {
                                    textW = Math.max(0.6, Math.min(OUTSIDE_LABEL_MAX_W, spaceLeft - OUTSIDE_LABEL_GAP))
                                    textX = x - textW - OUTSIDE_LABEL_GAP
                                    align = 'right'
                                }

                                isOutsideLabel = true
                            }

                            const fs = isOutsideLabel
                                ? actFontMax
                                : getFontSizeForGantt(activityTitle, textW, actFontMax, actFontMin)

                            const TRUNCATION_BOOST = isOutsideLabel ? 1.6 : 1.1

                            const label = getTruncatedTextForGantt(activityTitle, textW * TRUNCATION_BOOST, fs)

                            if (label) {
                                slide.addText(`${label}${activityNumber ? toSuperscriptNumber(activityNumber) : ''}`, {
                                    x: textX,
                                    y: yBar,
                                    w: textW,
                                    h: barHeight,
                                    fontSize: fs,
                                    color: '000000',
                                    align,
                                    valign: 'middle',
                                    margin: 0.01,
                                })
                            }
                        }
                    }

                    currentY += rowH
                }
                // loop continues with next chunk of rows …
            }
        })()
    }

    // Dynamic, auto-sizing legend for any # of statuses (6, 8, ...)
    // - x, y are the top-left of the legend box
    function createActivityStatusLegend(
        pptx,
        slide,
        activityStatusStyles,
        slideWidth = 10.0,
        x = null,
        y = 0.1,
        {
            maxCols = null,
            minCols = 2,
            maxColsCap = 2,
            cellW = 0.79,
            cellH = 0.15,
            swatch = 0.075,
            padX = 0.08,
            padY = 0.06,
            gapY = 0.015,
            baseFont = 6,
            denseFont = 5.5,
            maxLabelChars = 16,
            rightMargin = 0.2,
            align = 'right',
            linePt = 0.75,
        } = {}
    ) {
        const items = Object.entries(activityStatusStyles || {})
            .filter(([id]) => String(id).trim().toLowerCase() !== 'uncategorized')
            .map(([id, style]) => ({
                id,
                ...style,
                text: style?.label || id,
            }))

        if (!items.length) return null

        const cols = maxCols ? Math.max(minCols, Math.min(maxCols, maxColsCap)) : 2

        const rows = Math.ceil(items.length / cols)
        const labelFont = rows >= 3 ? denseFont : baseFont

        const innerW = padX * 2 + cols * cellW
        const innerH = padY * 2 + rows * cellH + (rows - 1) * gapY

        const legendX = x !== null ? x : align === 'right' ? slideWidth - innerW - rightMargin : rightMargin

        slide.addShape(pptx.ShapeType.rect, {
            x: legendX,
            y,
            w: innerW,
            h: innerH,
            fill: { color: 'FFFFFF' },
            line: { color: '000000', width: linePt },
        })

        const gridX = legendX + padX
        const gridY = y + padY

        const ellipsize = (text) =>
            String(text || '').length > maxLabelChars ? `${String(text).slice(0, maxLabelChars - 1)}…` : text

        items.forEach((item, index) => {
            const row = Math.floor(index / cols)
            const column = index % cols

            const cellX = gridX + column * cellW
            const cellY = gridY + row * (cellH + gapY)

            slide.addShape(pptx.ShapeType.rect, {
                x: cellX,
                y: cellY + (cellH - swatch) / 2,
                w: swatch,
                h: swatch,
                fill: { color: item.fill || '999999' },
                line: {
                    color: item.line || '999999',
                    width: 0.5,
                },
            })

            slide.addText(ellipsize(item.text), {
                x: cellX + swatch + 0.035,
                y: cellY,
                w: cellW - (swatch + 0.045),
                h: cellH,
                fontSize: labelFont,
                color: '000000',
                align: 'left',
                valign: 'middle',
                margin: 0,
            })
        })

        return {
            x: legendX,
            y,
            w: innerW,
            h: innerH,
            right: legendX + innerW,
            rightX: legendX + innerW,
            bottom: y + innerH,
        }
    }

    // ─────────────────────────────────────────────────────────────
    // Reusable Status Legend Helper to be used by slides with
    // aspirational, supported Status circles
    // ─────────────────────────────────────────────────────────────
    const STATUS_COLORS = {
        Supported: '09cc9e',
        'Supported-suboptimal': 'ff9c2b',
        Aspirational: 'c30a30',
    }

    // Keep your existing STATUS_COLORS as-is
    // const STATUS_COLORS = { Supported: '09cc9e', 'Supported-suboptimal': 'ff9c2b', Aspirational: 'c30a30' };

    function addStatusLegend(slide, cfg = {}) {
        const {
            x = 5.5,
            y = 0.15,
            padding = 0.07,
            showBox = true,

            // compact stacked layout
            dotSize = 8,
            fontSize = 6,
            rowH = 0.16,
            symbolW = 0.16,
            labelW = 0.63,
            labels = null,
            linePt = 0.75,
        } = cfg

        const items = labels || [
            { label: 'Supported', color: STATUS_COLORS['Supported'] },
            { label: 'Supp.-subopt.', color: STATUS_COLORS['Supported-suboptimal'] },
            { label: 'Aspirational', color: STATUS_COLORS['Aspirational'] },
        ]

        const w = padding * 2 + symbolW + labelW
        const h = padding * 2 + items.length * rowH

        if (showBox && slide.addShape) {
            slide.addShape('rect', {
                x,
                y,
                w,
                h,
                fill: { color: 'FFFFFF' },
                line: { color: '000000', pt: linePt },
            })
        }

        items.forEach((it, i) => {
            const cy = y + padding + i * rowH

            slide.addText('◉', {
                x: x + padding,
                y: cy,
                w: symbolW,
                h: rowH,
                fontSize: dotSize,
                color: it.color,
                valign: 'middle',
                align: 'left',
                margin: 0,
            })

            slide.addText(it.label, {
                x: x + padding + symbolW,
                y: cy,
                w: labelW,
                h: rowH,
                fontSize,
                color: '000000',
                valign: 'middle',
                align: 'left',
                margin: 0,
            })
        })

        return { x, y, w, h, right: x + w, bottom: y + h }
    }

    async function addValuePropSlide(pptx) {
        let positioningStatement = store.getState().strategy.positioningStatement
        let slide = pptx.addSlide({ masterName: 'CONTENT_SLIDE' })
        slide.addText(
            [
                {
                    text: valuePropositionDisplayName.singular || 'Loading',
                    options: {
                        color: blueHeaders,
                        fontSize: 24,
                        bold: true,
                        fontFace: 'Arial',
                        align: 'left',
                        isTextBox: true,
                        autoFit: true, // We should be using one or the other testing with this removed.
                        // Titles, headers, or labels (short, single-line text): use autoFit: true.
                        // shrinkText: true, //
                    },
                },
            ],
            { y: 1.9, x: 0.59, w: 2.94, h: 0.96, align: 'left' }
        )
        slide.addText(
            [
                {
                    text: positioningStatement,
                    options: {
                        color: textColor,
                        fontFace: 'Arial',
                        fontSize: 12, // fit: 'shrink' doesn't seem to work so just forcing it to be fontSize 12
                        align: 'left',
                        isTextBox: true,
                        fit: 'shrink',
                        // autoFit: true,
                        // shrinkText: true,
                    },
                },
            ],
            { y: 0.69, x: 3.8, w: 5.7, h: 4.25, align: 'left' } // Increasing the height of the box so shrinkText won't go too far.
        )
        slide.addShape(pptx.ShapeType.rect, { x: 0.59, y: 2.84, w: 2.56, h: 0.05, fill: blueHeaders })
    }

    // if user's org has enabled Gap Analyses, add it to the menu

    // Activities tracker
    async function handleActivitiesTrackerExcelExport() {
        try {
            setActivitiesExcelExporting(true)

            let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

            const strategyId = store.getState().strategy?._id
            if (!strategyId) throw new Error('No strategy selected')

            const activities = await fetchActivitiesForExport({
                callSecureAPI,
                endpoints,
                strategyId,
                token,
            })

            await exportActivitiesTrackerToExcel(activities, 'activities_tracker.xlsx')

            logEvent(ACTIONS.EXCEL_EXPORT, {
                reportType: 'ACTIVITIES_TRACKER',
                activityCount: activities.length,
            })
        } catch (err) {
            console.error('Error exporting Activities Tracker Excel:', err)

            if (typeof cannotExportPPTX === 'function') {
                cannotExportPPTX(`Failed to export Activities Tracker Excel: ${err.message}`)
            }
        } finally {
            setActivitiesExcelExporting(false)
        }
    }

    async function handleDisseminationPrioritizationExcelExport() {
        try {
            setDisseminationPrioritizationExcelExporting(true)

            let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

            const strategyId = store.getState().strategy?._id
            if (!strategyId) throw new Error('No strategy selected')

            const model = await fetchDisseminationPrioritizationExportData({
                callSecureAPI,
                endpoints,
                strategyId,
                token,
            })

            await exportDisseminationPrioritizationWorkbook(model, 'ATLAS_dissemination_prioritization.xlsx')

            logEvent(ACTIONS.EXCEL_EXPORT, {
                reportType: 'DISSEMINATION_PRIORITIZATION',
            })
        } catch (err) {
            console.error('Error exporting Dissemination Prioritization Excel:', err)

            if (typeof cannotExportPPTX === 'function') {
                cannotExportPPTX(`Failed to export Dissemination Prioritization Excel: ${err.message}`)
            }
        } finally {
            setDisseminationPrioritizationExcelExporting(false)
        }
    }

    // JSON exports outside of the PPT switch case

    async function handleActivitiesJsonExport() {
        try {
            setActivitiesJsonExporting(true)

            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const strategyId = store.getState().strategy?._id

            if (!strategyId) throw new Error('No strategy selected')

            await exportActivitiesJson({
                callSecureAPI,
                endpoints,
                strategyId,
                token,
                vmNameMap: {},
            })

            logEvent(ACTIONS.JSON_EXPORT, {
                reportType: 'ACTIVITIES',
            })
        } catch (err) {
            console.error('Error exporting Activities JSON:', err)
            cannotExportPPTX(`Failed to export Activities JSON: ${err.message}`)
        } finally {
            setActivitiesJsonExporting(false)
        }
    }

    function cannotExportPPTX(errorString) {
        setErrorModalText(errorString)
        setOpenModal(true)
        setOpenPptxCustomizationModal(false)
    }

    async function handleTrppJsonExport() {
        try {
            setTrppJsonExporting(true)

            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

            await exportTrppJson({
                callSecureAPI,
                endpoints,
                strategy: store.getState().strategy,
                token,
                tppDisplayName,
                evidenceById: {},
                vmNameMap: {},
                kesByEvidenceId: new Map(),
            })

            logEvent(ACTIONS.JSON_EXPORT, {
                reportType: 'TRPP',
            })
        } catch (err) {
            console.error('Error exporting TrPP JSON:', err)
            cannotExportPPTX(`Failed to export ${tppDisplayName} JSON: ${err.message}`)
        } finally {
            setTrppJsonExporting(false)
        }
    }

    async function handleValueNarrativesFullJsonExport() {
        try {
            setValueNarrativesJsonExporting(true)

            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const strategyId = store.getState().strategy?._id

            if (!strategyId) throw new Error('No strategy selected')

            await exportValueNarrativesFullJson({
                callSecureAPI,
                endpoints,
                strategyId,
                token,
                vnsDisplayName,
                vmsDisplayName,
            })

            logEvent(ACTIONS.JSON_EXPORT, {
                reportType: 'VALUE_NARRATIVES_FULL',
            })
        } catch (err) {
            console.error('Error exporting Value Narratives JSON:', err)
            cannotExportPPTX(`Failed to export ${vnsDisplayName}: ${err.message}`)
        } finally {
            setValueNarrativesJsonExporting(false)
        }
    }

    async function handleEvidenceJsonExport() {
        try {
            setEvidenceJsonExporting(true)

            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const strategyId = store.getState().strategy?._id

            if (!strategyId) throw new Error('No strategy selected')

            await exportEvidenceJson({
                callSecureAPI,
                endpoints,
                strategyId,
                token,
            })

            logEvent(ACTIONS.JSON_EXPORT, {
                reportType: 'EVIDENCE',
            })
        } catch (err) {
            console.error('Error exporting Evidence JSON:', err)
            cannotExportPPTX(`Failed to export ${evidenceDisplayName}: ${err.message}`)
        } finally {
            setEvidenceJsonExporting(false)
        }
    }

    const updateFreeTrialStatus = (organizationData) => {
        dispatch(
            setFreeTrialStatus({
                isFreeTrial: Boolean(organizationData?.isFreeTrial),
                freeTrialStartDate: organizationData?.freeTrialStartDate || null,
            })
        )
    }

    const updatePicoEnabled = (organizationData) => {
        dispatch(setIsPicoEnabled(Boolean(organizationData?.isPicoEnabled)))
    }
    const updateMaiaEnabled = (organizationData) => {
        dispatch(setIsMaiaEnabled(Boolean(organizationData?.isMaiaEnabled)))
    }

    async function getOrg() {
        if (user) {
            let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            let parsedUserId = user.sub.split('|')
            if (parsedUserId.length >= 2) {
                let userId = parsedUserId.slice(1).join('|')
                let user = await callSecureAPI(
                    endpoints.getUserAuth0.url + userId + '/auth0',
                    endpoints.getUserAuth0.method,
                    token
                )
                if (user.success) {
                    let org = await callSecureAPI(
                        endpoints.getOrganizationById.url + user.data.organizationId,
                        endpoints.getOrganizationById.method,
                        token
                    )
                    if (org.success) {
                        setOrganization(org.data)
                        updateFreeTrialStatus(org.data)
                        updatePicoEnabled(org.data)
                        updateMaiaEnabled(org.data)
                    }
                }
            }
        }
    }

    function getNavbarPageColor(navbarPath, listText) {
        if (
            history.location.pathname === navbarPath ||
            (navbarPath !== '/' && history.location.pathname.startsWith(navbarPath)) ||
            (listText === 'Roadmap' && roadmapSubpages.some((x) => history.location.pathname.startsWith(x.path))) ||
            ((listText === 'Overview' || listText === 'Dashboard') &&
                (history.location.pathname === '/' ||
                    history.location.pathname.startsWith('/metrics') ||
                    overviewSubpages.some((x) => x.path !== '/' && history.location.pathname.startsWith(x.path)))) ||
            (listText === 'Actions' && lightningActionsSubpages.map((x) => x.path).includes(history.location.pathname))
        ) {
            return isDarkMode ? '#51b3ff' : '#0049EA'
        } else if (listText === 'Roadmap' && history.location.pathname === '/gap-analysis') {
            return isDarkMode ? '#51b3ff' : '#0049EA'
        } else if (listText === 'Settings' && history.location.pathname === '/settings') {
            return isDarkMode ? '#51b3ff' : '#0049EA'
        }
        return isDarkMode ? '#FFFFFF' : '#4D4D4D'
    }

    let roadmapSubpages = [
        {
            listIcon: <SvgIcon component={ProductIcon} alt="TPP icon" fontSize="small" inheritViewBox />,
            listText: tppDisplayName,
            path: '/tpp',
        },
        {
            listIcon: (
                <SvgIcon component={StrategicIcon} alt="strategic imperatives icon" fontSize="small" inheritViewBox />
            ),
            listText: strategicDisplayName,
            path: '/strategic-imperatives',
        },
        {
            listIcon: <SvgIcon component={VMIcon} alt="value message icon" fontSize="small" inheritViewBox />,
            listText: `${valueNarrativeDisplayName.plural}`,
            path: '/narratives',
        },
        {
            listIcon: <SvgIcon component={ActivityIcon} alt="activity icon" fontSize="small" inheritViewBox />,
            listText: activitiesDisplayName,
            path: '/activities',
        },
        {
            listIcon: <SvgIcon component={EvidenceIcon} alt="evidence icon" fontSize="small" inheritViewBox />,
            listText: evidenceDisplayName,
            path: '/evidence',
        },
    ]

    const [snapshotSaved, setSnapshotSaved] = useState(false)

    let baseActionsSubpages = [
        {
            listIcon: <SvgIcon component={DownloadIcon} fontSize="small" inheritViewBox />,
            listText: 'Export Roadmap',
            action: beginCustomizingPptx,
        },
        {
            listIcon: <SvgIcon component={ViewSnapshotIcon} fontSize="small" inheritViewBox />,
            listText: 'View Snapshots',
            path: '/snapshots',
        },
        {
            listIcon: <SvgIcon component={InfoIcon} alt="info icon" fontSize="small" inheritViewBox />,
            listText: 'Help and Info',
            path: '/help',
        },
        {
            listIcon: <SvgIcon component={LogoutIcon} fontSize="small" inheritViewBox />,
            listText: 'Logout',
            action: () => {
                logEvent(ACTIONS.LOGOUT, {})
                logout({ returnTo: window.location.origin })
            },
        },
    ]

    const handleOpenSnapshot = useBooleanState()
    const hasInProgressSnapshot = useHasInProgressSnapshot()

    useEffect(() => {
        const next = []

        next.push(baseActionsSubpages.find((i) => i.listText === 'Export Roadmap'))

        if (strat?.sourceId) {
            next.push({
                listIcon: <SvgIcon component={ReplyIcon} fontSize="small" inheritViewBox />,
                listText: 'View Current',
                action: handleViewCurrentStrategy,
            })
        } else if (!userReadonly) {
            next.push({
                listIcon: <SvgIcon component={SnapshotIcon} fontSize="small" inheritViewBox />,
                listText: hasInProgressSnapshot
                    ? 'Snapshot in progress...'
                    : snapshotSaved
                      ? 'Snapshot Saved ✓'
                      : 'Save Snapshot',
                disabled: hasInProgressSnapshot,
                action: hasInProgressSnapshot ? undefined : () => handleOpenSnapshot.handleToggle(),
            })
        }

        baseActionsSubpages.filter((i) => i.listText !== 'Export Roadmap').forEach((i) => next.push(i))

        setLightningActionsSubpages(next)
    }, [snapshotSaved, userReadonly, strat?.sourceId, logout, hasInProgressSnapshot])

    let overviewSubpages = [
        {
            listIcon: <SvgIcon component={ProductIcon} fontSize="small" inheritViewBox />,
            listText: 'Product Overview',
            path: '/',
        },
        {
            listIcon: <SvgIcon component={MetricsIcon} fontSize="small" inheritViewBox />,
            listText: 'Metrics',
            path: '/metrics',
        },
    ]

    let parentMenuItems = [
        {
            listIcon: <SvgIcon component={HomeIcon} alt="home icon " fontSize="small" inheritViewBox />,
            listText: 'Home',
            path: '/roadmaps',
        },
        {
            listIcon: <SvgIcon component={OverviewIcon} alt="roadmap overview icon" fontSize="small" inheritViewBox />,
            listText: 'Dashboard',
            path: '/',
        },
        {
            listIcon: <SvgIcon component={MapIcon} alt="Roadmap icon" fontSize="small" inheritViewBox />,
            listText: 'Roadmap',
            menuSubpages: roadmapSubpages,
        },
        // {
        //     listIcon: <SvgIcon component={ResourcesIcon} alt="action icon" fontSize="small" inheritViewBox />,
        //     listText: 'Actions',
        //     menuSubpages: actionsSubpages,
        // },
    ]

    async function initMenu() {
        try {
            let token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

            // Check if store state and required properties exist
            if (!store.getState() || !store.getState().settings || !store.getState().settings.organizationId) {
                console.warn('Organization ID not found in store, menu initialization deferred')
                return
            }

            // Fetch organization data
            const response = await callSecureAPI(
                endpoints.getOrganizationById.url + store.getState().settings.organizationId,
                endpoints.getOrganizationById.method,
                token
            )

            // Verify the response and data exist
            if (!response || !response.data) {
                console.warn('Invalid response from organization API')
                return
            }

            const org = response.data

            // Safe check for Gap Analyses menu item
            if (org && (!org.hideMenuItem || !org.hideMenuItem['Gap Analyses'])) {
                roadmapSubpages.push({
                    listIcon: <SvgIcon component={GapIcon} alt="gap analyses icon" fontSize="small" inheritViewBox />,
                    listText: 'Gap Analyses',
                    path: '/gap-analysis',
                })
            }

            setIsLoaded(true)
            setMenuItems(parentMenuItems)
        } catch (error) {
            console.error('Error initializing menu:', error)
            // Fallback behavior - set basic menu items or retry
            setIsLoaded(true)
        }
    }

    useEffect(() => {
        detectSplashAndDashboard()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    useEffect(() => {
        if (forceRefresh) {
            setForceRefresh(false)
        }
        if (isAuthenticated) {
            getOrg()
            initMenu()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, storeSettings?.organizationId, isDarkMode, forceRefresh])

    useEffect(() => {
        if (!selectedStrategyId) return
        // When roadmap/strategy changes, reset localized market back to Global
        props.setLocalMarket('Global')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedStrategyId])

    const detectSplashAndDashboard = () => {
        const match = location.pathname === '/' || location.pathname === '/roadmaps'
        setShowStrategy(!match)
    }

    // Handling Nav + Drawer interactions
    const [mobileOpen, setMobileOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const [actionsAnchorEl, setActionsAnchorEl] = useState(null)
    const [selectedIndex, setSelectedIndex] = useState(null)

    const [lightningActionsSubpages, setLightningActionsSubpages] = useState([])

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen)
    }

    const handlePopoverOpen = (event, index) => {
        setActionsAnchorEl(null)
        setAnchorEl(event.currentTarget)
        setSelectedIndex(index)
    }

    const handlePopoverClose = () => {
        setAnchorEl(null)
    }
    const handleActionsMenuOpen = (event) => {
        setAnchorEl(null)
        setSelectedIndex(null)
        setActionsAnchorEl(event.currentTarget)
    }

    const handleActionsMenuClose = () => {
        setActionsAnchorEl(null)
    }

    const handleSearchClick = (event) => {
        setPopperAnchorEl(popperAnchorEl ? null : event.currentTarget)
        setPopperOpen(!popperOpen)
    }

    const handleSearchClickAway = () => {
        setPopperAnchorEl(null)
        setPopperOpen(false)
    }

    const getListItemIconStyles = (navbarPath, listText) => {
        const color = getNavbarPageColor(navbarPath, listText)
        return {
            minWidth: 30,
            color,
        }
    }

    const drawer = (
        <div>
            <Toolbar>
                <ModuleSelector />
            </Toolbar>
            <Divider />
            <List component="nav">
                {menuItems.map((page, index) => (
                    <div key={index}>
                        <ListItemButton
                            onClick={() => {
                                if (page.menuSubpages) {
                                    if (openSubMenuIndex === index) {
                                        setOpenSubMenuIndex(null) // close if clicking on the already open submenu
                                    } else {
                                        setOpenSubMenuIndex(index) // open the clicked submenu
                                    }
                                } else {
                                    page.action ? page.action() : history.push(page.path)
                                    handleDrawerToggle()
                                }
                            }}
                        >
                            <ListItemIcon sx={getListItemIconStyles(page.path, page.listText)}>
                                {page.listIcon}
                            </ListItemIcon>
                            <ListItemText>
                                <Typography color={getNavbarPageColor(page.path, page.listText)}>
                                    {page.listText}
                                </Typography>
                            </ListItemText>
                            {page.menuSubpages ? (
                                openSubMenuIndex === index ? (
                                    <ExpandLess color={getNavbarPageColor(page.path, page.listText)} />
                                ) : (
                                    <ExpandMore color={getNavbarPageColor(page.path, page.listText)} />
                                )
                            ) : null}
                        </ListItemButton>
                        <Collapse in={openSubMenuIndex === index} timeout="auto" unmountOnExit>
                            {page.menuSubpages &&
                                page.menuSubpages.map((subPage, subIndex) => (
                                    <ListItemButton
                                        dense
                                        sx={{ ml: 2 }}
                                        key={subIndex}
                                        onClick={() => {
                                            if (subPage.action) {
                                                subPage.action()
                                            } else {
                                                history.push(subPage.path, subPage.listText)
                                            }
                                            handleDrawerToggle()
                                        }}
                                    >
                                        <ListItemIcon sx={getListItemIconStyles(subPage.path, subPage.listText)}>
                                            {subPage.listIcon}
                                        </ListItemIcon>
                                        <ListItemText>
                                            <Typography color={getNavbarPageColor(subPage.path, subPage.listText)}>
                                                {subPage.listText}
                                            </Typography>
                                        </ListItemText>
                                    </ListItemButton>
                                ))}
                        </Collapse>
                    </div>
                ))}
            </List>
            <Divider />
        </div>
    )

    function flattenMarkets() {
        let keyMarkets = []
        for (let phase of strat.keyMarkets) {
            keyMarkets = keyMarkets.concat(phase.phaseKeyMarkets)
        }
        return keyMarkets
    }

    const menuListStyles = useMenuListStyles()

    return (
        <Fade in={isLoaded} timeout={800}>
            <Grid
                container
                wrap="nowrap"
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '0 45vh',
                    justifyContent: 'space-between',
                    position: 'relative',
                }}
                direction="column"
            >
                {!isPicoPage && (
                    <Grid container item>
                        <ElevationScroll {...props}>
                            <AppBar position="static" color="inherit" enableColorOnDark>
                                <Toolbar>
                                    <Grid container alignItems="center" justifyContent="space-between" wrap="nowrap">
                                        <Grid item sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
                                            <IconButton
                                                aria-label="menu"
                                                onClick={handleDrawerToggle}
                                                color="inherit"
                                                edge="start"
                                            >
                                                <MenuIcon />
                                            </IconButton>
                                        </Grid>
                                        <Grid
                                            item
                                            sx={{ display: { xs: 'none', md: 'flex' }, mr: 2 }}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            {organization.platformName === 'SPOT' && (
                                                <SvgIcon
                                                    component={SpotIcon}
                                                    inheritViewBox
                                                    sx={{
                                                        height: '100%',
                                                        width: '95px',
                                                    }}
                                                />
                                            )}

                                            <ModuleSelector />

                                            <Link component={RouterLink} color="secondary" to="/" underline="none" />
                                        </Grid>

                                        <Grid container item alignItems="center" wrap="nowrap">
                                            {menuItems &&
                                                menuItems.map((page, index) => (
                                                    <Grid item sx={{ display: { xs: 'none', md: 'flex' } }} key={index}>
                                                        <ListItemButton
                                                            aria-controls={open ? `simple-menu-${index}` : undefined}
                                                            aria-haspopup="true"
                                                            aria-expanded={open ? 'true' : undefined}
                                                            onClick={(event) => {
                                                                if (page.menuSubpages) {
                                                                    handlePopoverOpen(event, index)
                                                                } else if (page.action) {
                                                                    page.action()
                                                                } else if (page.path) {
                                                                    history.push(page.path)
                                                                }
                                                            }}
                                                            style={{
                                                                color: getNavbarPageColor(page.path, page.listText),
                                                            }}
                                                        >
                                                            <ListItemIcon
                                                                sx={getListItemIconStyles(page.path, page.listText)}
                                                            >
                                                                {page.listIcon}
                                                            </ListItemIcon>
                                                            <ListItemText>
                                                                <Typography
                                                                    variant="menu1"
                                                                    color={getNavbarPageColor(page.path, page.listText)}
                                                                >
                                                                    {page.listText}
                                                                </Typography>
                                                            </ListItemText>
                                                            {page.menuSubpages && (
                                                                <KeyboardArrowDownIcon
                                                                    style={{
                                                                        color: getNavbarPageColor(
                                                                            page.path,
                                                                            page.listText
                                                                        ),
                                                                    }}
                                                                />
                                                            )}
                                                        </ListItemButton>
                                                        <Menu
                                                            id={`simple-menu-${index}`}
                                                            anchorEl={anchorEl}
                                                            keepMounted
                                                            open={Boolean(anchorEl) && selectedIndex === index}
                                                            onClose={handlePopoverClose}
                                                            classes={{
                                                                paper: menuListStyles.paper,
                                                                list: menuListStyles.list,
                                                            }}
                                                        >
                                                            <MenuList
                                                                classes={{
                                                                    root: menuListStyles.root,
                                                                }}
                                                            >
                                                                {page.menuSubpages &&
                                                                    page.menuSubpages.map((subPage, subIndex) => (
                                                                        <ListItemButton
                                                                            key={subIndex}
                                                                            onClick={() => {
                                                                                if (subPage.action) {
                                                                                    subPage.action()
                                                                                } else {
                                                                                    history.push(
                                                                                        subPage.path,
                                                                                        subPage.listText
                                                                                    )
                                                                                }
                                                                                handlePopoverClose()
                                                                            }}
                                                                            sx={{
                                                                                padding: '4px 16px !important',
                                                                            }}
                                                                        >
                                                                            <ListItemIcon
                                                                                sx={getListItemIconStyles(
                                                                                    subPage.path,
                                                                                    subPage.listText
                                                                                )}
                                                                            >
                                                                                {subPage.listIcon}
                                                                            </ListItemIcon>
                                                                            <ListItemText>
                                                                                <Typography
                                                                                    variant="menu2"
                                                                                    color={getNavbarPageColor(
                                                                                        subPage.path,
                                                                                        subPage.listText
                                                                                    )}
                                                                                    sx={{ margin: 0 }}
                                                                                >
                                                                                    {subPage.listText}
                                                                                </Typography>
                                                                            </ListItemText>
                                                                        </ListItemButton>
                                                                    ))}
                                                            </MenuList>
                                                        </Menu>
                                                    </Grid>
                                                ))}
                                        </Grid>
                                        <Grid
                                            container
                                            item
                                            alignItems="center"
                                            xs="auto"
                                            columnGap={1.25}
                                            sx={{
                                                '.MuiGrid-item a': {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: 1,
                                                },
                                            }}
                                        >
                                            {/* Only where a roadmap means something: /roadmaps is the
                                            picker itself, and settings are org-wide. */}
                                            {history.location.pathname !== '/roadmaps' &&
                                                !history.location.pathname.startsWith('/settings') && (
                                                    <Grid
                                                        item
                                                        sx={{
                                                            display: { xs: 'none', md: 'flex' },
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        <RoadmapSelector />
                                                    </Grid>
                                                )}
                                            <Grid item sx={{ ml: 2 }}>
                                                <a href="javascript:void(0)" style={{ color: 'inherit' }}>
                                                    <Tooltip title="Search" enterDelay={600} enterNextDelay={600} arrow>
                                                        <SvgIcon
                                                            component={SearchIcon}
                                                            aria-describedby={'searchId'}
                                                            onClick={handleSearchClick}
                                                            fontSize="medium"
                                                            inheritViewBox
                                                        />
                                                    </Tooltip>
                                                </a>
                                            </Grid>
                                            <Popper
                                                id={'searchId'}
                                                open={popperOpen}
                                                anchorEl={popperAnchorEl}
                                                placement="bottom-end"
                                            >
                                                <ClickAwayListener onClickAway={() => handleSearchClickAway()}>
                                                    <div>
                                                        <SearchBar
                                                            openTextField={popperOpen}
                                                            manualClickAway={handleSearchClickAway}
                                                        />
                                                    </div>
                                                </ClickAwayListener>
                                            </Popper>
                                            {/* <Grid item>
                                                <a href="javascript:void(0)" style={{ color: 'inherit' }}>
                                                    <Tooltip enterDelay={600} enterNextDelay={600} title="Logout" arrow>
                                                        <SvgIcon
                                                            component={LogoutIcon}
                                                            onClick={() => {
                                                                // props.userLogout()
                                                                logEvent(ACTIONS.LOGOUT, {})
                                                                logout({ returnTo: window.location.origin })
                                                            }}
                                                            fontSize="medium"
                                                            inheritViewBox
                                                        />
                                                    </Tooltip>
                                                </a>
                                            </Grid> */}
                                            {storeSettings && storeSettings?.enableLocalizedMarkets && (
                                                <Grid item sx={{ display: { xs: 'none', md: 'flex', lg: 'flex' } }}>
                                                    <FormControl>
                                                        <Select
                                                            disableUnderline
                                                            variant="standard"
                                                            value={selectedMarket}
                                                            onChange={(e) => props.setLocalMarket(e.target.value)}
                                                            IconComponent={KeyboardArrowDownIcon}
                                                            MenuProps={{
                                                                classes: {
                                                                    paper: menuListStyles.paper,
                                                                    list: menuListStyles.list,
                                                                },
                                                            }}
                                                            sx={{
                                                                '.MuiSelect-select': {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    pl: 1,
                                                                },
                                                                '.MuiSelect-icon': {
                                                                    color: 'text.primary',
                                                                    fontSize: '1.25rem',
                                                                },
                                                            }}
                                                            renderValue={() => {
                                                                return (
                                                                    <Tooltip
                                                                        title="Market"
                                                                        enterDelay={600}
                                                                        enterNextDelay={600}
                                                                        arrow
                                                                    >
                                                                        {selectedMarket === 'Global' ? (
                                                                            <SvgIcon
                                                                                component={GlobalIcon}
                                                                                fontSize="medium"
                                                                                inheritViewBox
                                                                            />
                                                                        ) : (
                                                                            <>
                                                                                <PulsingCircle duration={7500} />
                                                                                <ReactCountryFlag
                                                                                    countryCode={selectedMarket?.toLowerCase()}
                                                                                    svg
                                                                                    cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                                                                                    cdnSuffix="svg"
                                                                                    style={{
                                                                                        verticalAlign: 'unset',
                                                                                        height: '22.5px',
                                                                                        width: '22.5px',
                                                                                    }}
                                                                                    title={
                                                                                        countryLookup[selectedMarket]
                                                                                    }
                                                                                    className="countryFlag"
                                                                                />
                                                                            </>
                                                                        )}
                                                                    </Tooltip>
                                                                )
                                                            }}
                                                        >
                                                            <MenuItem value="Global">
                                                                <ListItemIcon
                                                                    sx={{
                                                                        minWidth: 'auto !important',
                                                                        mr: 1,
                                                                        color: 'inherit',
                                                                    }}
                                                                >
                                                                    <SvgIcon
                                                                        component={GlobalIcon}
                                                                        fontSize="small"
                                                                        inheritViewBox
                                                                    />
                                                                </ListItemIcon>
                                                                <ListItemText>Global</ListItemText>
                                                            </MenuItem>
                                                            {strat &&
                                                                flattenMarkets().map((e, i) => {
                                                                    return (
                                                                        <MenuItem value={e.code} key={i}>
                                                                            <ReactCountryFlag
                                                                                countryCode={e.code?.toLowerCase()}
                                                                                svg
                                                                                style={{ marginRight: '8px' }}
                                                                            />
                                                                            {e.label}
                                                                        </MenuItem>
                                                                    )
                                                                })}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            )}
                                            <Grid item sx={{ display: { xs: 'none', md: 'flex', lg: 'flex' } }}>
                                                <Tooltip title="Actions" arrow>
                                                    <IconButton
                                                        onClick={handleActionsMenuOpen}
                                                        size="medium"
                                                        disableRipple
                                                        disableFocusRipple
                                                        sx={{
                                                            borderRadius: '999px',
                                                            padding: 0,
                                                            outline: 'none',
                                                            boxShadow: 'none',
                                                            color: isDarkMode ? '#FFFFFF' : 'inherit',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: 0,

                                                            '&:hover': {
                                                                backgroundColor: isDarkMode
                                                                    ? 'rgba(255,255,255,0.08)'
                                                                    : 'rgba(0,0,0,0.04)',
                                                            },
                                                        }}
                                                    >
                                                        <SvgIcon
                                                            component={LightningIcon}
                                                            inheritViewBox
                                                            fontSize="medium"
                                                            sx={{ color: isDarkMode ? '#FFFFFF' : 'inherit' }}
                                                        />
                                                        <KeyboardArrowDownIcon
                                                            fontSize="small"
                                                            sx={{ color: 'inherit' }}
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                                <Menu
                                                    id="actions-lightning-menu"
                                                    anchorEl={actionsAnchorEl}
                                                    keepMounted
                                                    open={Boolean(actionsAnchorEl)}
                                                    onClose={handleActionsMenuClose}
                                                    classes={{
                                                        paper: menuListStyles.paper,
                                                        list: menuListStyles.list,
                                                    }}
                                                >
                                                    <MenuList
                                                        classes={{
                                                            root: menuListStyles.root,
                                                        }}
                                                    >
                                                        {lightningActionsSubpages.map((subPage, index) => (
                                                            <ListItemButton
                                                                key={index}
                                                                disabled={!!subPage.disabled}
                                                                onClick={() => {
                                                                    if (subPage.action) {
                                                                        subPage.action()
                                                                    } else if (subPage.path) {
                                                                        history.push(subPage.path, subPage.listText)
                                                                    }
                                                                    handleActionsMenuClose()
                                                                }}
                                                                sx={{
                                                                    padding: '4px 16px !important',
                                                                }}
                                                            >
                                                                <ListItemIcon
                                                                    sx={getListItemIconStyles(
                                                                        subPage.path,
                                                                        subPage.listText
                                                                    )}
                                                                >
                                                                    {subPage.listIcon}
                                                                </ListItemIcon>
                                                                <ListItemText>
                                                                    <Typography
                                                                        variant="menu2"
                                                                        color={getNavbarPageColor(
                                                                            subPage.path,
                                                                            subPage.listText
                                                                        )}
                                                                        sx={{ margin: 0 }}
                                                                    >
                                                                        {subPage.listText}
                                                                    </Typography>
                                                                </ListItemText>
                                                            </ListItemButton>
                                                        ))}
                                                    </MenuList>
                                                </Menu>
                                            </Grid>
                                            {store.getState().strategy &&
                                            !store.getState().strategy.sourceId &&
                                            store.getState().userRecord &&
                                            !userReadonly ? (
                                                <Grid item>
                                                    <a href="javascript:void(0)" style={{ color: 'inherit' }}>
                                                        <Tooltip
                                                            title="Settings"
                                                            enterDelay={600}
                                                            enterNextDelay={600}
                                                            arrow
                                                        >
                                                            <SvgIcon
                                                                component={SettingsIcon}
                                                                onClick={() => {
                                                                    history.push('/settings')
                                                                }}
                                                                color={
                                                                    history.location.pathname === '/settings'
                                                                        ? 'primary'
                                                                        : ''
                                                                }
                                                                fontSize="medium"
                                                                inheritViewBox
                                                            />
                                                        </Tooltip>
                                                    </a>
                                                </Grid>
                                            ) : null}
                                            {!_.isEmpty(organization) && (
                                                <Grid
                                                    item
                                                    sx={{ ml: 2, display: { xs: 'flex', md: 'none', lg: 'flex' } }}
                                                >
                                                    {currentUser?.isAdmin ? (
                                                        <OrganizationSelector
                                                            organization={organization}
                                                            isDarkMode={isDarkMode}
                                                            isAdmin={currentUser?.isAdmin}
                                                        />
                                                    ) : (
                                                        <img
                                                            alt={organization.name + ' Logo'}
                                                            src={
                                                                isDarkMode
                                                                    ? organization.image
                                                                    : organization.lightModeImage
                                                            }
                                                            className="orgLogo"
                                                        />
                                                    )}
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Toolbar>
                                <NavbarInfoBanner />
                            </AppBar>
                        </ElevationScroll>
                        <Box component="nav" sx={{ flexShrink: { sm: 0 } }}>
                            <Drawer
                                variant="temporary"
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                }}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                    '& .MuiDrawer-paper': {
                                        boxSizing: 'border-box',
                                        width: DRAWER_WIDTH,
                                    },
                                }}
                            >
                                {drawer}
                            </Drawer>
                            <Drawer
                                variant="permanent"
                                sx={{
                                    display: { xs: 'none' },
                                    '& .MuiDrawer-paper': {
                                        boxSizing: 'border-box',
                                        width: DRAWER_WIDTH,
                                    },
                                }}
                                open
                            >
                                {drawer}
                            </Drawer>
                        </Box>
                    </Grid>
                )}
                <Grid
                    container
                    item
                    direction="column"
                    wrap="nowrap"
                    justifyContent="space-between"
                    component="main"
                    flex={1}
                >
                    {props.children}
                    {!_.isEmpty(organization) && !isPicoPage && (
                        <Box
                            p={1}
                            sx={{
                                backgroundColor: isDarkMode ? 'rgba(0,0,0,.2)' : 'rgba(255,255,255,.2)',
                            }}
                        >
                            <footer>
                                <Typography variant="subtitle5">{organization.confidentialityFooter}</Typography>
                            </footer>
                        </Box>
                    )}
                </Grid>
                {handleOpenSnapshot.state && (
                    <SnapshotModal toggleOpen={handleOpenSnapshot.handleToggle} toggle={handleOpenSnapshot.state} />
                )}

                <Dialog
                    open={openModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setOpenModal(false)}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">{'Unable to export slide deck'}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">{errorModalText}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenModal(false)}>OK</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openPptxCustomizationModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => setOpenPptxCustomizationModal(false)}
                    aria-labelledby="alert-dialog-slide-title1"
                    aria-describedby="alert-dialog-slide-description1"
                >
                    <DialogTitle id="alert-dialog-slide-title1">
                        <Typography variant="h3">Customize Roadmap Export</Typography>
                    </DialogTitle>
                    <DialogContent>
                        <List>
                            <p
                                style={{
                                    fontWeight: 700,
                                    textAlign: 'center',
                                    marginTop: 12,
                                    marginBottom: 6,
                                }}
                            >
                                PowerPoint Exports
                            </p>

                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={`Fulfillment: ${vmsDisplayName}`} />
                                <ListItemSecondaryAction>
                                    {isFulfillmentVMExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="download"
                                            onClick={() => {
                                                exportPPTX(`Fulfillment: ${vmsDisplayName}`)
                                                setIsFulfillmentVMExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={`Fulfillment: ${tppDisplayName}`} />
                                <ListItemSecondaryAction>
                                    {isFulfillmentTPPExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="download"
                                            onClick={() => {
                                                exportPPTX(`Fulfillment: ${tppDisplayName}`)
                                                setIsFulfillmentTPPExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={vmsDisplayName + ' + Evidence Statements + Citations'} />
                                <ListItemSecondaryAction>
                                    {isValueNarrativeExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(vnsDisplayName)
                                                setIsValueNarrativeExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={tppDisplayName} />
                                <ListItemSecondaryAction>
                                    {isTrPPExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(tppDisplayName)
                                                setIsTrPPExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={vmsDisplayName} />
                                <ListItemSecondaryAction>
                                    {vmExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(vmsDisplayName)
                                                setVMExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={vmsDisplayName + ' + ' + evidenceDisplayName + ' + Citations'} />
                                <ListItemSecondaryAction>
                                    {vmAndEvidenceExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(vmsDisplayName + ' + ' + evidenceDisplayName)
                                                setVMAndEvidenceExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={evidenceDisplayName + ' + Evidence Statements + Citations'} />
                                <ListItemSecondaryAction>
                                    {isKeyEvidenceExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX('Key Evidence Statements')
                                                setIsKeyEvidenceExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={evidenceDisplayName + ' + Citations'} />
                                <ListItemSecondaryAction>
                                    {evidenceExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(evidenceDisplayName)
                                                setEvidenceExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={vmsDisplayName + ' + ' + activitiesDisplayName + ' (with Gantt chart)'}
                                />
                                <ListItemSecondaryAction>
                                    {vmAndActExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(vmsDisplayName + ' + ' + activitiesDisplayName)
                                                setVMAndActExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={activitiesDisplayName + ' (with Gantt chart)'} />
                                <ListItemSecondaryAction>
                                    {actExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(activitiesDisplayName)
                                                setActExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={strategicDisplayName + ' + ' + activitiesDisplayName} />
                                <ListItemSecondaryAction>
                                    {EGPExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(strategicDisplayName + ' + ' + activitiesDisplayName)
                                                setEGPExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={vmsDisplayName + ' + Status + Gaps'} />
                                <ListItemSecondaryAction>
                                    {vmsStatusGapsExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(vmsDisplayName + ' + Status + Gaps')
                                                setVMsStatusGapsExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={vmsDisplayName + ' + Gaps'} />
                                <ListItemSecondaryAction>
                                    {vmsGapsExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(vmsDisplayName + ' + Gaps')
                                                setVMsGapsExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={'Aspirational ' + vmsDisplayName + ' + ' + activitiesDisplayName}
                                />
                                <ListItemSecondaryAction>
                                    {isAspirationalExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                                exportPPTX(
                                                    'Aspirational ' + vmsDisplayName + ' + ' + activitiesDisplayName
                                                )
                                                setIsAspirationalExporting(true)
                                            }}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>

                            <p>Optional Slides:</p>
                            <Grid container>
                                <FormControlLabel
                                    control={
                                        <WhiteOutlineCheckbox
                                            checked={includesValueProp}
                                            onChange={() => setIncludesValueProp(!includesValueProp)}
                                            name={valuePropositionDisplayName.singular}
                                        />
                                    }
                                    label={valuePropositionDisplayName.singular}
                                />
                            </Grid>

                            <p
                                style={{
                                    fontWeight: 700,
                                    textAlign: 'center',
                                    marginTop: 12,
                                    marginBottom: 6,
                                }}
                            >
                                Excel Exports
                            </p>

                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={`${activitiesDisplayName} Tracker`} />
                                <ListItemSecondaryAction>
                                    {activitiesExcelExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="download"
                                            onClick={handleActivitiesTrackerExcelExport}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>

                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={'Dissemination & Prioritization'} />
                                <ListItemSecondaryAction>
                                    {disseminationPrioritizationExcelExporting ? (
                                        <CircularProgress size={20} />
                                    ) : (
                                        <IconButton
                                            edge="end"
                                            aria-label="download"
                                            onClick={handleDisseminationPrioritizationExcelExport}
                                        >
                                            <GetAppIcon color={'primary'} />
                                        </IconButton>
                                    )}
                                </ListItemSecondaryAction>
                            </ListItem>

                            <>
                                <p
                                    style={{
                                        fontWeight: 700,
                                        textAlign: 'center',
                                        marginTop: 12,
                                        marginBottom: 6,
                                    }}
                                >
                                    JSON Exports
                                </p>

                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar>
                                            <DescriptionIcon />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={tppDisplayName} />
                                    <ListItemSecondaryAction>
                                        {trppJsonExporting ? (
                                            <CircularProgress size={20} />
                                        ) : (
                                            <IconButton edge="end" aria-label="download" onClick={handleTrppJsonExport}>
                                                <GetAppIcon color={'primary'} />
                                            </IconButton>
                                        )}
                                    </ListItemSecondaryAction>
                                </ListItem>

                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar>
                                            <DescriptionIcon />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={vnsDisplayName} />
                                    <ListItemSecondaryAction>
                                        {valueNarrativesJsonExporting ? (
                                            <CircularProgress size={20} />
                                        ) : (
                                            <IconButton
                                                edge="end"
                                                aria-label="download"
                                                onClick={handleValueNarrativesFullJsonExport}
                                            >
                                                <GetAppIcon color={'primary'} />
                                            </IconButton>
                                        )}
                                    </ListItemSecondaryAction>
                                </ListItem>

                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar>
                                            <DescriptionIcon />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={evidenceDisplayName} />
                                    <ListItemSecondaryAction>
                                        {evidenceJsonExporting ? (
                                            <CircularProgress size={20} />
                                        ) : (
                                            <IconButton
                                                edge="end"
                                                aria-label="download"
                                                onClick={handleEvidenceJsonExport}
                                            >
                                                <GetAppIcon color={'primary'} />
                                            </IconButton>
                                        )}
                                    </ListItemSecondaryAction>
                                </ListItem>

                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar>
                                            <DescriptionIcon />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={activitiesDisplayName} />
                                    <ListItemSecondaryAction>
                                        {activitiesJsonExporting ? (
                                            <CircularProgress size={20} />
                                        ) : (
                                            <IconButton
                                                edge="end"
                                                aria-label="download"
                                                onClick={handleActivitiesJsonExport}
                                            >
                                                <GetAppIcon color={'primary'} />
                                            </IconButton>
                                        )}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            </>
                        </List>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setOpenPptxCustomizationModal(false)
                                setIncludesValueProp(false)
                            }}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </Fade>
    )
}

const Layout = connect(null, mapDispatchToProps)(ConnectedLayout)

export default withRouter(Layout)
